import { Images as sharedImages } from "./shared-images";
import { aboutAssets } from "./modules/about";
import { cakephpAssets } from "./modules/cakephp";
import { careerAssets } from "./modules/career";
import { cmsAssets } from "./modules/cms";
import { codeigniterAssets } from "./modules/codeigniter";
import { contactPartnersAssets } from "./modules/contact-partners";
import { datingAssets } from "./modules/dating";
import { directoryAssets } from "./modules/directory";
import { djangoAssets } from "./modules/django";
import { ecommerceAssets } from "./modules/ecommerce-cms";
import { frameworkAssets } from "./modules/frameworks";
import { industryAssets } from "./modules/industries";
import { javaAssets } from "./modules/java";
import { marketingAssets } from "./modules/marketing";
import { nodeAssets } from "./modules/node";
import { onDemandAssets } from "./modules/on-demand";
import { openSourceAssets } from "./modules/open-source";
import { partnershipAssets } from "./modules/partnership";
import { pythonAssets } from "./modules/python";
import { stackAssets } from "./modules/stacks";
import { swiftAssets } from "./modules/swift";
import { telemedicineAssets } from "./modules/telemedicine";
import { threejsAssets } from "./modules/threejs";
import fourzerofour from "../images/fourzerofour.svg";
import Restaurant_Finde_Booking_App from "../images/restaurant_page/solutions/restaurant-finder-booking-app.webp";
import Restaurant_Discount_Rewards_App_Development from "../images/restaurant_page/solutions/restaurant-discount-rewards-app-development.webp";
import Customer_Food_Delivery_App from "../images/restaurant_page/solutions/food-delivery-app-development.webp";
import Online_Food_Ordering_App from "../images/restaurant_page/solutions/online-food-ordering-app-development.webp";
import Waiting_Management_App from "../images/restaurant_page/solutions/waiter-management-app-development.webp";
import Restaurant_Web_Portal_Development from "../images/restaurant_page/solutions/restaurant-web-portal-development.webp";
import Table_Reservation_App from "../images/restaurant_page/solutions/table-reservation-app-development.webp";
import mobileBannerImage from "../images/mobile-development.webp";
import mobileBannerMobImage from "../images/mobile-development-mobile.webp";
import contactBg from "../images/Contact-us.webp";
import ourClientsBg from "../images/our-clients-bg.webp";
import partnerBg from "../images/awards-members-bg.webp";
import ourTeamBg from "../images/our-team-bg.webp";
import pressReleaseBg from "../images/press-release-bg.webp";
import testimonialBg from "../images/testimonial-bg.webp";
import becomePartnerBg from "../images/become-a-partner-bg.webp";

import artificialIntelligenceFrontend from "../images/frontend-dev/artificial-intelligence.webp";
import arVrFrontend from "../images/frontend-dev/ar-vr.webp";
import emergeBlockChainFrontend from "../images/frontend-dev/blockchain.webp";
import cloudComputingFrontend from "../images/frontend-dev/cloud-computing.webp";
import dataAnalytics from "../images/frontend-dev/data-analytics.webp";
import internetOfThings from "../images/frontend-dev/internet-of-things.webp";

import requirementsGathering from "../images/frontend-dev/requirements-gathering.webp";
import wireframing from "../images/frontend-dev/wireframing.webp";
import design from "../images/frontend-dev/design.webp";
import development from "../images/frontend-dev/development.webp";
import testing from "../images/frontend-dev/testing.webp";
import deploymentAndMaintenance from "../images/frontend-dev/deployment-and-maintenance.webp";

import arVrImage from "../images/backend_dev/emerging/ar-vr.webp";
import artificialIntelligenceImage from "../images/backend_dev/emerging/artificial-intelligence.webp";
import blockchainImage from "../images/backend_dev/emerging/blockchain.webp";
import cloudComputingImage from "../images/backend_dev/emerging/cloud-computing.webp";
import dataAnalyticsImage from "../images/backend_dev/emerging/data-analytics.webp";
import internetOfThingsImage from "../images/backend_dev/emerging/internet-of-things.webp";

import designProcessImage from "../images/backend_dev/process/design.webp";
import developmentProcessImage from "../images/backend_dev/process/development.webp";
import initialConsultationProcessImage from "../images/backend_dev/process/initial-consultation.webp";
import maintenanceAndSupportProcessImage from "../images/backend_dev/process/maintenance-and-support.webp";
import qualityAssuranceProcessImage from "../images/backend_dev/process/quality-assurance.webp";
import releaseDeploymentProcessImage from "../images/backend_dev/process/release-deployment.webp";

import aiMlImageStrip from "../images/stripe_images/emerging/ai-ml.webp";
import arVrImageStrip from "../images/stripe_images/emerging/ar-vr.webp";
import blockchainImageStrip from "../images/stripe_images/emerging/blockchain.webp";
import cloudComputingImageStrip from "../images/stripe_images/emerging/cloud-computing.webp";
import dataAnalyticsImageStrip from "../images/stripe_images/emerging/data-analytics.webp";
import internetOfThingsImageStrip from "../images/stripe_images/emerging/internet-of-things.webp";

import deploymentProcessImage from "../images/stripe_images/process/deployment.webp";
import designingProcessImage from "../images/stripe_images/process/designing.webp";
import integrationProcessImage from "../images/stripe_images/process/integration.webp";
import requirementAnalysisProcessImage from "../images/stripe_images/process/requirement-analysis.webp";
import supportMaintenanceProcessImage from "../images/stripe_images/process/support-maintenance.webp";
import testingProcessImage from "../images/stripe_images/process/testing.webp";

import arVrImageSaas from "../images/saas_image/emerging/ar-vr.webp";
import artificialIntelligenceImageSaas from "../images/saas_image/emerging/artificial-intelligence.webp";
import blockchainImageSaas from "../images/saas_image/emerging/blockchain.webp";
import cloudComputingImageSaas from "../images/saas_image/emerging/cloud-computing.webp";
import dataAnalyticsImageSaas from "../images/saas_image/emerging/data-analytics.webp";
import iotImageSaas from "../images/saas_image/emerging/iot.webp";

import deploymentProcessImageSaas from "../images/saas_image/process/deployment.webp";
import developmentProcessImageSaas from "../images/saas_image/process/development.webp";
import maintenanceProcessImage from "../images/saas_image/process/maintenance.webp";
import planningProcessImageSaas from "../images/saas_image/process/planning.webp";
import testingProcessImageSaas from "../images/saas_image/process/testing.webp";
import uiUxDesignProcessImageSaas from "../images/saas_image/process/ui-ux-design.webp";

import reconstruction3dImageMetaVerse from "../images/metaverse_images/emerging/3d-reconstruction.webp";
import artificialIntelligenceImageMetaVerse from "../images/metaverse_images/emerging/artificial-intelligence.webp";
import blockchainImageMetaVerse from "../images/metaverse_images/emerging/blockchain.webp";
import edgeComputingImageMetaVerse from "../images/metaverse_images/emerging/edge-computing.webp";
import extendedRealityImageMetaVerse from "../images/metaverse_images/emerging/extended-reality.webp";
import internetOfThingsImageMetaVerse from "../images/metaverse_images/emerging/internet-of-things.webp";

import blockchainIntegrationProcessImageMetaVerse from "../images/metaverse_images/process/blockchain-integration.webp";
import conceptualizationProcessImageMetaVerse from "../images/metaverse_images/process/conceptualization.webp";
import deploymentSupportProcessImageMetaVerse from "../images/metaverse_images/process/deployment-support.webp";
import developmentProcessImageMetaVerse from "../images/metaverse_images/process/development.webp";
import requirementAnalysisProcessImageMetaVerse from "../images/metaverse_images/process/requirement-analysis.webp";
import testingProcessImageMetaVerse from "../images/metaverse_images/process/testing.webp";

import aiAgentDevelopmentImage from "../images/ai_power_bus_images/emerging/ai-agent-development.webp";
import aiChatbotDevelopmentImage from "../images/ai_power_bus_images/emerging/ai-chatbot-development.webp";
import aiModelDevelopmentImage from "../images/ai_power_bus_images/emerging/ai-model-development.webp";
import aiPocDevelopmentImage from "../images/ai_power_bus_images/emerging/ai-poc-development.webp";
import aiProductDevelopmentImage from "../images/ai_power_bus_images/emerging/ai-product-development.webp";
import imageBasedAiSolutionsImage from "../images/ai_power_bus_images/emerging/image-based-ai-solutions.webp";

import businessAssessmentProcessImage from "../images/ai_power_bus_images/process/business-assessment.webp";
import changeManagementProcessImage from "../images/ai_power_bus_images/process/change-management.webp";
import developmentProcessImageAiPowered from "../images/ai_power_bus_images/process/development.webp";
import maintenanceAndSupportProcessImageAiPowered from "../images/ai_power_bus_images/process/maintenance-and-support.webp";
import solutionDesignProcessImage from "../images/ai_power_bus_images/process/solution-design.webp";
import strategicRoadmapProcessImage from "../images/ai_power_bus_images/process/strategic-roadmap.webp";

import agenticAiImage from "../images/ai_integration_images/emerging/agentic-ai.webp";
import computerVisionImage from "../images/ai_integration_images/emerging/computer-vision.webp";
import iotImage from "../images/ai_integration_images/emerging/iot.webp";
import largeLanguageModelsImage from "../images/ai_integration_images/emerging/large-language-models.webp";
import naturalLanguageProcessingImage from "../images/ai_integration_images/emerging/natural-language-processing.webp";
import predictiveAnalyticsImage from "../images/ai_integration_images/emerging/predictive-analytics.webp";

import dataIntegrationProcessImage from "../images/ai_integration_images/process/data-integration.webp";
import fineTuningProcessImage from "../images/ai_integration_images/process/fine-tuning.webp";
import modelSelectionProcessImage from "../images/ai_integration_images/process/model-selection.webp";
import requirementGatheringProcessImage from "../images/ai_integration_images/process/requirement-gathering.webp";
import testingAndEvaluationProcessImage from "../images/ai_integration_images/process/testing-and-evaluation.webp";
import workflowIntegrationProcessImage from "../images/ai_integration_images/process/workflow-integration.webp";

import agenticAiImageAIConsulting from "../images/ai_consulting_images/emerging/agentic-ai.webp";
import computerVisionImageAIConsulting from "../images/ai_consulting_images/emerging/computer-vision.webp";
import iotImageAIConsulting from "../images/ai_consulting_images/emerging/iot.webp";
import largeLanguageModelsImageAIConsulting from "../images/ai_consulting_images/emerging/large-language-models.webp";
import naturalLanguageProcessingImageAIConsulting from "../images/ai_consulting_images/emerging/natural-language-processing.webp";
import predictiveAnalyticsImageAIConsulting from "../images/ai_consulting_images/emerging/predictive-analytics.webp";

import aiReadinessProcessImage from "../images/ai_consulting_images/process/ai-readiness.webp";
import continuousMonitoringProcessImage from "../images/ai_consulting_images/process/continuous-monitoring.webp";
import deploymentProcessImageAIConsulting from "../images/ai_consulting_images/process/deployment.webp";
import opportunityMappingProcessImage from "../images/ai_consulting_images/process/opportunity-mapping.webp";
import rapidMvpProcessImage from "../images/ai_consulting_images/process/rapid-mvp.webp";
import solutionsDesignProcessImage from "../images/ai_consulting_images/process/solutions-design.webp";

// Emerging Technologies
import codexImage from "../images/generative_ai_images/emerging/codex.webp";
import dallE3Image from "../images/generative_ai_images/emerging/dall-e-3.webp";
import gpt4Image from "../images/generative_ai_images/emerging/gpt-4.webp";
import soraImage from "../images/generative_ai_images/emerging/sora.webp";
import stableDiffusionImage from "../images/generative_ai_images/emerging/stable-diffusion.webp";
import whisperImage from "../images/generative_ai_images/emerging/whisper.webp";

// Process
import dataCollectionImage from "../images/generative_ai_images/process/data-collection.webp";
import deploymentImage from "../images/generative_ai_images/process/deployment.webp";
import designCustomizationImage from "../images/generative_ai_images/process/design-customization.webp";
import needsAnalysisImage from "../images/generative_ai_images/process/needs-analysis.webp";
import supportAndMaintenanceImage from "../images/generative_ai_images/process/support-and-maintenance.webp";
import trainingImage from "../images/generative_ai_images/process/training.webp";

// Emerging Technologies
import modeling3dImage from "../images/vr_development_images/emerging/3d-modeling.webp";
import aiMlImage from "../images/vr_development_images/emerging/ai-ml.webp";
import eyeTrackingImage from "../images/vr_development_images/emerging/eye-tracking.webp";
import gestureRecognitionImage from "../images/vr_development_images/emerging/gesture-recognition.webp";
import hapticFeedbackSystemsImage from "../images/vr_development_images/emerging/haptic-feedback-systems.webp";
import spatialAudioProcessingImage from "../images/vr_development_images/emerging/spatial-audio-processing.webp";

// Process
import definingRequirementsImage from "../images/vr_development_images/process/defining-the-requirements.webp";
import deploymentAndMaintenanceImage from "../images/vr_development_images/process/deployment-and-maintenance.webp";
import designingImage from "../images/vr_development_images/process/designing.webp";
import developmentImage from "../images/vr_development_images/process/development.webp";
import preDevelopmentPlanningImage from "../images/vr_development_images/process/pre-development-planning.webp";
import testingImage from "../images/vr_development_images/process/testing.webp";

// Emerging Technologies
import modeling3dARImage from "../images/ar-development_images/emerging/3d-modeling.webp";
import cloudTechnologyARImage from "../images/ar-development_images/emerging/cloud-technology.webp";
import computerVisionARImage from "../images/ar-development_images/emerging/computer-vision.webp";
import slamARImage from "../images/ar-development_images/emerging/slam.webp";
import spatialAudioARImage from "../images/ar-development_images/emerging/spatial-audio.webp";

// Process
import arTechnologyIntegrationARImage from "../images/ar-development_images/process/ar-technology-integration.webp";
import deploymentARImage from "../images/ar-development_images/process/deployment.webp";
import developmentARImage from "../images/ar-development_images/process/development.webp";
import planningARImage from "../images/ar-development_images/process/planning.webp";
import testingAndQaARImage from "../images/ar-development_images/process/testing-and-qa.webp";
import uiUxDesignARImage from "../images/ar-development_images/process/ui-ux-design.webp";

// Emerging
import aiChatbotsMLImage from "../images/machine_learning_images/emerging/ai-chatbots.webp";
import artificialIntelligenceMLImage from "../images/machine_learning_images/emerging/artificial-intelligence.webp";
import cloudMLImage from "../images/machine_learning_images/emerging/cloud.webp";
import computerVisionMLImage from "../images/machine_learning_images/emerging/computer-vision.webp";
import naturalLanguageProcessingMLImage from "../images/machine_learning_images/emerging/natural-language-processing.webp";
import rpaMLImage from "../images/machine_learning_images/emerging/rpa.webp";

// Process
import businessProblemIdentificationMLImage from "../images/machine_learning_images/process/business-problem-identification.webp";
import dataModelingAndEvaluationMLImage from "../images/machine_learning_images/process/data-modeling-and-evaluation.webp";
import dataPreparationMLImage from "../images/machine_learning_images/process/data-preparation.webp";
import exploratoryDataAnalysisMLImage from "../images/machine_learning_images/process/exploratory-data-analysis.webp";
import implementationMLImage from "../images/machine_learning_images/process/implementation.webp";
import monitoringAndSupportMLImage from "../images/machine_learning_images/process/monitoring-and-support.webp";

// Emerging
import arVrAIAgentImage from "../images/ai_agent_images/emerging/ar-vr.webp";
import blockchainAIAgentImage from "../images/ai_agent_images/emerging/blockchain.webp";
import cloudComputingAIAgentImage from "../images/ai_agent_images/emerging/cloud-computing.webp";
import dataAnalyticsAIAgentImage from "../images/ai_agent_images/emerging/data-analytics.webp";
import iotAIAgentImage from "../images/ai_agent_images/emerging/iot.webp";
import machineLearningAIAgentImage from "../images/ai_agent_images/emerging/machine-learning.webp";

// Process
import architectureAIAgentImage from "../images/ai_agent_images/process/architecture.webp";
import designAIAgentImage from "../images/ai_agent_images/process/design.webp";
import developmentAIAgentImage from "../images/ai_agent_images/process/development.webp";
import discoveryAIAgentImage from "../images/ai_agent_images/process/discovery.webp";
import launchAIAgentImage from "../images/ai_agent_images/process/launch.webp";
import testingAIAgentImage from "../images/ai_agent_images/process/testing.webp";

import agenticAiAIChatbotImage from "../images/ai_chatbot_images/emerging/agentic-ai.webp";
import largeLanguageModelsAIChatbotImage from "../images/ai_chatbot_images/emerging/large-language-models.webp";
import machineLearningAIChatbotImage from "../images/ai_chatbot_images/emerging/machine-learning.webp";
import naturalLanguageProcessingAIChatbotImage from "../images/ai_chatbot_images/emerging/natural-language-processing.webp";
import retrievalAugmentedGenerationAIChatbotImage from "../images/ai_chatbot_images/emerging/retrieval-augmented-generation.webp";
import voiceBasedInteractionAIChatbotImage from "../images/ai_chatbot_images/emerging/voice-based-interaction.webp";

// Process
import deploymentAIChatbotImage from "../images/ai_chatbot_images/process/deployment.webp";
import developmentAIChatbotImage from "../images/ai_chatbot_images/process/development.webp";
import discoveryPhaseAIChatbotImage from "../images/ai_chatbot_images/process/discovery-phase.webp";
import maintenanceAIChatbotImage from "../images/ai_chatbot_images/process/maintenance.webp";
import qualityAssuranceAIChatbotImage from "../images/ai_chatbot_images/process/quality-assurance.webp";
import uiUxDesignAIChatbotImage from "../images/ai_chatbot_images/process/ui-ux-design.webp";
import Odoo_bg from "../images/Odoo_bg.svg";
import GCP_bg from "../images/GCP_bg.svg";
import Stripe_bg from "../images/Stripe_bg.svg";
import AWS_bg from "../images/AWS_bg.svg";

import aiMl from "../images/fitness_app_development_images/emerging/ai-ml.webp";
import arVr from "../images/fitness_app_development_images/emerging/ar-vr.webp";
import blockchain from "../images/fitness_app_development_images/emerging/blockchain.webp";
import chatbots from "../images/fitness_app_development_images/emerging/chatbots.webp";
import cloudTechnology from "../images/fitness_app_development_images/emerging/cloud-technology.webp";
import roboticProcessAutomation from "../images/fitness_app_development_images/emerging/robotic-process-automation.webp";

import deployment from "../images/fitness_app_development_images/process/deployment.webp";
import fitnessDevelopment from "../images/fitness_app_development_images/process/development.webp";
import supportAndMaintenance from "../images/fitness_app_development_images/process/support-and-maintenance.webp";
import fitnessTesting from "../images/fitness_app_development_images/process/testing.webp";
import uiUxDesign from "../images/fitness_app_development_images/process/ui-ux-design.webp";
import ideation from "../images/fitness_app_development_images/process/ideation.webp";

import dietNutritionApp from "../images/fitness_app_development_images/solutions/diet-nutrition-app.webp";
import fitnessClubApps from "../images/fitness_app_development_images/solutions/fitness-club-apps.webp";
import fitnessTrackerApp from "../images/fitness_app_development_images/solutions/fitness-tracker-app.webp";
import meditationYogaApp from "../images/fitness_app_development_images/solutions/meditation-yoga-app.webp";
import personalTrainerApp from "../images/fitness_app_development_images/solutions/personal-trainer-app.webp";
import socialMediaFitnessApp from "../images/fitness_app_development_images/solutions/social-media-fitness-app.webp";

import socialArVr from "../images/social_media_app_development_images/emerging/ar-vr.webp";
import artificialIntelligence from "../images/social_media_app_development_images/emerging/artificial-intelligence.webp";
import socialBlockchain from "../images/social_media_app_development_images/emerging/blockchain.webp";
import cloudComputing from "../images/social_media_app_development_images/emerging/cloud-computing.webp";
import geolocationTechnology from "../images/social_media_app_development_images/emerging/geolocation-technology.webp";
import machineLearning from "../images/social_media_app_development_images/emerging/machine-learning.webp";

import socialDeployment from "../images/social_media_app_development_images/process/deployment.webp";
import socialDesign from "../images/social_media_app_development_images/process/design.webp";
import socialDevelopment from "../images/social_media_app_development_images/process/development.webp";
import maintenance from "../images/social_media_app_development_images/process/maintenance.webp";
import marketResearch from "../images/social_media_app_development_images/process/market-research.webp";
import socialTesting from "../images/social_media_app_development_images/process/testing.webp";

import businessSocialNetworkingApp from "../images/social_media_app_development_images/solutions/business-social-networking-app.webp";
import entertainmentSocialMediaApp from "../images/social_media_app_development_images/solutions/entertainment-social-media-app.webp";
import socialCommunityApp from "../images/social_media_app_development_images/solutions/social-community-app.webp";
import socialCreatorPlatform from "../images/social_media_app_development_images/solutions/social-creator-platform.webp";
import socialNetworkingApp from "../images/social_media_app_development_images/solutions/social-networking-app.webp";
import videoAndContentSharingApp from "../images/social_media_app_development_images/solutions/video-and-content-sharing-app.webp";

import ai from "../images/telemedicine_app_development_images/emerging/ai.webp";
import telemedicineArVr from "../images/telemedicine_app_development_images/emerging/ar-vr.webp";
import bigDataAnalytics from "../images/telemedicine_app_development_images/emerging/big-data-analytics.webp";
import telemedicineBlockchain from "../images/telemedicine_app_development_images/emerging/blockchain.webp";
import telemedicineCloudComputing from "../images/telemedicine_app_development_images/emerging/cloud-computing.webp";
import digitalTherapeutics from "../images/telemedicine_app_development_images/emerging/digital-therapeutics.webp";
import iot from "../images/telemedicine_app_development_images/emerging/iot.webp";

import configureNotification from "../images/telemedicine_app_development_images/features/admin/configure-notification.webp";
import manageServices from "../images/telemedicine_app_development_images/features/admin/manage-services.webp";
import powerfulDashboard from "../images/telemedicine_app_development_images/features/admin/powerful-dashboard.webp";
import registerDoctors from "../images/telemedicine_app_development_images/features/admin/register-doctors.webp";
import reportsAndAnalytics from "../images/telemedicine_app_development_images/features/admin/reports-and-analytics.webp";
import viewAppointments from "../images/telemedicine_app_development_images/features/admin/view-appointments.webp";

import cancelAppointment from "../images/telemedicine_app_development_images/features/doctor/cancel-appointment.webp";
import createOrder from "../images/telemedicine_app_development_images/features/doctor/create-order.webp";
import detailedDashboard from "../images/telemedicine_app_development_images/features/doctor/detailed-dashboard.webp";
import manageProfile from "../images/telemedicine_app_development_images/features/doctor/manage-profile.webp";
import notification from "../images/telemedicine_app_development_images/features/doctor/notification.webp";
import updateAvailability from "../images/telemedicine_app_development_images/features/doctor/update-availability.webp";

import appointmentHistory from "../images/telemedicine_app_development_images/features/patient/appointment-history.webp";
import bookVisit from "../images/telemedicine_app_development_images/features/patient/book-visit.webp";
import notifications from "../images/telemedicine_app_development_images/features/patient/notifications.webp";
import searchDoctors from "../images/telemedicine_app_development_images/features/patient/search-doctors.webp";
import upcomingAppointments from "../images/telemedicine_app_development_images/features/patient/upcoming-appointments.webp";
import videoConsultation from "../images/telemedicine_app_development_images/features/patient/video-consultation.webp";

import musicStreamingArVr from "../images/music_streaming_app_development_images/emerging/ar-vr.webp";
import musicStreamingArtificialIntelligence from "../images/music_streaming_app_development_images/emerging/artificial-intelligence.webp";
import musicStreamingBlockchain from "../images/music_streaming_app_development_images/emerging/blockchain.webp";
import musicStreamingCloudComputing from "../images/music_streaming_app_development_images/emerging/cloud-computing.webp";
import musicStreamingDataAnalytics from "../images/music_streaming_app_development_images/emerging/data-analytics.webp";
import musicRecognitionEngine from "../images/music_streaming_app_development_images/emerging/music-recognition-engine.webp";

import dashboard from "../images/music_streaming_app_development_images/features/admin/dashboard.webp";
import musicPublishing from "../images/music_streaming_app_development_images/features/admin/music-publishing.webp";
import paymentTracking from "../images/music_streaming_app_development_images/features/admin/payment-tracking.webp";
import reportsAnalytics from "../images/music_streaming_app_development_images/features/admin/reports-analytics.webp";
import subscriptionManagement from "../images/music_streaming_app_development_images/features/admin/subscription-management.webp";
import userManagement from "../images/music_streaming_app_development_images/features/admin/user-management.webp";

import artistsProfiles from "../images/music_streaming_app_development_images/features/advanced_features/artists-profiles.webp";
import lyrics from "../images/music_streaming_app_development_images/features/advanced_features/lyrics.webp";
import multilingualFunctionality from "../images/music_streaming_app_development_images/features/advanced_features/multilingual-functionality.webp";
import musicWishlist from "../images/music_streaming_app_development_images/features/advanced_features/music-wishlist.webp";
import reviewRating from "../images/music_streaming_app_development_images/features/advanced_features/review-rating.webp";
import voiceSearch from "../images/music_streaming_app_development_images/features/advanced_features/voice-search.webp";

import createAPlaylist from "../images/music_streaming_app_development_images/features/user/create-a-playlist.webp";
import integratingSocialMedia from "../images/music_streaming_app_development_images/features/user/integrating-social-media.webp";
import offlineListening from "../images/music_streaming_app_development_images/features/user/offline-listening.webp";
import profileCreation from "../images/music_streaming_app_development_images/features/user/profile-creation.webp";
import streamMusicOnline from "../images/music_streaming_app_development_images/features/user/stream-music-online.webp";
import subscriptionPlans from "../images/music_streaming_app_development_images/features/user/subscription-plans.webp";

import aiImage from "../images/computer_vision_image/emerging/ai.webp";
import cloudComputingComputerVisionImage from "../images/computer_vision_image/emerging/cloud-computing.webp";
import deepLearningImage from "../images/computer_vision_image/emerging/deep-learning.webp";
import edgeComputingImage from "../images/computer_vision_image/emerging/edge-computing.webp";
import machineLearningImage from "../images/computer_vision_image/emerging/machine-learning.webp";
import naturalLanguageProcessingComputerVisionImage from "../images/computer_vision_image/emerging/natural-language-processing.webp";

import architectureDesignImage from "../images/computer_vision_image/process/architecture-design.webp";
import dataCollectionComputerVisionImage from "../images/computer_vision_image/process/data-collection.webp";
import deploymentAndMaintenanceComputerVisionImage from "../images/computer_vision_image/process/deployment-and-maintenance.webp";
import modelTrainingImage from "../images/computer_vision_image/process/model-training.webp";
import problemDefinitionImage from "../images/computer_vision_image/process/problem-definition.webp";
import testingComputerVisionImage from "../images/computer_vision_image/process/testing.webp";

const ICON_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_BASE_URL || "";

import aiAgeVerificationImage from "../images/liquor_images/emerging/ai-age-verification.webp";
import blockchainLiquorImage from "../images/liquor_images/emerging/blockchain.webp";
import cloudComputingLiquorImage from "../images/liquor_images/emerging/cloud-computing.webp";
import dataAnalyticsLiquorImage from "../images/liquor_images/emerging/data-analytics.webp";
import machineLearningLiquorImage from "../images/liquor_images/emerging/machine-learning.webp";
import smartRouteOptimizationImage from "../images/liquor_images/emerging/smart-route-optimization.webp";

import deliveryManagementAdminImage from "../images/liquor_images/features/admin/delivery-management.webp";
import inventoryManagementAdminImage from "../images/liquor_images/features/admin/inventory-management.webp";
import multipleStoreManagementAdminImage from "../images/liquor_images/features/admin/multiple-store-management.webp";
import regulatoryComplianceAdminImage from "../images/liquor_images/features/admin/regulatory-compliance.webp";
import reviewFeedbackAdminImage from "../images/liquor_images/features/admin/review-feedback.webp";
import userManagementAdminImage from "../images/liquor_images/features/admin/user-management.webp";

import comparePricesCustomerImage from "../images/liquor_images/features/customer/compare-prices.webp";
import easyPaymentsCustomerImage from "../images/liquor_images/features/customer/easy-payments.webp";
import offersDiscountsCustomerImage from "../images/liquor_images/features/customer/offers-discounts.webp";
import realTimeTrackingCustomerImage from "../images/liquor_images/features/customer/real-time-tracking.webp";
import searchCustomerImage from "../images/liquor_images/features/customer/search.webp";
import signInCustomerImage from "../images/liquor_images/features/customer/sign-in.webp";

import deliveryStatusDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/delivery-status.webp";
import itemDetailsDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/item-details.webp";
import notificationsDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/notifications.webp";
import paymentManagementDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/payment-management.webp";
import profileCreationDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/profile-creation.webp";
import realTimeTrackingDeliveryAgentImage from "../images/liquor_images/features/delivery_agent/real-time-tracking.webp";

import manageDeliveryMerchantImage from "../images/liquor_images/features/merchant/manage-delivery.webp";
import manageOrdersMerchantImage from "../images/liquor_images/features/merchant/manage-orders.webp";
import manageStockMerchantImage from "../images/liquor_images/features/merchant/manage-stock.webp";
import offersDiscountsMerchantImage from "../images/liquor_images/features/merchant/offers-discounts.webp";
import profileCreationMerchantImage from "../images/liquor_images/features/merchant/profile-creation.webp";
import realTimeNotificationsMerchantImage from "../images/liquor_images/features/merchant/real-time-notifications.webp";

import arVrFuelDeliveryImage from "../images/fuel_delivery_images/emerging/ar-vr.webp";
import artificialIntelligenceFuelDeliveryImage from "../images/fuel_delivery_images/emerging/artificial-intelligence.webp";
import blockchainFuelDeliveryImage from "../images/fuel_delivery_images/emerging/blockchain.webp";
import cloudComputingFuelDeliveryImage from "../images/fuel_delivery_images/emerging/cloud-computing.webp";
import internetOfThingsFuelDeliveryImage from "../images/fuel_delivery_images/emerging/internet-of-things.webp";
import machineLearningMlImage from "../images/fuel_delivery_images/emerging/machine-learning-ml.webp";

import dashboardAdminImage from "../images/fuel_delivery_images/features/admin/dashboard.webp";
import driversAdminImage from "../images/fuel_delivery_images/features/admin/drivers.webp";
import loginAdminImage from "../images/fuel_delivery_images/features/admin/login.webp";
import paymentAdminImage from "../images/fuel_delivery_images/features/admin/payment.webp";
import pricingAdminImage from "../images/fuel_delivery_images/features/admin/pricing.webp";
import tankersAdminImage from "../images/fuel_delivery_images/features/admin/tankers.webp";

import assistanceDriverImage from "../images/fuel_delivery_images/features/driver/assistance.webp";
import customerInformationDriverImage from "../images/fuel_delivery_images/features/driver/customer-information.webp";
import dashboardsDriverImage from "../images/fuel_delivery_images/features/driver/dashboards.webp";
import navigationDriverImage from "../images/fuel_delivery_images/features/driver/navigation.webp";
import registrationDriverImage from "../images/fuel_delivery_images/features/driver/registration.webp";
import statusDriverImage from "../images/fuel_delivery_images/features/driver/status.webp";

import alertsUserImage from "../images/fuel_delivery_images/features/user/alerts.webp";
import priceUserImage from "../images/fuel_delivery_images/features/user/price.webp";
import receiptsUserImage from "../images/fuel_delivery_images/features/user/receipts.webp";
import registrationUserImage from "../images/fuel_delivery_images/features/user/registration.webp";
import testimonialsUserImage from "../images/fuel_delivery_images/features/user/testimonials.webp";
import userProfileUserImage from "../images/fuel_delivery_images/features/user/user-profile.webp";

import aiDODImage from "../images/doctors_on_demand_images/emerging/ai.webp";
import arVrDODImage from "../images/doctors_on_demand_images/emerging/ar-vr.webp";
import blockchainDODImage from "../images/doctors_on_demand_images/emerging/blockchain.webp";
import cloudComputingDODImage from "../images/doctors_on_demand_images/emerging/cloud-computing.webp";
import dataAnalyticsDODImage from "../images/doctors_on_demand_images/emerging/data-analytics.webp";
import iotDODImage from "../images/doctors_on_demand_images/emerging/iot.webp";

import appointmentManagementAdminImage from "../images/doctors_on_demand_images/features/admin/appointment-management.webp";
import billingAdminImage from "../images/doctors_on_demand_images/features/admin/billing.webp";
import contentManagementAdminImage from "../images/doctors_on_demand_images/features/admin/content-management.webp";
import customerSupportAdminImage from "../images/doctors_on_demand_images/features/admin/customer-support.webp";
import platformAnalyticsAdminImage from "../images/doctors_on_demand_images/features/admin/platform-analytics.webp";
import userManagementAdminDODImage from "../images/doctors_on_demand_images/features/admin/user-management.webp";

import appointmentSchedulingCustomerImage from "../images/doctors_on_demand_images/features/customer/appointment-scheduling.webp";
import ePrescriptionsCustomerImage from "../images/doctors_on_demand_images/features/customer/e-prescriptions.webp";
import geolocationServicesCustomerImage from "../images/doctors_on_demand_images/features/customer/geolocation-services.webp";
import insuranceIntegrationCustomerImage from "../images/doctors_on_demand_images/features/customer/insurance-integration.webp";
import symptomCheckerCustomerImage from "../images/doctors_on_demand_images/features/customer/symptom-checker.webp";
import videoConsultationsCustomerImage from "../images/doctors_on_demand_images/features/customer/video-consultations.webp";

import availabilityManagementDoctorImage from "../images/doctors_on_demand_images/features/doctor/availability-management.webp";
import doctorProfileDoctorImage from "../images/doctors_on_demand_images/features/doctor/doctor-profile.webp";
import earningsPaymentsDoctorImage from "../images/doctors_on_demand_images/features/doctor/earnings-payments.webp";
import patientManagementDoctorImage from "../images/doctors_on_demand_images/features/doctor/patient-management.webp";
import performanceAnalyticsDoctorImage from "../images/doctors_on_demand_images/features/doctor/performance-analytics.webp";
import teleconsultationPlatformDoctorImage from "../images/doctors_on_demand_images/features/doctor/teleconsultation-platform.webp";

import frontendDevelopmentbBg from "../images/frontend-development-bg.svg";
import backendDevelopmentbBg from "../images/backend-development-bg.svg";

import cmsAiMl from "../images/cms_images/ai-ml.webp";
import cmsBlockchain from "../images/cms_images/blockchain.webp";
import cmsCloudComputing from "../images/cms_images/cloud-computing.webp";

import bankingFinance from "../images/industries_we_serve_images/banking-finance.webp";
import ecommerceRetailB2b from "../images/industries_we_serve_images/ecommerce-retail-b2b.webp";
import foodRestaurant from "../images/industries_we_serve_images/food-restaurant.webp";
import onDemandSolutions from "../images/industries_we_serve_images/on-demand-solutions.webp";
import realEstateProperty from "../images/industries_we_serve_images/real-estate-property.webp";

import timeLineImage1 from "../images/about/2003.webp";
import timeLineImage2 from "../images/about/2008.webp";
import timeLineImage3 from "../images/about/2013.webp";
import timeLineImage4 from "../images/about/2018.webp";
import timeLineImage5 from "../images/about/2023.webp";
import timeLineImage6 from "../images/about/2026.webp";

import aiMlGCPImage from "../images/google_cloud_platform_image/emerging/ai-ml.webp";
import arVrGCPImage from "../images/google_cloud_platform_image/emerging/ar-vr.webp";
import blockchainGCPImage from "../images/google_cloud_platform_image/emerging/blockchain.webp";
import cloudComputingGCPImage from "../images/google_cloud_platform_image/emerging/cloud-computing.webp";
import dataAnalyticsGCPImage from "../images/google_cloud_platform_image/emerging/data-analytics.webp";
import iotGCPImage from "../images/google_cloud_platform_image/emerging/iot.webp";

import deploymentProcessGCPImage from "../images/google_cloud_platform_image/process/deployment.webp";
import designProcessGCPImage from "../images/google_cloud_platform_image/process/design.webp";
import developmentProcessGCPImage from "../images/google_cloud_platform_image/process/development.webp";
import requirementsAnalysisProcessGCPImage from "../images/google_cloud_platform_image/process/requirements-analysis.webp";
import supportMaintenanceProcessGCPImage from "../images/google_cloud_platform_image/process/support-maintenance.webp";
import testingProcessGCPImage from "../images/google_cloud_platform_image/process/testing.webp";

import odooArVr from "../images/odoo_development_services_images/emerging/ar-vr.webp";
import odooArtificialIntelligence from "../images/odoo_development_services_images/emerging/artificial-intelligence.webp";
import odooBlockchain from "../images/odoo_development_services_images/emerging/blockchain.webp";
import odooCloudComputing from "../images/odoo_development_services_images/emerging/cloud-computing.webp";
import odooDataAnalytics from "../images/odoo_development_services_images/emerging/data-analytics.webp";
import odooInternetOfThings from "../images/odoo_development_services_images/emerging/internet-of-things.webp";

import odooDeployment from "../images/odoo_development_services_images/process/deployment.webp";
import odooDevelopment from "../images/odoo_development_services_images/process/development.webp";
import planning from "../images/odoo_development_services_images/process/planning.webp";
import preparation from "../images/odoo_development_services_images/process/preparation.webp";
import odooSupportAndMaintenance from "../images/odoo_development_services_images/process/support-maintenance.webp";
import odooTesting from "../images/odoo_development_services_images/process/testing.webp";

import awsAiMl from "../images/aws_consulting_services_images/emerging/ai-ml.webp";
import awsArVr from "../images/aws_consulting_services_images/emerging/ar-vr.webp";
import awsBlockchain from "../images/aws_consulting_services_images/emerging/blockchain.webp";
import awsCloudComputing from "../images/aws_consulting_services_images/emerging/cloud-computing.webp";
import awsDataAnalytics from "../images/aws_consulting_services_images/emerging/data-analytics.webp";
import awsIot from "../images/aws_consulting_services_images/emerging/internet-of-things.webp";

import awsDevelopment from "../images/aws_consulting_services_images/process/development.webp";
import awsReadiness from "../images/aws_consulting_services_images/process/readiness.webp";
import awsSolutionDesign from "../images/aws_consulting_services_images/process/solution-design.webp";
import awsStrategy from "../images/aws_consulting_services_images/process/strategy.webp";
import awsSupportAndMaintenance from "../images/aws_consulting_services_images/process/support-and-maintenance.webp";
import awsTesting from "../images/aws_consulting_services_images/process/testing.webp";

import easySignIn from "../images/classified_app_development_images/features/customer/easy-sign-in.webp";
import favoriteList from "../images/classified_app_development_images/features/customer/favorite-list.webp";
import inAppChat from "../images/classified_app_development_images/features/customer/in-app-chat.webp";
import reviewAndReport from "../images/classified_app_development_images/features/customer/review-and-report.webp";
import searchByCategory from "../images/classified_app_development_images/features/customer/search-by-category.webp";
import searchByLocation from "../images/classified_app_development_images/features/customer/search-by-location.webp";

import adManagement from "../images/classified_app_development_images/features/seller/ad-management.webp";
import easyAdListing from "../images/classified_app_development_images/features/seller/easy-ad-listing.webp";
import messagingSystem from "../images/classified_app_development_images/features/seller/messaging-system.webp";
import performanceInsights from "../images/classified_app_development_images/features/seller/performance-insights.webp";
import profileCustomization from "../images/classified_app_development_images/features/seller/profile-customization.webp";

import chatArVr from "../images/chat_messaging_app_development_images/emerging/ar-vr.webp";
import chatArtificialIntelligence from "../images/chat_messaging_app_development_images/emerging/artificial-intelligence.webp";
import chatBlockchain from "../images/chat_messaging_app_development_images/emerging/blockchain.webp";
import chatCloudComputing from "../images/chat_messaging_app_development_images/emerging/cloud-computing.webp";
import chatDataAnalytics from "../images/chat_messaging_app_development_images/emerging/data-analytics.webp";
import chatInternetOfThings from "../images/chat_messaging_app_development_images/emerging/internet-of-things.webp";

import aiPoweredModeration from "../images/chat_messaging_app_development_images/feature/admin/ai-powered-moderation.webp";
import broadcastingMessage from "../images/chat_messaging_app_development_images/feature/admin/broadcasting-message.webp";
import chatGroupControls from "../images/chat_messaging_app_development_images/feature/admin/chat-group-controls.webp";
import dataPrivacy from "../images/chat_messaging_app_development_images/feature/admin/data-privacy.webp";
import chatReportsAnalytics from "../images/chat_messaging_app_development_images/feature/admin/reports-analytics.webp";
import chatUserManagement from "../images/chat_messaging_app_development_images/feature/admin/user-management.webp";

import aiIntegration from "../images/chat_messaging_app_development_images/feature/user/ai-integration.webp";
import completeEncryption from "../images/chat_messaging_app_development_images/feature/user/complete-encryption.webp";
import filesMediaSharing from "../images/chat_messaging_app_development_images/feature/user/files-media-sharing.webp";
import languageTranslation from "../images/chat_messaging_app_development_images/feature/user/language-translation.webp";
import smartReplySuggestions from "../images/chat_messaging_app_development_images/feature/user/smart-reply-suggestions.webp";
import voiceToText from "../images/chat_messaging_app_development_images/feature/user/voice-to-text.webp";

import directoryArtificialIntelligence from "../images/directory_app_development_images/emerging/artificial-intelligence.webp";
import directoryBlockchain from "../images/directory_app_development_images/emerging/blockchain.webp";
import directoryCloudComputing from "../images/directory_app_development_images/emerging/cloud-computing.webp";
import directoryDataAnalytics from "../images/directory_app_development_images/emerging/data-analytics.webp";
import directoryGeolocation from "../images/directory_app_development_images/emerging/geolocation.webp";
import directoryInternetOfThings from "../images/directory_app_development_images/emerging/internet-of-things.webp";

import directoryContentModeration from "../images/directory_app_development_images/feature/admin/content-moderation.webp";
import directoryDashboard from "../images/directory_app_development_images/feature/admin/dashboard.webp";
import listingManagement from "../images/directory_app_development_images/feature/admin/listing-management.webp";
import directoryPaymentManagement from "../images/directory_app_development_images/feature/admin/payment-management.webp";
import systemSettings from "../images/directory_app_development_images/feature/admin/system-settings.webp";
import userVendorManagement from "../images/directory_app_development_images/feature/admin/user-vendor-management.webp";

import favorites from "../images/directory_app_development_images/feature/user/favorites.webp";
import inAppMessaging from "../images/directory_app_development_images/feature/user/in-app-messaging.webp";
import directoryRealTimeNotifications from "../images/directory_app_development_images/feature/user/real-time-notifications.webp";
import directoryReviews from "../images/directory_app_development_images/feature/user/reviews.webp";
import smartSearch from "../images/directory_app_development_images/feature/user/smart-search.webp";
import userProfiles from "../images/directory_app_development_images/feature/user/user-profiles.webp";

import analyticsAndInsights from "../images/directory_app_development_images/feature/vendor/analytics-and-insights.webp";
import leadManagement from "../images/directory_app_development_images/feature/vendor/lead-management.webp";
import directoryManageProfile from "../images/directory_app_development_images/feature/vendor/manage-profile.webp";
import directoryPaymentTracking from "../images/directory_app_development_images/feature/vendor/payment-tracking.webp";
import promotionTools from "../images/directory_app_development_images/feature/vendor/promotion-tools.webp";
import reviewManagement from "../images/directory_app_development_images/feature/vendor/review-management.webp";

//event app development (emerging tech)
import eventArVr from "../images/event_app_development_images/emerging_tech/ar-vr.webp";
import eventArtificialIntelligence from "../images/event_app_development_images/emerging_tech/artificial-intelligence.webp";
import eventBlockChain from "../images/event_app_development_images/emerging_tech/blockchain.webp";
import eventCloudComputing from "../images/event_app_development_images/emerging_tech/cloud-computing.webp";
import eventDataAnalytics from "../images/event_app_development_images/emerging_tech/data-analytics.webp";
import eventInternetOfThings from "../images/event_app_development_images/emerging_tech/internet-of-things.webp";

//event app development (process)
import eventAppDeployment from "../images/event_app_development_images/process/app-development.webp";
import eventDeployment from "../images/event_app_development_images/process/deployment.webp";
import eventResearch from "../images/event_app_development_images/process/research.webp";
import eventSupportMaintenance from "../images/event_app_development_images/process/support-maintenance.webp";
import eventTesting from "../images/event_app_development_images/process/testing.webp";
import eventUiUxDesign from "../images/event_app_development_images/process/ui-ux-design.webp";

//event app development (solutions)
import conferenceEventBookingApp from "../images/event_app_development_images/solutions/conference-event-booking-app.webp";
import corporateEventApps from "../images/event_app_development_images/solutions/corporate-event-apps.webp";
import festivalManagementApp from "../images/event_app_development_images/solutions/festival-management-app.webp";
import localEventApps from "../images/event_app_development_images/solutions/local-event-apps.webp";
import sportEventApps from "../images/event_app_development_images/solutions/sports-event-apps.webp";
import weddingPlannerRefreshmentApps from "../images/event_app_development_images/solutions/wedding-planner-refreshment-apps.webp";

//Game App Developement
import gameAdvanceAutomation from "../images/game_app_development_image/emerging_tech/advanced-automation.webp";
import gameArtificialIntelligence from "../images/game_app_development_image/emerging_tech/artificial-intelligence.webp";
import gameAugmentedReality from "../images/game_app_development_image/emerging_tech/augmented-reality.webp";
import gameBlockchain from "../images/game_app_development_image/emerging_tech/blockchain.webp";
import gameCloudGaming from "../images/game_app_development_image/emerging_tech/cloud-gaming.webp";
import gameVirtualReality from "../images/game_app_development_image/emerging_tech/virtual-reality.webp";

import processDesign from "../images/game_app_development_image/process/design.webp";
import processDevelopememt from "../images/game_app_development_image/process/development.webp";
import processPreProduction from "../images/game_app_development_image/process/pre-production.webp";
import processRequirementGathering from "../images/game_app_development_image/process/requirement-gathering.webp";
import processSupport from "../images/game_app_development_image/process/support.webp";
import processTestingAndDeployment from "../images/game_app_development_image/process/testing-and-deployment.webp";

import solutionsActionGamingApps from "../images/game_app_development_image/solutions/action-gaming-apps.webp";
import solutionsCardGames from "../images/game_app_development_image/solutions/card-games.webp";
import solutionsCasualGames from "../images/game_app_development_image/solutions/casual-games.webp";
import solutionsEducationalGamingApps from "../images/game_app_development_image/solutions/educational-gaming-apps.webp";
import solutionsPuzzleGames from "../images/game_app_development_image/solutions/puzzle-games.webp";
import solutionsStrategyGamingApps from "../images/game_app_development_image/solutions/strategy-gaming-apps.webp";

// Dating App Development(emerging)
import datingAiMl from "../images/dating_app_development_images/emerging/ai-ml.webp";
import datingArVr from "../images/dating_app_development_images/emerging/ar-vr.webp";
import datingBigDataAnalytics from "../images/dating_app_development_images/emerging/big-data-analytics.webp";
import datingBlockChain from "../images/dating_app_development_images/emerging/blockchain.webp";
import datingCloudIntegration from "../images/dating_app_development_images/emerging/cloud-integration.webp";
import datingIot from "../images/dating_app_development_images/emerging/iot.webp";

// Dating App Development(features/admin panel)
import datingcustomerSupportSystem from "../images/dating_app_development_images/features/admin_panel/customer-support-system.webp";
import datingreportAnalysis from "../images/dating_app_development_images/features/admin_panel/report-analysis.webp";
import datingseamlessDashboard from "../images/dating_app_development_images/features/admin_panel/seamless-dashboard.webp";
import datingsubscriptionModelManagement from "../images/dating_app_development_images/features/admin_panel/subscription-model-management.webp";
import datingUserManagement from "../images/dating_app_development_images/features/admin_panel/subscription-model-management.webp";
import datingUserVerification from "../images/dating_app_development_images/features/admin_panel/user-verification.webp";

// Dating App Development(features/advanced features)
import datingCallingOption from "../images/dating_app_development_images/features/advanced_featured/calling-option.webp";
import datingDatePlanner from "../images/dating_app_development_images/features/advanced_featured/date-planner.webp";
import datingGeoLocationTagging from "../images/dating_app_development_images/features/advanced_featured/geolocation-tagging.webp";
import datingMessageBox from "../images/dating_app_development_images/features/advanced_featured/message-box.webp";
import datingSpamProtection from "../images/dating_app_development_images/features/advanced_featured/spam-protection.webp";
import datingUserAuthentication from "../images/dating_app_development_images/features/advanced_featured/user-authentication.webp";

// Dating App Development(features/user panel)
import datingFacialRecognition from "../images/dating_app_development_images/features/user_panel/facial-recognition.webp";
import datingMatchMakingTools from "../images/dating_app_development_images/features/user_panel/matchmaking-tools.webp";
import datingMultilingualCommunication from "../images/dating_app_development_images/features/user_panel/multilingual-communication.webp";
import datingRealTimeTranslation from "../images/dating_app_development_images/features/user_panel/real-time-translation.webp";
import datingSearchFilter from "../images/dating_app_development_images/features/user_panel/search-filters.webp";
import datingUserReview from "../images/dating_app_development_images/features/user_panel/user-review.webp";

//Transportation App Developement
import transAiMlTech from "../images/transportation-app-development_images/emerging_tech/ai-ml-1.webp";
import transArVr from "../images/transportation-app-development_images/emerging_tech/ar-vr.webp";
import transBigData from "../images/transportation-app-development_images/emerging_tech/big-data-analytics.webp";
import transBlockChain from "../images/transportation-app-development_images/emerging_tech/blockchain.webp";
import transCloud from "../images/transportation-app-development_images/emerging_tech/cloud-computing.webp";
import transIOT from "../images/transportation-app-development_images/emerging_tech/internet-of-things.webp";

import processDev from "../images/transportation-app-development_images/process/development.webp";
import processGathering from "../images/transportation-app-development_images/process/gathering-requirements.webp";
import processMaintenance from "../images/transportation-app-development_images/process/maintenance-and-support.webp";
import processTesting from "../images/transportation-app-development_images/process/testing-and-launch.webp";
import processUiUx from "../images/transportation-app-development_images/process/ui-ux-design.webp";

import solutionsCar from "../images/transportation-app-development_images/solutions/car-rental-app.webp";
import solutionsDeliveryApp from "../images/transportation-app-development_images/solutions/delivery-app.webp";
import solutionsElectricVehicle from "../images/transportation-app-development_images/solutions/electric-vehicle-charging-app.webp";
import solutionsFreightApp from "../images/transportation-app-development_images/solutions/freight-app.webp";
import solutionsRideSharing from "../images/transportation-app-development_images/solutions/ride-sharing-app.webp";
import solutionsTourTravel from "../images/transportation-app-development_images/solutions/tour-travel-app.webp";

import taxiEmergingArtificialIntelligence from "../images/taxi_page_images/emerging/artificial-intelligence.webp";
import taxiEmergingBlockchain from "../images/taxi_page_images/emerging/blockchain.webp";
import taxiEmergingDataAnalytics from "../images/taxi_page_images/emerging/data-analytics.webp";
import taxiEmergingIotIntegration from "../images/taxi_page_images/emerging/iot-integration.webp";
import taxiEmergingMachineLearning from "../images/taxi_page_images/emerging/machine-learning.webp";
import taxiEmergingVirtualAssistants from "../images/taxi_page_images/emerging/virtual-assistants.webp";
import taxiAdminDriverManagement from "../images/taxi_page_images/features/admin_panel/driver-management.webp";
import taxiAdminManageCurrency from "../images/taxi_page_images/features/admin_panel/manage-currency.webp";
import taxiAdminOwedAmountManagement from "../images/taxi_page_images/features/admin_panel/owed-amount-management.webp";
import taxiAdminRatings from "../images/taxi_page_images/features/admin_panel/ratings.webp";
import taxiAdminRidersManagement from "../images/taxi_page_images/features/admin_panel/riders-management.webp";
import taxiAdminSeamlessUserIntegration from "../images/taxi_page_images/features/admin_panel/seamless-map-integration.webp";
import taxiDriverCancellingOption from "../images/taxi_page_images/features/driver_panel/cancelling-option.webp";
import taxiDriverDocumentManagement from "../images/taxi_page_images/features/driver_panel/document-management.webp";
import taxiDriverEarningReport from "../images/taxi_page_images/features/driver_panel/earning-report.webp";
import taxiDriverOnlineOfflineMode from "../images/taxi_page_images/features/driver_panel/online-offline-mode.webp";
import taxiDriverRatingAndReviews from "../images/taxi_page_images/features/driver_panel/rating-and-reviews.webp";
import taxiDriverSeamlessMapIntegration from "../images/taxi_page_images/features/driver_panel/seamless-map-integration.webp";
import taxiUserInAppPayments from "../images/taxi_page_images/features/user_panel/in-app-payments.webp";
import taxiUserInstantNotifications from "../images/taxi_page_images/features/user_panel/instant-notifications.webp";
import taxiUserLiveGeoTracking from "../images/taxi_page_images/features/user_panel/live-geo-tracking.webp";
import taxiUserMultipleRegistration from "../images/taxi_page_images/features/user_panel/multiple-registration.webp";
import taxiUserSuperFastSearch from "../images/taxi_page_images/features/user_panel/super-fast-search.webp";
import taxiUserVerifiedUsers from "../images/taxi_page_images/features/user_panel/verified-users.webp";
import rubyArVr from "../images/ruby_on_rails_development_images/emerging/ar-vr.webp";
import rubyArtificialIntelligence from "../images/ruby_on_rails_development_images/emerging/artificial-intelligence.webp";
import rubyBlockchain from "../images/ruby_on_rails_development_images/emerging/blockchain.webp";
import rubyCloudComputing from "../images/ruby_on_rails_development_images/emerging/cloud-computing.webp";
import rubyDataAnalytics from "../images/ruby_on_rails_development_images/emerging/data-analytics.webp";
import rubyInternetOfThings from "../images/ruby_on_rails_development_images/emerging/internet-of-things.webp";

import rubyDeployment from "../images/ruby_on_rails_development_images/process/deployment.webp";
import rubyDesign from "../images/ruby_on_rails_development_images/process/design.webp";
import rubyDevelopment from "../images/ruby_on_rails_development_images/process/development.webp";
import rubyRequirementAnalysis from "../images/ruby_on_rails_development_images/process/requirement-analysis.webp";
import rubySupportAndMaintenance from "../images/ruby_on_rails_development_images/process/support-and-maintenance.webp";
import rubyTesting from "../images/ruby_on_rails_development_images/process/testing.webp";

import logisticsAiMl from "../images/logistics_app_development_images/emerging/ai-ml.webp";
import logisticsArVr from "../images/logistics_app_development_images/emerging/ar-vr.webp";
import logisticsBigDataAnalytics from "../images/logistics_app_development_images/emerging/big-data-analytics.webp";
import logisticsBlockchain from "../images/logistics_app_development_images/emerging/blockchain.webp";
import logisticsCloudComputing from "../images/logistics_app_development_images/emerging/cloud-computing.webp";
import logisticsInternetOfThings from "../images/logistics_app_development_images/emerging/internet-of-things.webp";

import logisticsDevelopment from "../images/logistics_app_development_images/process/development.webp";
import logisticsDiscovery from "../images/logistics_app_development_images/process/discovery.webp";
import logisticsLaunch from "../images/logistics_app_development_images/process/launch.webp";
import logisticsSupportAndMaintenance from "../images/logistics_app_development_images/process/support-and-maintenance.webp";
import logisticsTesting from "../images/logistics_app_development_images/process/testing.webp";
import logisticsUiUxDesign from "../images/logistics_app_development_images/process/ui-ux-design.webp";

import customerSupportApp from "../images/logistics_app_development_images/solutions/customer-support-app.webp";
import documentManagementApp from "../images/logistics_app_development_images/solutions/document-management-app.webp";
import inventoryManagementApp from "../images/logistics_app_development_images/solutions/inventory-management-app.webp";
import shippingLogisticsSystems from "../images/logistics_app_development_images/solutions/shipping-logistics-systems.webp";
import supplierProcurementSolutions from "../images/logistics_app_development_images/solutions/supplier-procurement-solutions.webp";
import supplyChainVisibilityApp from "../images/logistics_app_development_images/solutions/supply-chain-visibility-app.webp";
import warehouseManagementApp from "../images/logistics_app_development_images/solutions/warehouse-management-app.webp";

//Handy Man Images
import arVrHandyMan from "../images/handyman_app_images/emerging/ar-vr.webp";
import artificialIntelligenceHandyMan from "../images/handyman_app_images/emerging/artificial-intelligence.webp";
import blockchainHandyMan from "../images/handyman_app_images/emerging/blockchain.webp";
import cloudComputingHandyMan from "../images/handyman_app_images/emerging/cloud-computing.webp";
import dataAnalyticsHandyMan from "../images/handyman_app_images/emerging/data-analytics.webp";
import internetOfThingsHandyMan from "../images/handyman_app_images/emerging/internet-of-things.webp";

import analyticsReports from "../images/handyman_app_images/Features/admin/analytics-reports.webp";
import commissionManagement from "../images/handyman_app_images/Features/admin/commission-management.webp";
import handymanProfile from "../images/handyman_app_images/Features/admin/handyman-profile.webp";
import paymentTrackingHandyMan from "../images/handyman_app_images/Features/admin/payment-tracking.webp";
import support from "../images/handyman_app_images/Features/admin/support.webp";
import userManagementHandyMan from "../images/handyman_app_images/Features/admin/user-management.webp";

import availabilityControl from "../images/handyman_app_images/Features/service/availability-control.webp";
import earningsTracking from "../images/handyman_app_images/Features/service/earnings-tracking.webp";
import inAppCommunication from "../images/handyman_app_images/Features/service/in-app-communication.webp";
import jobManagement from "../images/handyman_app_images/Features/service/job-management.webp";
import profileManagement from "../images/handyman_app_images/Features/service/profile-management.webp";
import ratingsFeedback from "../images/handyman_app_images/Features/service/ratings-feedback.webp";

import easyBooking from "../images/handyman_app_images/Features/user/easy-booking.webp";
import flexibleScheduling from "../images/handyman_app_images/Features/user/flexible-scheduling.webp";
import realTimeTrackingUser from "../images/handyman_app_images/Features/user/real-time-tracking.webp";
import reviews from "../images/handyman_app_images/Features/user/reviews.webp";
import securePayments from "../images/handyman_app_images/Features/user/secure-payments.webp";
import serviceHistory from "../images/handyman_app_images/Features/user/service-history.webp";

//Car Wash Images
import artificialIntelligenceCarWash from "../images/car_wash_images/emerging/artificial-intelligence.webp";
import augmentedRealityCarWash from "../images/car_wash_images/emerging/augmented-reality.webp";
import bigDataAnalyticsCarWash from "../images/car_wash_images/emerging/big-data-analytics.webp";
import blockchainCarWash from "../images/car_wash_images/emerging/blockchain.webp";
import cloudComputingCarWash from "../images/car_wash_images/emerging/cloud-computing.webp";
import internetOfThingsCarWash from "../images/car_wash_images/emerging/internet-of-things.webp";

import dashboardCarWash from "../images/car_wash_images/features/admin/dashboard.webp";
import manageServicesCarWash from "../images/car_wash_images/features/admin/manage-services.webp";
import manageTimeZone from "../images/car_wash_images/features/admin/manage-time-zone.webp";
import manageUsers from "../images/car_wash_images/features/admin/manage-users.webp";
import manageWashers from "../images/car_wash_images/features/admin/manage-washers.webp";
import registerWashers from "../images/car_wash_images/features/admin/register-washers.webp";

import bookService from "../images/car_wash_images/features/user/book-service.webp";
import checkAvailability from "../images/car_wash_images/features/user/check-availability.webp";
import chooseWasher from "../images/car_wash_images/features/user/choose-washer.webp";
import payOnline from "../images/car_wash_images/features/user/pay-online.webp";
import signUpUser from "../images/car_wash_images/features/user/sign-up.webp";
import trackService from "../images/car_wash_images/features/user/track-service.webp";

import acceptRejectService from "../images/car_wash_images/features/washer_panel/accept-reject-service.webp";
import addServiceLocation from "../images/car_wash_images/features/washer_panel/add-service-location.webp";
import pushNotifications from "../images/car_wash_images/features/washer_panel/push-notifications.webp";
import signUpWasher from "../images/car_wash_images/features/washer_panel/sign-up.webp";
import updateServiceStatus from "../images/car_wash_images/features/washer_panel/update-service-status.webp";
import viewHistory from "../images/car_wash_images/features/washer_panel/view-history.webp";

//EdTech Images
import aiMlEdtech from "../images/edtech_images/emerging/ai-ml.webp";
import arVrlEdtech from "../images/edtech_images/emerging/ar-vr.webp";
import bigData from "../images/edtech_images/emerging/big-data.webp";
import blockchainlEdtech from "../images/edtech_images/emerging/blockchain.webp";
import cloudComputinglEdtech from "../images/edtech_images/emerging/cloud-computing.webp";
import internetOfThingslEdtech from "../images/edtech_images/emerging/internet-of-things.webp";

import manageContent from "../images/edtech_images/features/admin/manage-content.webp";
import manageSubjects from "../images/edtech_images/features/admin/manage-subjects.webp";
import manageSubscriptions from "../images/edtech_images/features/admin/manage-subscriptions.webp";
import manageTeachersStudents from "../images/edtech_images/features/admin/manage-teachers-students.webp";
import studentInformation from "../images/edtech_images/features/admin/student-information.webp";
import viewReports from "../images/edtech_images/features/admin/view-reports.webp";

import availableSubjects from "../images/edtech_images/features/student/available-subjects.webp";
import filterOnlineTutors from "../images/edtech_images/features/student/filter-online-tutors.webp";
import liveChat from "../images/edtech_images/features/student/live-chat.webp";
import payment from "../images/edtech_images/features/student/payment.webp";
import selectTutors from "../images/edtech_images/features/student/select-tutors.webp";
import subscribeTestSeries from "../images/edtech_images/features/student/subscribe-test-series.webp";

import answerQueries from "../images/edtech_images/features/teacher/answer-queries.webp";
import chat from "../images/edtech_images/features/teacher/chat.webp";
import profileManagementlEdtech from "../images/edtech_images/features/teacher/profile-management.webp";
import pushNotificationslEdtech from "../images/edtech_images/features/teacher/push-notifications.webp";
import scheduleClasses from "../images/edtech_images/features/teacher/schedule-classes.webp";
import viewRatings from "../images/edtech_images/features/teacher/view-ratings.webp";

//Smart Tv Images
import artificialIntelligenceSmartTv from "../images/smart_tv_images/emerging/artificial-intelligence.webp";
import bigDataAnalyticsSmartTv from "../images/smart_tv_images/emerging/big-data-analytics.webp";
import blockchainSmartTv from "../images/smart_tv_images/emerging/blockchain.webp";
import chatbotsSmartTv from "../images/smart_tv_images/emerging/chatbots.webp";
import cloudComputingSmartTv from "../images/smart_tv_images/emerging/cloud-computing.webp";
import internetOfThingsSmartTv from "../images/smart_tv_images/emerging/internet-of-things.webp";

import contentModeration from "../images/smart_tv_images/features/admin/content-moderation.webp";
import performanceMonitoring from "../images/smart_tv_images/features/admin/performance-monitoring.webp";
import securityControl from "../images/smart_tv_images/features/admin/security-control.webp";
import subscriptionManagementSmartTv from "../images/smart_tv_images/features/admin/subscription-management.webp";
import systemConfiguration from "../images/smart_tv_images/features/admin/system-configuration.webp";
import userManagementSmartTv from "../images/smart_tv_images/features/admin/user-management.webp";

import analyticsDashboard from "../images/smart_tv_images/features/brand panel/analytics-dashboard.webp";
import contentScheduling from "../images/smart_tv_images/features/brand panel/content-scheduling.webp";
import contentUpload from "../images/smart_tv_images/features/brand panel/content-upload.webp";
import customBranding from "../images/smart_tv_images/features/brand panel/custom-branding.webp";
import engagementTools from "../images/smart_tv_images/features/brand panel/engagement-tools.webp";
import multiRegionContent from "../images/smart_tv_images/features/brand panel/multi-region-content.webp";

import multiProfileSupport from "../images/smart_tv_images/features/user/multi-profile-support.webp";
import personalizedRecommendations from "../images/smart_tv_images/features/user/personalized-recommendations.webp";
import seamlessPlayback from "../images/smart_tv_images/features/user/seamless-playback.webp";
import userFriendlyInterface from "../images/smart_tv_images/features/user/user-friendly-interface.webp";
import voiceSearchSmartTv from "../images/smart_tv_images/features/user/voice-search.webp";
import watchlist from "../images/smart_tv_images/features/user/watchlist.webp";

import oilAndGasArVr from "../images/oil-and-gas-app-development_images/emerging/ar-vr.webp";
import oilAndGasArtificialIntelligence from "../images/oil-and-gas-app-development_images/emerging/artificial-intelligence.webp";
import oilAndGasBlockchain from "../images/oil-and-gas-app-development_images/emerging/blockchain.webp";
import oilAndGasDataScience from "../images/oil-and-gas-app-development_images/emerging/data-science.webp";
import oilAndGasInternetOfThings from "../images/oil-and-gas-app-development_images/emerging/internet-of-things.webp";
import oilAndGasMetaverse from "../images/oil-and-gas-app-development_images/emerging/metaverse.webp";

import oilAndGasAppDeployment from "../images/oil-and-gas-app-development_images/process/app-deployment.webp";
import oilAndGasDevelopment from "../images/oil-and-gas-app-development_images/process/development.webp";
import oilAndGasPlanning from "../images/oil-and-gas-app-development_images/process/planning.webp";
import oilAndGasSupportAndMaintenance from "../images/oil-and-gas-app-development_images/process/support-and-maintenance.webp";
import oilAndGasTesting from "../images/oil-and-gas-app-development_images/process/testing.webp";
import oilAndGasUiUxDesign from "../images/oil-and-gas-app-development_images/process/ui-ux-design.webp";

import assetManagementSolutions from "../images/oil-and-gas-app-development_images/solutions/asset-management-solutions.webp";
import downstreamSystemSolutions from "../images/oil-and-gas-app-development_images/solutions/downstream-system-solutions.webp";
import fieldDataCaptureApps from "../images/oil-and-gas-app-development_images/solutions/field-data-capture-apps.webp";
import midstreamSystemSolutions from "../images/oil-and-gas-app-development_images/solutions/midstream-system-solutions.webp";
import reservoirModelingApp from "../images/oil-and-gas-app-development_images/solutions/reservoir-modeling-app.webp";
import upstreamSystemSolutions from "../images/oil-and-gas-app-development_images/solutions/upstream-system-solutions.webp";

import automotiveArtificialIntelligence from "../images/automotive_app_development_images/emerging/artificial-intelligence.webp";
import automotiveBigData from "../images/automotive_app_development_images/emerging/big-data.webp";
import automotiveCloudComputing from "../images/automotive_app_development_images/emerging/cloud-computing.webp";
import automotiveInternetOfThings from "../images/automotive_app_development_images/emerging/internet-of-things.webp";
import automotiveMachineLearning from "../images/automotive_app_development_images/emerging/machine-learning.webp";
import automotiveMetaverse from "../images/automotive_app_development_images/emerging/metaverse.webp";

import automotiveDevelopment from "../images/automotive_app_development_images/process/development.webp";
import automotiveDiscovery from "../images/automotive_app_development_images/process/discovery.webp";
import automotiveLaunch from "../images/automotive_app_development_images/process/launch.webp";
import automotiveQualityAssurance from "../images/automotive_app_development_images/process/quality-assurance.webp";
import automotiveSupportAndMaintenance from "../images/automotive_app_development_images/process/support-and-maintenance.webp";
import automotiveUiUxDesign from "../images/automotive_app_development_images/process/ui-ux-design.webp";

import connectedCarAppDevelopment from "../images/automotive_app_development_images/solutions/connected-car-app-development.webp";
import embeddedSoftwareDevelopment from "../images/automotive_app_development_images/solutions/embedded-software-development.webp";
import fleetManagementSolutions from "../images/automotive_app_development_images/solutions/fleet-management-solutions.webp";
import infotainmentDevelopment from "../images/automotive_app_development_images/solutions/infotainment-development.webp";
import salesAndDealershipManagement from "../images/automotive_app_development_images/solutions/sales-and-dealership-management.webp";
import vehicleMaintenanceApp from "../images/automotive_app_development_images/solutions/vehicle-maintenance-app.webp";

import agricultureArtificialIntelligence from "../images/agriculture_app_development_images/emerging/artificial-intelligence.webp";
import agricultureBigData from "../images/agriculture_app_development_images/emerging/big-data.webp";
import agricultureBlockchain from "../images/agriculture_app_development_images/emerging/blockchain.webp";
import agricultureCloudComputing from "../images/agriculture_app_development_images/emerging/cloud-computing.webp";
import agricultureInternetOfThings from "../images/agriculture_app_development_images/emerging/internet-of-things.webp";
import agricultureMachineLearning from "../images/agriculture_app_development_images/emerging/machine-learning.webp";

import agricultureDeployment from "../images/agriculture_app_development_images/process/deployment.webp";
import agricultureDevelopment from "../images/agriculture_app_development_images/process/development.webp";
import agricultureMaintenanceSupport from "../images/agriculture_app_development_images/process/maintenance-support.webp";
import agricultureRequirementAnalysis from "../images/agriculture_app_development_images/process/requirement-analysis.webp";
import agricultureTesting from "../images/agriculture_app_development_images/process/testing.webp";
import agricultureUiUxDesign from "../images/agriculture_app_development_images/process/ui-ux-design.webp";

import farmAccountingApp from "../images/agriculture_app_development_images/solutions/farm-accounting-app.webp";
import farmManagementApp from "../images/agriculture_app_development_images/solutions/farm-management-app.webp";
import foodSafetyComplianceApp from "../images/agriculture_app_development_images/solutions/food-safety-compliance-app.webp";
import livestockManagementApp from "../images/agriculture_app_development_images/solutions/livestock-management-app.webp";
import precisionAgricultureApp from "../images/agriculture_app_development_images/solutions/precision-agriculture-app.webp";
import smartAgricultureApp from "../images/agriculture_app_development_images/solutions/smart-agriculture-app.webp";

//OTT Pages Image
import aiMlOtt from "../images/ott_images/emerging/ai-ml.webp";
import arVrOtt from "../images/ott_images/emerging/ar-vr.webp";
import blockchainOtt from "../images/ott_images/emerging/blockchain.webp";
import cloudComputingOtt from "../images/ott_images/emerging/cloud-computing.webp";
import dataAnalyticsOtt from "../images/ott_images/emerging/data-analytics.webp";

import contentControl from "../images/ott_images/feature/admin/content-control.webp";
import customDashboard from "../images/ott_images/feature/admin/custom-dashboard.webp";
import languageSupport from "../images/ott_images/feature/admin/language-support.webp";
import monetizationTools from "../images/ott_images/feature/admin/monetization-tools.webp";
import userManagementOtt from "../images/ott_images/feature/admin/user-management.webp";
import userSegmentation from "../images/ott_images/feature/admin/user-segmentation.webp";

import contentManagement from "../images/ott_images/feature/brand/content-management.webp";
import liveStreamMonitoring from "../images/ott_images/feature/brand/live-stream-monitoring.webp";
import monetization from "../images/ott_images/feature/brand/monetization.webp";
import multiLanguageSupport from "../images/ott_images/feature/brand/multi-language-support.webp";
import realTimeAnalytics from "../images/ott_images/feature/brand/real-time-analytics.webp";
import thirdPartyIntegration from "../images/ott_images/feature/brand/third-party-integration.webp";

import crossPlatformSupport from "../images/ott_images/feature/user/cross-platform-support.webp";
import liveTvStreaming from "../images/ott_images/feature/user/live-tv-streaming.webp";
import multiUserProfiles from "../images/ott_images/feature/user/multi-user-profiles.webp";
import pushNotificationsOtt from "../images/ott_images/feature/user/push-notifications.webp";
import resumeWatching from "../images/ott_images/feature/user/resume-watching.webp";
import socialSharingFeatures from "../images/ott_images/feature/user/social-sharing-features.webp";

import sportsArVr from "../images/sports_app_development_images/emerging/ar-vr.webp";
import sportsArtificialIntelligence from "../images/sports_app_development_images/emerging/artificial-intelligence.webp";
import sportsBigDataAnalytics from "../images/sports_app_development_images/emerging/big-data-analytics.webp";
import sportsBlockchain from "../images/sports_app_development_images/emerging/blockchain.webp";
import sportsCloudTechnology from "../images/sports_app_development_images/emerging/cloud-technology.webp";
import sportsMachineLearning from "../images/sports_app_development_images/emerging/machine-learning.webp";

import sportsDevelopment from "../images/sports_app_development_images/process/development.webp";
import sportsMaintenance from "../images/sports_app_development_images/process/maintenance.webp";
import sportsRequirementAnalysis from "../images/sports_app_development_images/process/requirement-analysis.webp";
import sportsTesting from "../images/sports_app_development_images/process/testing.webp";
import sportsUiUxDesign from "../images/sports_app_development_images/process/ui-ux-design.webp";
import sportsWireframing from "../images/sports_app_development_images/process/wireframing.webp";

import esportsMobileApp from "../images/sports_app_development_images/solutions/esports-mobile-app.webp";
import fantasySportsAppDevelopment from "../images/sports_app_development_images/solutions/fantasy-sports-app-development.webp";
import onlineSportsTicketBooking from "../images/sports_app_development_images/solutions/online-sports-ticket-booking.webp";
import sportsLeagueManagementApp from "../images/sports_app_development_images/solutions/sports-league-management-app.webp";
import sportsLiveStreamingApp from "../images/sports_app_development_images/solutions/sports-live-streaming-app.webp";
import sportsTrainingApp from "../images/sports_app_development_images/solutions/sports-training-app.webp";

//Laundry App Images
import arVrLaundryImages from "../images/laundry_app_images/emerging/ar-vr.webp";
import artificialIntelligenceLaundryImages from "../images/laundry_app_images/emerging/artificial-intelligence.webp";
import blockchainLaundryImages from "../images/laundry_app_images/emerging/blockchain.webp";
import cloudComputingLaundryImages from "../images/laundry_app_images/emerging/cloud-computing.webp";
import dataAnalyticsLaundryImages from "../images/laundry_app_images/emerging/data-analytics.webp";
import internetOfThingsLaundryImages from "../images/laundry_app_images/emerging/internet-of-things.webp";

import dashboardLaundryImages from "../images/laundry_app_images/features/admin/dashboard.webp";
import deliveryManagementLaundryImages from "../images/laundry_app_images/features/admin/delivery-management.webp";
import employeeManagementLaundryImages from "../images/laundry_app_images/features/admin/employee-management.webp";
import adminLoginLaundryImages from "../images/laundry_app_images/features/admin/login.webp";
import notificationsLaundryImages from "../images/laundry_app_images/features/admin/notifications.webp";
import userManagementLaundryImages from "../images/laundry_app_images/features/admin/user-management.webp";

import costCalculatorLaundryImages from "../images/laundry_app_images/features/customer/cost-calculator.webp";
import orderTrackingLaundryImages from "../images/laundry_app_images/features/customer/order-tracking.webp";
import customerRegistrationLaundryImages from "../images/laundry_app_images/features/customer/registration.webp";
import reviewRatingLaundryImages from "../images/laundry_app_images/features/customer/review-rating.webp";
import schedulePickupDeliveryLaundryImages from "../images/laundry_app_images/features/customer/schedule-pickup-delivery.webp";
import trackOrderHistoryLaundryImages from "../images/laundry_app_images/features/customer/track-order-history.webp";

import inAppNavigationLaundryImages from "../images/laundry_app_images/features/driver_panel/in-app-navigation.webp";
import driverLoginLaundryImages from "../images/laundry_app_images/features/driver_panel/login.webp";
import driverOrderHistoryLaundryImages from "../images/laundry_app_images/features/driver_panel/order-history.webp";
import orderRequestLaundryImages from "../images/laundry_app_images/features/driver_panel/order-request.webp";
import uploadDocumentsLaundryImages from "../images/laundry_app_images/features/driver_panel/upload-documents.webp";
import viewEarningsLaundryImages from "../images/laundry_app_images/features/driver_panel/view-earnings.webp";

import acceptDeclineOrderLaundryImages from "../images/laundry_app_images/features/service_provider/accept-decline-order.webp";
import serviceProviderLoginLaundryImages from "../images/laundry_app_images/features/service_provider/login.webp";
import manageChargesLaundryImages from "../images/laundry_app_images/features/service_provider/manage-charges.webp";
import manageOrderLaundryImages from "../images/laundry_app_images/features/service_provider/manage-order.webp";
import offersDiscountsLaundryImages from "../images/laundry_app_images/features/service_provider/offers-discounts.webp";
import serviceProviderOrderHistoryLaundryImages from "../images/laundry_app_images/features/service_provider/order-history.webp";

import aiMlVideoStreamingImage from "../images/video_streaming_images/emerging/ai-ml.webp";
import arVrVideoStreamingImage from "../images/video_streaming_images/emerging/ar-vr.webp";
import bigDataVideoStreamingImage from "../images/video_streaming_images/emerging/big-data.webp";
import blockchainVideoStreamingImage from "../images/video_streaming_images/emerging/blockchain.webp";
import cloudComputingVideoStreamingImage from "../images/video_streaming_images/emerging/cloud-computing.webp";
import internetOfThingsVideoStreamingImage from "../images/video_streaming_images/emerging/internet-of-things.webp";

import battleManagement from "../images/video_streaming_images/features/admin/battle-management.webp";
import paymentGateway from "../images/video_streaming_images/features/admin/payment-gateway.webp";
import reportsAnalyticsVideoStreamingImage from "../images/video_streaming_images/features/admin/reports-analytics.webp";
import topLiveStreaming from "../images/video_streaming_images/features/admin/top-live-streaming.webp";
import userLevelsManage from "../images/video_streaming_images/features/admin/user-levels-manage.webp";
import userManagementVideoStreamingImage from "../images/video_streaming_images/features/admin/user-management.webp";

import streaming247 from "../images/video_streaming_images/features/user/24-7-streaming.webp";
import battleAmongStreamers from "../images/video_streaming_images/features/user/battle-among-streamers.webp";
import createFamily from "../images/video_streaming_images/features/user/create-family.webp";
import manageProfiles from "../images/video_streaming_images/features/user/manage-profiles.webp";
import qualityControl from "../images/video_streaming_images/features/user/quality-control.webp";
import revenueGeneration from "../images/video_streaming_images/features/user/revenue-generation.webp";

//Flower App images
import arVrFlower from "../images/flower_delivery_images/emerging/ar-vr.webp";
import artificialIntelligenceFlower from "../images/flower_delivery_images/emerging/artificial-intelligence.webp";
import blockchainFlower from "../images/flower_delivery_images/emerging/blockchain.webp";
import cloudComputingFlower from "../images/flower_delivery_images/emerging/cloud-computing.webp";
import dataAnalyticsFlower from "../images/flower_delivery_images/emerging/data-analytics.webp";
import internetOfThingsFlower from "../images/flower_delivery_images/emerging/internet-of-things.webp";

import analyticsFlower from "../images/flower_delivery_images/features/admin/analytics.webp";
import categoryManagementFlower from "../images/flower_delivery_images/features/admin/category-management.webp";
import contentManagementSystemFlower from "../images/flower_delivery_images/features/admin/content-management-system.webp";
import deliveryBoyManagementFlower from "../images/flower_delivery_images/features/admin/delivery-boy-management.webp";
import manageCommissionFlower from "../images/flower_delivery_images/features/admin/manage-commission.webp";
import userManagementFlower from "../images/flower_delivery_images/features/admin/user-management.webp";

import customization from "../images/flower_delivery_images/features/customer/customization.webp";
import deliverySchedule from "../images/flower_delivery_images/features/customer/delivery-schedule.webp";
import orderPlacement from "../images/flower_delivery_images/features/customer/order-placement.webp";
import searchOptions from "../images/flower_delivery_images/features/customer/search-options.webp";
import securePaymentGateways from "../images/flower_delivery_images/features/customer/secure-payment-gateways.webp";
import trackOrder from "../images/flower_delivery_images/features/customer/track-order.webp";

import acceptRejectStatus from "../images/flower_delivery_images/features/shop/accept-reject-status.webp";
import accountOverview from "../images/flower_delivery_images/features/shop/account-overview.webp";
import manageDiscounts from "../images/flower_delivery_images/features/shop/manage-discounts.webp";
import orderStatus from "../images/flower_delivery_images/features/shop/order-status.webp";
import quickOrder from "../images/flower_delivery_images/features/shop/quick-order.webp";
import registration from "../images/flower_delivery_images/features/shop/registration.webp";

//Milk Delivery

import artificialIntelligenceMilkDeliveryImages from "../images/milk_delivery_images/emerging/artificial-intelligence.webp";
import bigDataAnalyticsMilkDeliveryImages from "../images/milk_delivery_images/emerging/big-data-analytics.webp";
import blockchainMilkDeliveryImages from "../images/milk_delivery_images/emerging/blockchain.webp";
import cloudComputingMilkDeliveryImages from "../images/milk_delivery_images/emerging/cloud-computing.webp";
import geolocationMilkDeliveryImages from "../images/milk_delivery_images/emerging/geolocation.webp";
import internetOfThingsMilkDeliveryImages from "../images/milk_delivery_images/emerging/internet-of-things.webp";

import customerManagement from "../images/milk_delivery_images/features/admin/customer-management.webp";
import driverManagement from "../images/milk_delivery_images/features/admin/driver-management.webp";
import masterDashboard from "../images/milk_delivery_images/features/admin/master-dashboard.webp";
import orderManagementAdmin from "../images/milk_delivery_images/features/admin/order-management.webp";
import productManagement from "../images/milk_delivery_images/features/admin/product-management.webp";
import subscriptionManagementMilkDeliveryImages from "../images/milk_delivery_images/features/admin/subscription-management.webp";

import advancedSearchBar from "../images/milk_delivery_images/features/customer/advanced-search-bar.webp";
import instantRegistration from "../images/milk_delivery_images/features/customer/instant-registration.webp";
import liveTracking from "../images/milk_delivery_images/features/customer/live-tracking.webp";
import multiplePaymentOptions from "../images/milk_delivery_images/features/customer/multiple-payment-options.webp";
import orderHistory from "../images/milk_delivery_images/features/customer/order-history.webp";
import userProfile from "../images/milk_delivery_images/features/customer/user-profile.webp";

import assignedOrders from "../images/milk_delivery_images/features/driver/assigned-orders.webp";
import customerDetails from "../images/milk_delivery_images/features/driver/customer-details.webp";
import deliveryManagement from "../images/milk_delivery_images/features/driver/delivery-management.webp";
import inAppCallChat from "../images/milk_delivery_images/features/driver/in-app-call-chat.webp";
import routeOptimization from "../images/milk_delivery_images/features/driver/route-optimization.webp";
import smartOnboarding from "../images/milk_delivery_images/features/driver/smart-onboarding.webp";

import deliveryCoordination from "../images/milk_delivery_images/features/store/delivery-coordination.webp";
import dynamicPricing from "../images/milk_delivery_images/features/store/dynamic-pricing.webp";
import multiStoreManagement from "../images/milk_delivery_images/features/store/multi-store-management.webp";
import orderManagementStore from "../images/milk_delivery_images/features/store/order-management.webp";
import productCatalog from "../images/milk_delivery_images/features/store/product-catalog.webp";
import profileManagementMilkDeliveryImages from "../images/milk_delivery_images/features/store/profile-management.webp";

//Grocery Delivery Images
import artificialIntelligenceGroceryDelivery from "../images/grocery_app_images/emerging/artificial-intelligence.webp";
import blockchainGroceryDelivery from "../images/grocery_app_images/emerging/blockchain.webp";
import cloudComputingGroceryDelivery from "../images/grocery_app_images/emerging/cloud-computing.webp";
import internetOfThingsGroceryDelivery from "../images/grocery_app_images/emerging/internet-of-things.webp";
import machineLearningGroceryDelivery from "../images/grocery_app_images/emerging/machine-learning.webp";
import voiceAssistantsGroceryDelivery from "../images/grocery_app_images/emerging/voice-assistants.webp";

import analyticsDashboardGroceryDelivery from "../images/grocery_app_images/features/admin/analytics-dashboard.webp";
import exclusiveDiscountsGroceryDelivery from "../images/grocery_app_images/features/admin/exclusive-discounts.webp";
import inAppWalletGroceryDelivery from "../images/grocery_app_images/features/admin/in-app-wallet.webp";
import manageOrdersGroceryDelivery from "../images/grocery_app_images/features/admin/manage-orders.webp";
import pushNotificationsGroceryDelivery from "../images/grocery_app_images/features/admin/push-notifications.webp";
import stockManagementGroceryDelivery from "../images/grocery_app_images/features/admin/stock-management.webp";

import availabilityStatusGroceryDelivery from "../images/grocery_app_images/features/driver/availability-status.webp";
import multipleOrderRequestsGroceryDelivery from "../images/grocery_app_images/features/driver/multiple-order-requests.webp";
import onlineTipsGroceryDelivery from "../images/grocery_app_images/features/driver/online-tips.webp";
import profileManagementGroceryDelivery from "../images/grocery_app_images/features/driver/profile-management.webp";
import reviewManagementGroceryDelivery from "../images/grocery_app_images/features/driver/review-management.webp";
import routeOptimizationGroceryDelivery from "../images/grocery_app_images/features/driver/route-optimization.webp";

import groceryCartGroceryDelivery from "../images/grocery_app_images/features/user/grocery-cart.webp";
import multiPaymentOptionsGroceryDelivery from "../images/grocery_app_images/features/user/multi-payment-options.webp";
import nearbyStoresGroceryDelivery from "../images/grocery_app_images/features/user/nearby-stores.webp";
import realTimeTrackingGroceryDelivery from "../images/grocery_app_images/features/user/real-time-tracking.webp";
import signupLoginGroceryDelivery from "../images/grocery_app_images/features/user/signup-login.webp";
import transactionHistoryGroceryDelivery from "../images/grocery_app_images/features/user/transaction-history.webp";
import wishlistGroceryDelivery from "../images/grocery_app_images/features/user/wishlist.webp";

import cancellationsRefundsGroceryDelivery from "../images/grocery_app_images/features/vendor/cancellations-refunds.webp";
import inventoryManagementGroceryDelivery from "../images/grocery_app_images/features/vendor/inventory-management.webp";
import liveTrackingGroceryDelivery from "../images/grocery_app_images/features/vendor/live-tracking.webp";
import productsListingGroceryDelivery from "../images/grocery_app_images/features/vendor/products-listing.webp";
import storeLocatorGroceryDelivery from "../images/grocery_app_images/features/vendor/store-locator.webp";
import storeVerificationGroceryDelivery from "../images/grocery_app_images/features/vendor/store-verification.webp";

import aiAndMl from "../images/insurance_mobile_app_development_images/emerging/ai-and-ml.webp";
import insuranceBigDataAnalytics from "../images/insurance_mobile_app_development_images/emerging/big-data-analytics.webp";
import insuranceBiometric from "../images/insurance_mobile_app_development_images/emerging/biometric.webp";
import insuranceBlockchain from "../images/insurance_mobile_app_development_images/emerging/blockchain.webp";
import insuranceCloudComputing from "../images/insurance_mobile_app_development_images/emerging/cloud-computing.webp";
import insuranceInternetOfThings from "../images/insurance_mobile_app_development_images/emerging/internet-of-things.webp";

import insuranceAppDevelopment from "../images/insurance_mobile_app_development_images/process/app-development.webp";
import insuranceDeployment from "../images/insurance_mobile_app_development_images/process/deployment.webp";
import insuranceRequirementAnalysis from "../images/insurance_mobile_app_development_images/process/requirement-analysis.webp";
import insuranceSupport from "../images/insurance_mobile_app_development_images/process/support.webp";
import insuranceTesting from "../images/insurance_mobile_app_development_images/process/testing.webp";
import insuranceUiUxDesign from "../images/insurance_mobile_app_development_images/process/ui-ux-design.webp";

import businessInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/business-insurance-apps.webp";
import carInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/car-insurance-apps.webp";
import healthInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/health-insurance-apps.webp";
import lifeInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/life-insurance-apps.webp";
import medicalInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/medical-insurance-apps.webp";
import propertyInsuranceApps from "../images/insurance_mobile_app_development_images/solutions/property-insurance-apps.webp";

import fantasyArtificialIntelligence from "../images/fantasy_sports_app_development_images/emerging/artificial-intelligence.webp";
import fantasyAugmentedReality from "../images/fantasy_sports_app_development_images/emerging/augmented-reality.webp";
import fantasyBlockchain from "../images/fantasy_sports_app_development_images/emerging/blockchain.webp";
import fantasyInternetOfThings from "../images/fantasy_sports_app_development_images/emerging/internet-of-things.webp";
import fantasyMachineLearning from "../images/fantasy_sports_app_development_images/emerging/machine-learning.webp";
import fantasyVirtualReality from "../images/fantasy_sports_app_development_images/emerging/virtual-reality.webp";

import adminDashboard from "../images/fantasy_sports_app_development_images/features/admin/admin-dashboard.webp";
import contestManagement from "../images/fantasy_sports_app_development_images/features/admin/contest-management.webp";
import revenueManagement from "../images/fantasy_sports_app_development_images/features/admin/revenue-management.webp";
import rewardPointsManagement from "../images/fantasy_sports_app_development_images/features/admin/reward-points-management.webp";
import fantasySignup from "../images/fantasy_sports_app_development_images/features/admin/signup.webp";
import fantasyUserManagement from "../images/fantasy_sports_app_development_images/features/admin/user-management.webp";

import commentaryFeed from "../images/fantasy_sports_app_development_images/features/features/commentary-feed.webp";
import creatingGroups from "../images/fantasy_sports_app_development_images/features/features/creating-groups.webp";
import gpsLocationTracking from "../images/fantasy_sports_app_development_images/features/features/gps-location-tracking.webp";
import fantasyInAppChat from "../images/fantasy_sports_app_development_images/features/features/in-app-chat.webp";
import matchResults from "../images/fantasy_sports_app_development_images/features/features/match-results.webp";
import scorePrediction from "../images/fantasy_sports_app_development_images/features/features/score-prediction.webp";

import inviteAndEarn from "../images/fantasy_sports_app_development_images/features/user/invite-and-earn.webp";
import liveScore from "../images/fantasy_sports_app_development_images/features/user/live-score.webp";
import multiplePaymentMethods from "../images/fantasy_sports_app_development_images/features/user/multiple-payment-methods.webp";
import paidAndPracticeContests from "../images/fantasy_sports_app_development_images/features/user/paid-and-practice-contests.webp";
import privateContest from "../images/fantasy_sports_app_development_images/features/user/private-contest.webp";
import userLogin from "../images/fantasy_sports_app_development_images/features/user/user-login.webp";

import electricArtificialIntelligence from "../images/electric_vehicle_app_development_images/emerging/artificial-intelligence.webp";
import electricBigDataAnalytics from "../images/electric_vehicle_app_development_images/emerging/big-data-analytics.webp";
import electricBlockchain from "../images/electric_vehicle_app_development_images/emerging/blockchain.webp";
import electricCloudComputing from "../images/electric_vehicle_app_development_images/emerging/cloud-computing.webp";
import electricInternetOfThings from "../images/electric_vehicle_app_development_images/emerging/internet-of-things.webp";
import electricMachineLearning from "../images/electric_vehicle_app_development_images/emerging/machine-learning.webp";

import electricAnalytics from "../images/electric_vehicle_app_development_images/features/admin/analytics.webp";
import electricCentralizedDashboard from "../images/electric_vehicle_app_development_images/features/admin/centralized-dashboard.webp";
import manageStationNetwork from "../images/electric_vehicle_app_development_images/features/admin/manage-station-network.webp";
import paymentOversight from "../images/electric_vehicle_app_development_images/features/admin/payment-oversight.webp";
import roleManagement from "../images/electric_vehicle_app_development_images/features/admin/role-management.webp";
import securityManagement from "../images/electric_vehicle_app_development_images/features/admin/security-management.webp";

import electricCustomerManagement from "../images/electric_vehicle_app_development_images/features/owner/customer-management.webp";
import electricEarningsDashboard from "../images/electric_vehicle_app_development_images/features/owner/earnings-dashboard.webp";
import maintenanceAndAlerts from "../images/electric_vehicle_app_development_images/features/owner/maintenance-and-alerts.webp";
import monitorStationPerformance from "../images/electric_vehicle_app_development_images/features/owner/monitor-station-performance.webp";
import remoteControl from "../images/electric_vehicle_app_development_images/features/owner/remote-control.webp";
import slotManagement from "../images/electric_vehicle_app_development_images/features/owner/slot-management.webp";

import chargingHistory from "../images/electric_vehicle_app_development_images/features/user/charging-history.webp";
import chargingStationFinder from "../images/electric_vehicle_app_development_images/features/user/charging-station-finder.webp";
import liveChargingStatus from "../images/electric_vehicle_app_development_images/features/user/live-charging-status.webp";
import electricMultiplePaymentOptions from "../images/electric_vehicle_app_development_images/features/user/multiple-payment-options.webp";
import electricPushNotifications from "../images/electric_vehicle_app_development_images/features/user/push-notifications.webp";
import slotBooking from "../images/electric_vehicle_app_development_images/features/user/slot-booking.webp";

import evArtificialIntelligence from "../images/ev_charging_app_development_images/emerging/artificial-intelligence.webp";
import evBigDataAnalytics from "../images/ev_charging_app_development_images/emerging/big-data-analytics.webp";
import evBlockchain from "../images/ev_charging_app_development_images/emerging/blockchain.webp";
import evCloudComputing from "../images/ev_charging_app_development_images/emerging/cloud-computing.webp";
import evInternetOfThings from "../images/ev_charging_app_development_images/emerging/internet-of-things.webp";
import evMachineLearning from "../images/ev_charging_app_development_images/emerging/machine-learning.webp";

import evAdvancedAnalytics from "../images/ev_charging_app_development_images/features/advanced/advanced-analytics.webp";
import evAiRoutePlanning from "../images/ev_charging_app_development_images/features/advanced/ai-route-planning.webp";
import evGreenEnergyIntegration from "../images/ev_charging_app_development_images/features/advanced/green-energy-integration.webp";
import evMultiLanguageSupport from "../images/ev_charging_app_development_images/features/advanced/multi-language-support.webp";
import evPredictiveMaintenance from "../images/ev_charging_app_development_images/features/advanced/predictive-maintenance.webp";
import evVoiceAssistance from "../images/ev_charging_app_development_images/features/advanced/voice-assistance.webp";

import evDynamicPricing from "../images/ev_charging_app_development_images/features/owner/dynamic-pricing.webp";
import energyMonitoring from "../images/ev_charging_app_development_images/features/owner/energy-monitoring.webp";
import remoteTroubleshooting from "../images/ev_charging_app_development_images/features/owner/remote-troubleshooting.webp";
import revenueDashboard from "../images/ev_charging_app_development_images/features/owner/revenue-dashboard.webp";
import staffManagement from "../images/ev_charging_app_development_images/features/owner/staff-management.webp";
import stationManagement from "../images/ev_charging_app_development_images/features/owner/station-management.webp";

import evChargingHistory from "../images/ev_charging_app_development_images/features/user/charging-history.webp";
import easyStationFinder from "../images/ev_charging_app_development_images/features/user/easy-station-finder.webp";
import loyaltyRewards from "../images/ev_charging_app_development_images/features/user/loyalty-rewards.webp";
import evRealTimeNotifications from "../images/ev_charging_app_development_images/features/user/real-time-notifications.webp";
import seamlessPayments from "../images/ev_charging_app_development_images/features/user/seamless-payments.webp";
import smartBooking from "../images/ev_charging_app_development_images/features/user/smart-booking.webp";

//Medicine Delivery Images
import aiMlMedicineDelivery from "../images/medicine_delivery_images/emerging/ai-ml.webp";
import blockchainMedicineDelivery from "../images/medicine_delivery_images/emerging/blockchain.webp";
import chatbotsMedicineDelivery from "../images/medicine_delivery_images/emerging/chatbots.webp";
import chatgptMedicineDelivery from "../images/medicine_delivery_images/emerging/chatgpt.webp";
import cloudComputingMedicineDelivery from "../images/medicine_delivery_images/emerging/cloud-computing.webp";
import iomtIntegrationMedicineDelivery from "../images/medicine_delivery_images/emerging/iomt-integration.webp";

import analyticsReport from "../images/medicine_delivery_images/features/admin_panel/analytics-report.webp";
import dashboardView from "../images/medicine_delivery_images/features/admin_panel/dashboard-view.webp";
import manageCustomers from "../images/medicine_delivery_images/features/admin_panel/manage-customers.webp";
import manageDrivers from "../images/medicine_delivery_images/features/admin_panel/manage-drivers.webp";
import managePharmacies from "../images/medicine_delivery_images/features/admin_panel/manage-pharmacies.webp";
import offersAndDiscounts from "../images/medicine_delivery_images/features/admin_panel/offers-and-discounts.webp";

import addToCart from "../images/medicine_delivery_images/features/customer_panel/add-to-cart.webp";
import easyLogin from "../images/medicine_delivery_images/features/customer_panel/easy-login.webp";
import multiplePaymentOptionsMedicineDelivery from "../images/medicine_delivery_images/features/customer_panel/multiple-payment-options.webp";
import orderTracking from "../images/medicine_delivery_images/features/customer_panel/order-tracking.webp";
import customerPushNotifications from "../images/medicine_delivery_images/features/customer_panel/push-notifications.webp";
import searchMedicines from "../images/medicine_delivery_images/features/customer_panel/search-medicines.webp";

import acceptDelivery from "../images/medicine_delivery_images/features/driver_panel/accept-delivery.webp";
import checkPaymentStatus from "../images/medicine_delivery_images/features/driver_panel/check-payment-status.webp";
import driverProfile from "../images/medicine_delivery_images/features/driver_panel/driver-profile.webp";
import gpsNavigationMap from "../images/medicine_delivery_images/features/driver_panel/gps-navigation-map.webp";
import driverPushNotifications from "../images/medicine_delivery_images/features/driver_panel/push-notifications.webp";
import routeOptimizationMedicineDelivery from "../images/medicine_delivery_images/features/driver_panel/route-optimization.webp";

import customerRelationshipManagement from "../images/medicine_delivery_images/features/pharmacy_panel/customer-relationship-management.webp";
import deliveryManagementMedicineDelivery from "../images/medicine_delivery_images/features/pharmacy_panel/delivery-management.webp";
import inventoryManagement from "../images/medicine_delivery_images/features/pharmacy_panel/inventory-management.webp";
import orderProcessing from "../images/medicine_delivery_images/features/pharmacy_panel/order-processing.webp";
import promotionsAndDiscounts from "../images/medicine_delivery_images/features/pharmacy_panel/promotions-and-discounts.webp";
import salesAndAnalytics from "../images/medicine_delivery_images/features/pharmacy_panel/sales-and-analytics.webp";

// Courier Images
import aiCourier from "../images/courier_delivery_images/emerging/ai.webp";
import arVrCourier from "../images/courier_delivery_images/emerging/ar-vr.webp";
import blockchainCourier from "../images/courier_delivery_images/emerging/blockchain.webp";
import cloudComputingCourier from "../images/courier_delivery_images/emerging/cloud-computing.webp";
import dataAnalyticsCourier from "../images/courier_delivery_images/emerging/data-analytics.webp";
import iotCourier from "../images/courier_delivery_images/emerging/iot.webp";

import addCities from "../images/courier_delivery_images/features/admin/add-cities.webp";
import manageDelivery from "../images/courier_delivery_images/features/admin/manage-delivery.webp";
import manageDriverDetails from "../images/courier_delivery_images/features/admin/manage-driver-details.webp";
import manageOrder from "../images/courier_delivery_images/features/admin/manage-order.webp";
import setServiceArea from "../images/courier_delivery_images/features/admin/set-service-area.webp";
import vehicleManagement from "../images/courier_delivery_images/features/admin/vehicle-management.webp";

import createProfile from "../images/courier_delivery_images/features/rider/create-profile.webp";
import earningDetails from "../images/courier_delivery_images/features/rider/earning-details.webp";
import history from "../images/courier_delivery_images/features/rider/history.webp";
import navigation from "../images/courier_delivery_images/features/rider/navigation.webp";
import routeOptimizationCourier from "../images/courier_delivery_images/features/rider/route-optimization.webp";
import submitDocuments from "../images/courier_delivery_images/features/rider/submit-documents.webp";

import changeAddress from "../images/courier_delivery_images/features/user/change-address.webp";
import digitalPayment from "../images/courier_delivery_images/features/user/digital-payment.webp";
import notificationsCourier from "../images/courier_delivery_images/features/user/notifications.webp";
import pickDestination from "../images/courier_delivery_images/features/user/pick-destination.webp";
import realTimeTracking from "../images/courier_delivery_images/features/user/real-time-tracking.webp";
import registerSignup from "../images/courier_delivery_images/features/user/register-signup.webp";

import magazineAiMl from "../images/magazine_and_newspaper_app_development_images/emerging/ai-ml.webp";
import magazineArVr from "../images/magazine_and_newspaper_app_development_images/emerging/ar-vr.webp";
import magazineBigDataAnalytics from "../images/magazine_and_newspaper_app_development_images/emerging/big-data-analytics.webp";
import magazineBlockchain from "../images/magazine_and_newspaper_app_development_images/emerging/blockchain.webp";
import magazineCloudComputing from "../images/magazine_and_newspaper_app_development_images/emerging/cloud-computing.webp";
import magazineInternetOfThings from "../images/magazine_and_newspaper_app_development_images/emerging/internet-of-things.webp";

import magazineAdminDashboard from "../images/magazine_and_newspaper_app_development_images/features/admin/admin-dashboard.webp";
import magazineChatSupport from "../images/magazine_and_newspaper_app_development_images/features/admin/chat-support.webp";
import magazineProfileManagement from "../images/magazine_and_newspaper_app_development_images/features/admin/profile-management.webp";
import magazinePushNotifications from "../images/magazine_and_newspaper_app_development_images/features/admin/push-notifications.webp";
import magazineReportsAnalytics from "../images/magazine_and_newspaper_app_development_images/features/admin/reports-analytics.webp";
import magazineUserRestriction from "../images/magazine_and_newspaper_app_development_images/features/admin/user-restriction.webp";

import magazineLiveTv from "../images/magazine_and_newspaper_app_development_images/features/user/live-tv.webp";
import magazineNewsCategories from "../images/magazine_and_newspaper_app_development_images/features/user/news-categories.webp";
import magazineUserProfileManagement from "../images/magazine_and_newspaper_app_development_images/features/user/profile-management.webp";
import magazineUserPushNotifications from "../images/magazine_and_newspaper_app_development_images/features/user/push-notifications.webp";
import magazineSearchFilters from "../images/magazine_and_newspaper_app_development_images/features/user/search-filters.webp";
import magazineSignUp from "../images/magazine_and_newspaper_app_development_images/features/user/sign-up.webp";

import stockArtificialIntelligence from "../images/stock_trading_app_development_images/emerging/artificial-intelligence.webp";
import stockBigDataAnalytics from "../images/stock_trading_app_development_images/emerging/big-data-analytics.webp";
import stockBlockchain from "../images/stock_trading_app_development_images/emerging/blockchain.webp";
import stockCloudComputing from "../images/stock_trading_app_development_images/emerging/cloud-computing.webp";
import stockInternetOfThings from "../images/stock_trading_app_development_images/emerging/internet-of-things.webp";
import stockMachineLearning from "../images/stock_trading_app_development_images/emerging/machine-learning.webp";

import advertisingManagement from "../images/stock_trading_app_development_images/features/admin/advertising-management.webp";
import brandConnectivity from "../images/stock_trading_app_development_images/features/admin/brand-connectivity.webp";
import centralizedControl from "../images/stock_trading_app_development_images/features/admin/centralized-control.webp";
import stockPushNotifications from "../images/stock_trading_app_development_images/features/admin/push-notifications.webp";
import stockRevenueManagement from "../images/stock_trading_app_development_images/features/admin/revenue-management.webp";
import stockUserManagement from "../images/stock_trading_app_development_images/features/admin/user-management.webp";

import clientManagement from "../images/stock_trading_app_development_images/features/broker/client-management.webp";
import stockCommissionManagement from "../images/stock_trading_app_development_images/features/broker/commission-management.webp";
import stockCommunicationTools from "../images/stock_trading_app_development_images/features/broker/communication-tools.webp";
import marketInsightsAccess from "../images/stock_trading_app_development_images/features/broker/market-insights-access.webp";
import riskManagementTools from "../images/stock_trading_app_development_images/features/broker/risk-management-tools.webp";
import tradeMonitoring from "../images/stock_trading_app_development_images/features/broker/trade-monitoring.webp";

import accountManagement from "../images/stock_trading_app_development_images/features/trader/account-management.webp";
import orderInput from "../images/stock_trading_app_development_images/features/trader/order-input.webp";
import portfolioOverview from "../images/stock_trading_app_development_images/features/trader/portfolio-overview.webp";
import realTimeData from "../images/stock_trading_app_development_images/features/trader/real-time-data.webp";
import researchAndEvaluation from "../images/stock_trading_app_development_images/features/trader/research-and-evaluation.webp";
import stockUserAuthentication from "../images/stock_trading_app_development_images/features/trader/user-authentication.webp";

import carRentalAiMl from "../images/car_rental_app_development_images/emerging/ai-ml.webp";
import carRentalBigDataAnalytics from "../images/car_rental_app_development_images/emerging/big-data-analytics.webp";
import carRentalBlockchain from "../images/car_rental_app_development_images/emerging/blockchain.webp";
import carRentalCloudComputing from "../images/car_rental_app_development_images/emerging/cloud-computing.webp";
import carRentalGenAi from "../images/car_rental_app_development_images/emerging/gen-ai.webp";
import carRentalInternetOfThings from "../images/car_rental_app_development_images/emerging/internet-of-things.webp";

import carRentalDashboard from "../images/car_rental_app_development_images/features/admin/dashboard.webp";
import manageCarOwners from "../images/car_rental_app_development_images/features/admin/manage-car-owners.webp";
import carRentalManageCustomers from "../images/car_rental_app_development_images/features/admin/manage-customers.webp";
import rentalManagement from "../images/car_rental_app_development_images/features/admin/rental-management.webp";
import carRentalReportsAnalytics from "../images/car_rental_app_development_images/features/admin/reports-analytics.webp";
import reputationManagement from "../images/car_rental_app_development_images/features/admin/reputation-management.webp";

import calendarView from "../images/car_rental_app_development_images/features/owner/calendar-view.webp";
import manageRequests from "../images/car_rental_app_development_images/features/owner/manage-requests.webp";
import rateSummary from "../images/car_rental_app_development_images/features/owner/rate-summary.webp";
import carRentalRegister from "../images/car_rental_app_development_images/features/owner/register.webp";
import toDoSummary from "../images/car_rental_app_development_images/features/owner/to-do-summary.webp";
import vehicleTracking from "../images/car_rental_app_development_images/features/owner/vehicle-tracking.webp";

import bookACar from "../images/car_rental_app_development_images/features/user/book-a-car.webp";
import browseCars from "../images/car_rental_app_development_images/features/user/browse-cars.webp";
import carRentalEasyPayments from "../images/car_rental_app_development_images/features/user/easy-payments.webp";
import fareEstimation from "../images/car_rental_app_development_images/features/user/fare-estimation.webp";
import carRentalRatingsFeedback from "../images/car_rental_app_development_images/features/user/ratings-feedback.webp";
import carRentalSignUp from "../images/car_rental_app_development_images/features/user/sign-up.webp";
import defaultBannerImage from "../images/kis-banner.webp";
import award24 from "../images/awards/rightfirms-badge-categories.webp";
import aiCaseStudy from "../images/ai-case-study.svg";

export const Images = {
  ...sharedImages,
  carRentalEmerging: {
    carRentalAiMl,
    carRentalBigDataAnalytics,
    carRentalBlockchain,
    carRentalCloudComputing,
    carRentalGenAi,
    carRentalInternetOfThings,
  },

  carRentalFeatures: {
    admin: {
      carRentalDashboard,
      manageCarOwners,
      carRentalManageCustomers,
      rentalManagement,
      carRentalReportsAnalytics,
      reputationManagement,
    },
    owner: {
      calendarView,
      manageRequests,
      rateSummary,
      carRentalRegister,
      toDoSummary,
      vehicleTracking,
    },
    user: {
      bookACar,
      browseCars,
      carRentalEasyPayments,
      fareEstimation,
      carRentalRatingsFeedback,
      carRentalSignUp,
    },
  },

  stockEmerging: {
    stockArtificialIntelligence,
    stockBigDataAnalytics,
    stockBlockchain,
    stockCloudComputing,
    stockInternetOfThings,
    stockMachineLearning,
  },

  stockFeatures: {
    admin: {
      advertisingManagement,
      brandConnectivity,
      centralizedControl,
      stockPushNotifications,
      stockRevenueManagement,
      stockUserManagement,
    },
    broker: {
      clientManagement,
      stockCommissionManagement,
      stockCommunicationTools,
      marketInsightsAccess,
      riskManagementTools,
      tradeMonitoring,
    },
    trader: {
      accountManagement,
      orderInput,
      portfolioOverview,
      realTimeData,
      researchAndEvaluation,
      stockUserAuthentication,
    },
  },

  magazineEmerging: {
    magazineAiMl,
    magazineArVr,
    magazineBigDataAnalytics,
    magazineBlockchain,
    magazineCloudComputing,
    magazineInternetOfThings,
  },

  magazineFeatures: {
    admin: {
      magazineAdminDashboard,
      magazineChatSupport,
      magazineProfileManagement,
      magazinePushNotifications,
      magazineReportsAnalytics,
      magazineUserRestriction,
    },
    user: {
      magazineLiveTv,
      magazineNewsCategories,
      magazineUserProfileManagement,
      magazineUserPushNotifications,
      magazineSearchFilters,
      magazineSignUp,
    },
  },

  courierDeliveryImages: {
    emerging: {
      aiCourier,
      arVrCourier,
      blockchainCourier,
      cloudComputingCourier,
      dataAnalyticsCourier,
      iotCourier,
    },

    features: {
      admin: {
        addCities,
        manageDelivery,
        manageDriverDetails,
        manageOrder,
        setServiceArea,
        vehicleManagement,
      },

      rider: {
        createProfile,
        earningDetails,
        history,
        navigation,
        routeOptimizationCourier,
        submitDocuments,
      },

      user: {
        changeAddress,
        digitalPayment,
        notificationsCourier,
        pickDestination,
        realTimeTracking,
        registerSignup,
      },
    },
  },

  medicineDeliveryImages: {
    emerging: {
      aiMlMedicineDelivery,
      blockchainMedicineDelivery,
      chatbotsMedicineDelivery,
      chatgptMedicineDelivery,
      cloudComputingMedicineDelivery,
      iomtIntegrationMedicineDelivery,
    },

    features: {
      adminPanel: {
        analyticsReport,
        dashboardView,
        manageCustomers,
        manageDrivers,
        managePharmacies,
        offersAndDiscounts,
      },

      customerPanel: {
        addToCart,
        easyLogin,
        multiplePaymentOptionsMedicineDelivery,
        orderTracking,
        customerPushNotifications,
        searchMedicines,
      },

      driverPanel: {
        acceptDelivery,
        checkPaymentStatus,
        driverProfile,
        gpsNavigationMap,
        driverPushNotifications,
        routeOptimizationMedicineDelivery,
      },

      pharmacyPanel: {
        customerRelationshipManagement,
        deliveryManagementMedicineDelivery,
        inventoryManagement,
        orderProcessing,
        promotionsAndDiscounts,
        salesAndAnalytics,
      },
    },
  },

  evEmerging: {
    evArtificialIntelligence,
    evBigDataAnalytics,
    evBlockchain,
    evCloudComputing,
    evInternetOfThings,
    evMachineLearning,
  },

  evFeatures: {
    advanced: {
      evAdvancedAnalytics,
      evAiRoutePlanning,
      evGreenEnergyIntegration,
      evMultiLanguageSupport,
      evPredictiveMaintenance,
      evVoiceAssistance,
    },
    owner: {
      evDynamicPricing,
      energyMonitoring,
      remoteTroubleshooting,
      revenueDashboard,
      staffManagement,
      stationManagement,
    },
    user: {
      evChargingHistory,
      easyStationFinder,
      loyaltyRewards,
      evRealTimeNotifications,
      seamlessPayments,
      smartBooking,
    },
  },

  electricEmerging: {
    electricArtificialIntelligence,
    electricBigDataAnalytics,
    electricBlockchain,
    electricCloudComputing,
    electricInternetOfThings,
    electricMachineLearning,
  },

  electricFeatures: {
    admin: {
      electricAnalytics,
      electricCentralizedDashboard,
      manageStationNetwork,
      paymentOversight,
      roleManagement,
      securityManagement,
    },
    owner: {
      electricCustomerManagement,
      electricEarningsDashboard,
      maintenanceAndAlerts,
      monitorStationPerformance,
      remoteControl,
      slotManagement,
    },
    user: {
      chargingHistory,
      chargingStationFinder,
      liveChargingStatus,
      electricMultiplePaymentOptions,
      electricPushNotifications,
      slotBooking,
    },
  },

  fantasyEmerging: {
    fantasyArtificialIntelligence,
    fantasyAugmentedReality,
    fantasyBlockchain,
    fantasyInternetOfThings,
    fantasyMachineLearning,
    fantasyVirtualReality,
  },

  fantasyFeatures: {
    admin: {
      adminDashboard,
      contestManagement,
      revenueManagement,
      rewardPointsManagement,
      fantasySignup,
      fantasyUserManagement,
    },
    features: {
      commentaryFeed,
      creatingGroups,
      gpsLocationTracking,
      fantasyInAppChat,
      matchResults,
      scorePrediction,
    },
    user: {
      inviteAndEarn,
      liveScore,
      multiplePaymentMethods,
      paidAndPracticeContests,
      privateContest,
      userLogin,
    },
  },

  insuranceEmerging: {
    aiAndMl,
    insuranceBigDataAnalytics,
    insuranceBiometric,
    insuranceBlockchain,
    insuranceCloudComputing,
    insuranceInternetOfThings,
  },

  insuranceProcess: {
    insuranceAppDevelopment,
    insuranceDeployment,
    insuranceRequirementAnalysis,
    insuranceSupport,
    insuranceTesting,
    insuranceUiUxDesign,
  },

  insuranceSolutions: {
    businessInsuranceApps,
    carInsuranceApps,
    healthInsuranceApps,
    lifeInsuranceApps,
    medicalInsuranceApps,
    propertyInsuranceApps,
  },

  groceryAppImages: {
    emerging: {
      artificialIntelligenceGroceryDelivery,
      blockchainGroceryDelivery,
      cloudComputingGroceryDelivery,
      internetOfThingsGroceryDelivery,
      machineLearningGroceryDelivery,
      voiceAssistantsGroceryDelivery,
    },

    features: {
      admin: {
        analyticsDashboardGroceryDelivery,
        exclusiveDiscountsGroceryDelivery,
        inAppWalletGroceryDelivery,
        manageOrdersGroceryDelivery,
        pushNotificationsGroceryDelivery,
        stockManagementGroceryDelivery,
      },

      driver: {
        availabilityStatusGroceryDelivery,
        multipleOrderRequestsGroceryDelivery,
        onlineTipsGroceryDelivery,
        profileManagementGroceryDelivery,
        reviewManagementGroceryDelivery,
        routeOptimizationGroceryDelivery,
      },

      user: {
        groceryCartGroceryDelivery,
        multiPaymentOptionsGroceryDelivery,
        nearbyStoresGroceryDelivery,
        realTimeTrackingGroceryDelivery,
        signupLoginGroceryDelivery,
        transactionHistoryGroceryDelivery,
        wishlistGroceryDelivery,
      },

      vendor: {
        cancellationsRefundsGroceryDelivery,
        inventoryManagementGroceryDelivery,
        liveTrackingGroceryDelivery,
        productsListingGroceryDelivery,
        storeLocatorGroceryDelivery,
        storeVerificationGroceryDelivery,
      },
    },
  },

  milkDeliveryImages: {
    emerging: {
      artificialIntelligenceMilkDeliveryImages,
      bigDataAnalyticsMilkDeliveryImages,
      blockchainMilkDeliveryImages,
      cloudComputingMilkDeliveryImages,
      geolocationMilkDeliveryImages,
      internetOfThingsMilkDeliveryImages,
    },

    features: {
      admin: {
        customerManagement,
        driverManagement,
        masterDashboard,
        orderManagementAdmin,
        productManagement,
        subscriptionManagementMilkDeliveryImages,
      },

      customer: {
        advancedSearchBar,
        instantRegistration,
        liveTracking,
        multiplePaymentOptions,
        orderHistory,
        userProfile,
      },

      driver: {
        assignedOrders,
        customerDetails,
        deliveryManagement,
        inAppCallChat,
        routeOptimization,
        smartOnboarding,
      },

      store: {
        deliveryCoordination,
        dynamicPricing,
        multiStoreManagement,
        orderManagementStore,
        productCatalog,
        profileManagementMilkDeliveryImages,
      },
    },
  },

  flowerDeliveryImages: {
    emerging: {
      arVrFlower,
      artificialIntelligenceFlower,
      blockchainFlower,
      cloudComputingFlower,
      dataAnalyticsFlower,
      internetOfThingsFlower,
    },

    features: {
      admin: {
        analyticsFlower,
        categoryManagementFlower,
        contentManagementSystemFlower,
        deliveryBoyManagementFlower,
        manageCommissionFlower,
        userManagementFlower,
      },

      customer: {
        customization,
        deliverySchedule,
        orderPlacement,
        searchOptions,
        securePaymentGateways,
        trackOrder,
      },

      shop: {
        acceptRejectStatus,
        accountOverview,
        manageDiscounts,
        orderStatus,
        quickOrder,
        registration,
      },
    },
  },

  sportsEmerging: {
    sportsArVr,
    sportsArtificialIntelligence,
    sportsBigDataAnalytics,
    sportsBlockchain,
    sportsCloudTechnology,
    sportsMachineLearning,
  },

  sportsProcess: {
    sportsDevelopment,
    sportsMaintenance,
    sportsRequirementAnalysis,
    sportsTesting,
    sportsUiUxDesign,
    sportsWireframing,
  },

  sportsSolutions: {
    esportsMobileApp,
    fantasySportsAppDevelopment,
    onlineSportsTicketBooking,
    sportsLeagueManagementApp,
    sportsLiveStreamingApp,
    sportsTrainingApp,
  },

  agricultureEmerging: {
    agricultureArtificialIntelligence,
    agricultureBigData,
    agricultureBlockchain,
    agricultureCloudComputing,
    agricultureInternetOfThings,
    agricultureMachineLearning,
  },

  agricultureProcess: {
    agricultureDeployment,
    agricultureDevelopment,
    agricultureMaintenanceSupport,
    agricultureRequirementAnalysis,
    agricultureTesting,
    agricultureUiUxDesign,
  },

  agricultureSolutions: {
    farmAccountingApp,
    farmManagementApp,
    foodSafetyComplianceApp,
    livestockManagementApp,
    precisionAgricultureApp,
    smartAgricultureApp,
  },

  automotiveEmerging: {
    automotiveArtificialIntelligence,
    automotiveBigData,
    automotiveCloudComputing,
    automotiveInternetOfThings,
    automotiveMachineLearning,
    automotiveMetaverse,
  },

  automotiveProcess: {
    automotiveDevelopment,
    automotiveDiscovery,
    automotiveLaunch,
    automotiveQualityAssurance,
    automotiveSupportAndMaintenance,
    automotiveUiUxDesign,
  },

  automotiveSolutions: {
    connectedCarAppDevelopment,
    embeddedSoftwareDevelopment,
    fleetManagementSolutions,
    infotainmentDevelopment,
    salesAndDealershipManagement,
    vehicleMaintenanceApp,
  },

  oilAndGasEmerging: {
    oilAndGasArVr,
    oilAndGasArtificialIntelligence,
    oilAndGasBlockchain,
    oilAndGasDataScience,
    oilAndGasInternetOfThings,
    oilAndGasMetaverse,
  },

  oilAndGasProcess: {
    oilAndGasAppDeployment,
    oilAndGasDevelopment,
    oilAndGasPlanning,
    oilAndGasSupportAndMaintenance,
    oilAndGasTesting,
    oilAndGasUiUxDesign,
  },

  oilAndGasSolutions: {
    assetManagementSolutions,
    downstreamSystemSolutions,
    fieldDataCaptureApps,
    midstreamSystemSolutions,
    reservoirModelingApp,
    upstreamSystemSolutions,
  },

  videoStreamingImages: {
    emerging: {
      aiMlVideoStreamingImage,
      arVrVideoStreamingImage,
      bigDataVideoStreamingImage,
      blockchainVideoStreamingImage,
      cloudComputingVideoStreamingImage,
      internetOfThingsVideoStreamingImage,
    },

    features: {
      admin: {
        battleManagement,
        paymentGateway,
        reportsAnalyticsVideoStreamingImage,
        topLiveStreaming,
        userLevelsManage,
        userManagementVideoStreamingImage,
      },

      user: {
        streaming247,
        battleAmongStreamers,
        createFamily,
        manageProfiles,
        qualityControl,
        revenueGeneration,
      },
    },
  },

  laundryAppImages: {
    emerging: {
      arVrLaundryImages,
      artificialIntelligenceLaundryImages,
      blockchainLaundryImages,
      cloudComputingLaundryImages,
      dataAnalyticsLaundryImages,
      internetOfThingsLaundryImages,
    },

    features: {
      admin: {
        dashboardLaundryImages,
        deliveryManagementLaundryImages,
        employeeManagementLaundryImages,
        adminLoginLaundryImages,
        notificationsLaundryImages,
        userManagementLaundryImages,
      },

      customer: {
        costCalculatorLaundryImages,
        orderTrackingLaundryImages,
        customerRegistrationLaundryImages,
        reviewRatingLaundryImages,
        schedulePickupDeliveryLaundryImages,
        trackOrderHistoryLaundryImages,
      },

      driverPanel: {
        inAppNavigationLaundryImages,
        driverLoginLaundryImages,
        driverOrderHistoryLaundryImages,
        orderRequestLaundryImages,
        uploadDocumentsLaundryImages,
        viewEarningsLaundryImages,
      },

      serviceProvider: {
        acceptDeclineOrderLaundryImages,
        serviceProviderLoginLaundryImages,
        manageChargesLaundryImages,
        manageOrderLaundryImages,
        offersDiscountsLaundryImages,
        serviceProviderOrderHistoryLaundryImages,
      },
    },
  },

  ottImages: {
    emerging: {
      aiMlOtt,
      arVrOtt,
      blockchainOtt,
      cloudComputingOtt,
      dataAnalyticsOtt,
    },

    feature: {
      admin: {
        contentControl,
        customDashboard,
        languageSupport,
        monetizationTools,
        userManagementOtt,
        userSegmentation,
      },

      brand: {
        contentManagement,
        liveStreamMonitoring,
        monetization,
        multiLanguageSupport,
        realTimeAnalytics,
        thirdPartyIntegration,
      },

      user: {
        crossPlatformSupport,
        liveTvStreaming,
        multiUserProfiles,
        pushNotificationsOtt,
        resumeWatching,
        socialSharingFeatures,
      },
    },
  },

  smartTvImages: {
    emerging: {
      artificialIntelligenceSmartTv,
      bigDataAnalyticsSmartTv,
      blockchainSmartTv,
      chatbotsSmartTv,
      cloudComputingSmartTv,
      internetOfThingsSmartTv,
    },

    features: {
      admin: {
        contentModeration,
        performanceMonitoring,
        securityControl,
        subscriptionManagementSmartTv,
        systemConfiguration,
        userManagementSmartTv,
      },

      brandPanel: {
        analyticsDashboard,
        contentScheduling,
        contentUpload,
        customBranding,
        engagementTools,
        multiRegionContent,
      },

      user: {
        multiProfileSupport,
        personalizedRecommendations,
        seamlessPlayback,
        userFriendlyInterface,
        voiceSearchSmartTv,
        watchlist,
      },
    },
  },

  edtechImages: {
    emerging: {
      aiMlEdtech,
      arVrlEdtech,
      bigData,
      blockchainlEdtech,
      cloudComputinglEdtech,
      internetOfThingslEdtech,
    },

    features: {
      admin: {
        manageContent,
        manageSubjects,
        manageSubscriptions,
        manageTeachersStudents,
        studentInformation,
        viewReports,
      },

      student: {
        availableSubjects,
        filterOnlineTutors,
        liveChat,
        payment,
        selectTutors,
        subscribeTestSeries,
      },

      teacher: {
        answerQueries,
        chat,
        profileManagementlEdtech,
        pushNotificationslEdtech,
        scheduleClasses,
        viewRatings,
      },
    },
  },

  carWashImages: {
    emerging: {
      artificialIntelligenceCarWash,
      augmentedRealityCarWash,
      bigDataAnalyticsCarWash,
      blockchainCarWash,
      cloudComputingCarWash,
      internetOfThingsCarWash,
    },

    features: {
      admin: {
        dashboardCarWash,
        manageServicesCarWash,
        manageTimeZone,
        manageUsers,
        manageWashers,
        registerWashers,
      },

      user: {
        bookService,
        checkAvailability,
        chooseWasher,
        payOnline,
        signUp: signUpUser,
        trackService,
      },

      washer_panel: {
        acceptRejectService,
        addServiceLocation,
        pushNotifications,
        signUp: signUpWasher,
        updateServiceStatus,
        viewHistory,
      },
    },
  },

  handyManImages: {
    emerging: {
      arVrHandyMan,
      artificialIntelligenceHandyMan,
      blockchainHandyMan,
      cloudComputingHandyMan,
      dataAnalyticsHandyMan,
      internetOfThingsHandyMan,
    },

    features: {
      admin: {
        analyticsReports,
        commissionManagement,
        handymanProfile,
        paymentTrackingHandyMan,
        support,
        userManagementHandyMan,
      },

      service: {
        availabilityControl,
        earningsTracking,
        inAppCommunication,
        jobManagement,
        profileManagement,
        ratingsFeedback,
      },

      user: {
        easyBooking,
        flexibleScheduling,
        realTimeTrackingUser,
        reviews,
        securePayments,
        serviceHistory,
      },
    },
  },
  logisticsEmerging: {
    logisticsAiMl,
    logisticsArVr,
    logisticsBigDataAnalytics,
    logisticsBlockchain,
    logisticsCloudComputing,
    logisticsInternetOfThings,
  },

  logisticsProcess: {
    logisticsDevelopment,
    logisticsDiscovery,
    logisticsLaunch,
    logisticsSupportAndMaintenance,
    logisticsTesting,
    logisticsUiUxDesign,
  },

  logisticsSolutions: {
    customerSupportApp,
    documentManagementApp,
    inventoryManagementApp,
    shippingLogisticsSystems,
    supplierProcurementSolutions,
    supplyChainVisibilityApp,
    warehouseManagementApp,
  },

  rubyEmerging: {
    rubyArVr,
    rubyArtificialIntelligence,
    rubyBlockchain,
    rubyCloudComputing,
    rubyDataAnalytics,
    rubyInternetOfThings,
  },

  rubyProcess: {
    rubyDeployment,
    rubyDesign,
    rubyDevelopment,
    rubyRequirementAnalysis,
    rubySupportAndMaintenance,
    rubyTesting,
  },

  datingAppEmerging: {
    datingAiMl,
    datingArVr,
    datingBigDataAnalytics,
    datingBlockChain,
    datingCloudIntegration,
    datingIot,
  },

  datingFeatureAdminPanel: {
    datingcustomerSupportSystem,
    datingreportAnalysis,
    datingseamlessDashboard,
    datingsubscriptionModelManagement,
    datingUserManagement,
    datingUserVerification,
  },

  datingFeatureAdvanced: {
    datingCallingOption,
    datingDatePlanner,
    datingGeoLocationTagging,
    datingMessageBox,
    datingSpamProtection,
    datingUserAuthentication,
  },

  datingFeatureUserPanel: {
    datingFacialRecognition,
    datingMatchMakingTools,
    datingMultilingualCommunication,
    datingRealTimeTranslation,
    datingSearchFilter,
    datingUserReview,
  },

  emrTransport: {
    transAiMlTech,
    transArVr,
    transBigData,
    transBlockChain,
    transCloud,
    transIOT,
  },
  processTransport: {
    processDev,
    processGathering,
    processMaintenance,
    processTesting,
    processUiUx,
  },
  solutionsTransport: {
    solutionsCar,
    solutionsDeliveryApp,
    solutionsElectricVehicle,
    solutionsFreightApp,
    solutionsRideSharing,
    solutionsTourTravel,
  },

  emrGameDevelopement: {
    gameAdvanceAutomation,
    gameArtificialIntelligence,
    gameAugmentedReality,
    gameBlockchain,
    gameCloudGaming,
    gameVirtualReality,
  },
  processGameDevelopememt: {
    processDesign,
    processDevelopememt,
    processPreProduction,
    processRequirementGathering,
    processSupport,
    processTestingAndDeployment,
  },
  solutionsGameDevelopememt: {
    solutionsActionGamingApps,
    solutionsCardGames,
    solutionsCasualGames,
    solutionsEducationalGamingApps,
    solutionsPuzzleGames,
    solutionsStrategyGamingApps,
  },

  directoryAppEmerging: {
    directoryArtificialIntelligence,
    directoryBlockchain,
    directoryCloudComputing,
    directoryDataAnalytics,
    directoryGeolocation,
    directoryInternetOfThings,
  },

  directoryFeature: {
    admin: {
      directoryContentModeration,
      directoryDashboard,
      listingManagement,
      directoryPaymentManagement,
      systemSettings,
      userVendorManagement,
    },
    user: {
      favorites,
      inAppMessaging,
      directoryRealTimeNotifications,
      directoryReviews,
      smartSearch,
      userProfiles,
    },
    vendor: {
      analyticsAndInsights,
      leadManagement,
      directoryManageProfile,
      directoryPaymentTracking,
      promotionTools,
      reviewManagement,
    },
  },

  chatMessagingEmerging: {
    chatArVr,
    chatArtificialIntelligence,
    chatBlockchain,
    chatCloudComputing,
    chatDataAnalytics,
    chatInternetOfThings,
  },

  chatFeature: {
    admin: {
      aiPoweredModeration,
      broadcastingMessage,
      chatGroupControls,
      dataPrivacy,
      chatReportsAnalytics,
      chatUserManagement,
    },
    user: {
      aiIntegration,
      completeEncryption,
      filesMediaSharing,
      languageTranslation,
      smartReplySuggestions,
      voiceToText,
    },
  },

  eventEmergingTech: {
    eventArVr,
    eventArtificialIntelligence,
    eventBlockChain,
    eventCloudComputing,
    eventDataAnalytics,
    eventInternetOfThings,
  },

  eventProcess: {
    eventAppDeployment,
    eventDeployment,
    eventResearch,
    eventSupportMaintenance,
    eventTesting,
    eventUiUxDesign,
  },

  eventSolutions: {
    conferenceEventBookingApp,
    corporateEventApps,
    festivalManagementApp,
    localEventApps,
    sportEventApps,
    weddingPlannerRefreshmentApps,
  },

  awsEmerging: {
    awsAiMl,
    awsArVr,
    awsBlockchain,
    awsCloudComputing,
    awsDataAnalytics,
    awsIot,
  },

  awsProcess: {
    awsDevelopment,
    awsReadiness,
    awsSolutionDesign,
    awsStrategy,
    awsSupportAndMaintenance,
    awsTesting,
  },

  odooEmerging: {
    odooArVr,
    odooArtificialIntelligence,
    odooBlockchain,
    odooCloudComputing,
    odooDataAnalytics,
    odooInternetOfThings,
  },

  odooProcess: {
    odooDeployment,
    odooDevelopment,
    planning,
    preparation,
    odooSupportAndMaintenance,
    odooTesting,
  },

  industriesImages: {
    bankingFinance,
    ecommerceRetailB2b,
    foodRestaurant,
    onDemandSolutions,
    realEstateProperty,
  },

  googleCloudPlatformEmerging: {
    aiMlGCPImage,
    arVrGCPImage,
    blockchainGCPImage,
    cloudComputingGCPImage,
    dataAnalyticsGCPImage,
    iotGCPImage,
  },

  googleCloudPlatformProcess: {
    deploymentProcessGCPImage,
    designProcessGCPImage,
    developmentProcessGCPImage,
    requirementsAnalysisProcessGCPImage,
    supportMaintenanceProcessGCPImage,
    testingProcessGCPImage,
  },

  frontendDevelopmentbBg,

  backendDevelopmentbBg,

  musicStreamingEmerging: {
    musicStreamingArVr,
    musicStreamingArtificialIntelligence,
    musicStreamingBlockchain,
    musicStreamingCloudComputing,
    musicStreamingDataAnalytics,
    musicRecognitionEngine,
  },

  musicStreamingFeatures: {
    admin: {
      dashboard,
      musicPublishing,
      paymentTracking,
      reportsAnalytics,
      subscriptionManagement,
      userManagement,
    },
    advancedFeature: {
      artistsProfiles,
      lyrics,
      multilingualFunctionality,
      musicWishlist,
      reviewRating,
      voiceSearch,
    },
    user: {
      createAPlaylist,
      integratingSocialMedia,
      offlineListening,
      profileCreation,
      streamMusicOnline,
      subscriptionPlans,
    },
  },

  telemedicineAppEmerging: {
    ai,
    telemedicineArVr,
    bigDataAnalytics,
    telemedicineBlockchain,
    telemedicineCloudComputing,
    digitalTherapeutics,
    iot,
  },

  telemedicineAppFeatures: {
    admin: {
      configureNotification,
      manageServices,
      powerfulDashboard,
      registerDoctors,
      reportsAndAnalytics,
      viewAppointments,
    },
    doctor: {
      cancelAppointment,
      createOrder,
      detailedDashboard,
      manageProfile,
      notification,
      updateAvailability,
    },
    patient: {
      appointmentHistory,
      bookVisit,
      notifications,
      searchDoctors,
      upcomingAppointments,
      videoConsultation,
    },
  },

  socialEmerging: {
    socialArVr,
    artificialIntelligence,
    socialBlockchain,
    cloudComputing,
    geolocationTechnology,
    machineLearning,
  },

  socialProcess: {
    socialDeployment,
    socialDesign,
    socialDevelopment,
    maintenance,
    marketResearch,
    socialTesting,
  },

  socialSolutions: {
    businessSocialNetworkingApp,
    entertainmentSocialMediaApp,
    socialCommunityApp,
    socialCreatorPlatform,
    socialNetworkingApp,
    videoAndContentSharingApp,
  },

  fitnessEmerging: {
    aiMl,
    arVr,
    blockchain,
    chatbots,
    cloudTechnology,
    roboticProcessAutomation,
  },

  fitnessProcess: {
    deployment,
    fitnessDevelopment,
    supportAndMaintenance,
    fitnessTesting,
    uiUxDesign,
    ideation,
  },

  fitnessSolutions: {
    dietNutritionApp,
    fitnessClubApps,
    fitnessTrackerApp,
    meditationYogaApp,
    personalTrainerApp,
    socialMediaFitnessApp,
  },

  doctorOnDemandEmerging: {
    aiDODImage,
    arVrDODImage,
    blockchainDODImage,
    cloudComputingDODImage,
    dataAnalyticsDODImage,
    iotDODImage,
  },

  doctorOnDemandFeatures: {
    admin: {
      appointmentManagementAdminImage,
      billingAdminImage,
      contentManagementAdminImage,
      customerSupportAdminImage,
      platformAnalyticsAdminImage,
      userManagementAdminDODImage,
    },

    customer: {
      appointmentSchedulingCustomerImage,
      ePrescriptionsCustomerImage,
      geolocationServicesCustomerImage,
      insuranceIntegrationCustomerImage,
      symptomCheckerCustomerImage,
      videoConsultationsCustomerImage,
    },

    doctor: {
      availabilityManagementDoctorImage,
      doctorProfileDoctorImage,
      earningsPaymentsDoctorImage,
      patientManagementDoctorImage,
      performanceAnalyticsDoctorImage,
      teleconsultationPlatformDoctorImage,
    },
  },

  fuelDeliveryEmerging: {
    arVrFuelDeliveryImage,
    artificialIntelligenceFuelDeliveryImage,
    blockchainFuelDeliveryImage,
    cloudComputingFuelDeliveryImage,
    internetOfThingsFuelDeliveryImage,
    machineLearningMlImage,
  },

  fuelDeliverImage: {
    admin: {
      dashboardAdminImage,
      driversAdminImage,
      loginAdminImage,
      paymentAdminImage,
      pricingAdminImage,
      tankersAdminImage,
    },
    driver: {
      assistanceDriverImage,
      customerInformationDriverImage,
      dashboardsDriverImage,
      navigationDriverImage,
      registrationDriverImage,
      statusDriverImage,
    },
    user: {
      alertsUserImage,
      priceUserImage,
      receiptsUserImage,
      registrationUserImage,
      testimonialsUserImage,
      userProfileUserImage,
    },
  },

  liquorEmerging: {
    aiAgeVerificationImage,
    blockchainLiquorImage,
    cloudComputingLiquorImage,
    dataAnalyticsLiquorImage,
    machineLearningLiquorImage,
    smartRouteOptimizationImage,
  },

  liquorFeaturesImages: {
    admin: {
      deliveryManagementAdminImage,
      inventoryManagementAdminImage,
      multipleStoreManagementAdminImage,
      regulatoryComplianceAdminImage,
      reviewFeedbackAdminImage,
      userManagementAdminImage,
    },

    customer: {
      comparePricesCustomerImage,
      easyPaymentsCustomerImage,
      offersDiscountsCustomerImage,
      realTimeTrackingCustomerImage,
      searchCustomerImage,
      signInCustomerImage,
    },

    deliveryAgent: {
      deliveryStatusDeliveryAgentImage,
      itemDetailsDeliveryAgentImage,
      notificationsDeliveryAgentImage,
      paymentManagementDeliveryAgentImage,
      profileCreationDeliveryAgentImage,
      realTimeTrackingDeliveryAgentImage,
    },

    merchant: {
      manageDeliveryMerchantImage,
      manageOrdersMerchantImage,
      manageStockMerchantImage,
      offersDiscountsMerchantImage,
      profileCreationMerchantImage,
      realTimeNotificationsMerchantImage,
    },
  },

  computerVisionProcess: {
    architectureDesignImage,
    dataCollectionComputerVisionImage,
    deploymentAndMaintenanceComputerVisionImage,
    modelTrainingImage,
    problemDefinitionImage,
    testingComputerVisionImage,
  },

  computerVisionEmerging: {
    aiImage,
    cloudComputingComputerVisionImage,
    deepLearningImage,
    edgeComputingImage,
    machineLearningImage,
    naturalLanguageProcessingComputerVisionImage,
  },

  aiChatBotEmerging: {
    agenticAiAIChatbotImage,
    largeLanguageModelsAIChatbotImage,
    machineLearningAIChatbotImage,
    naturalLanguageProcessingAIChatbotImage,
    retrievalAugmentedGenerationAIChatbotImage,
    voiceBasedInteractionAIChatbotImage,
  },

  aiChatBotProcess: {
    deploymentAIChatbotImage,
    developmentAIChatbotImage,
    discoveryPhaseAIChatbotImage,
    uiUxDesignAIChatbotImage,
    qualityAssuranceAIChatbotImage,
    maintenanceAIChatbotImage,
  },

  aiAgentProcess: {
    architectureAIAgentImage,
    designAIAgentImage,
    developmentAIAgentImage,
    discoveryAIAgentImage,
    testingAIAgentImage,
    launchAIAgentImage,
  },

  aiAgentEmerging: {
    arVrAIAgentImage,
    blockchainAIAgentImage,
    cloudComputingAIAgentImage,
    dataAnalyticsAIAgentImage,
    iotAIAgentImage,
    machineLearningAIAgentImage,
  },

  MLEmerging: {
    aiChatbotsMLImage,
    artificialIntelligenceMLImage,
    cloudMLImage,
    computerVisionMLImage,
    naturalLanguageProcessingMLImage,
    rpaMLImage,
  },

  MLProcess: {
    businessProblemIdentificationMLImage,
    dataModelingAndEvaluationMLImage,
    dataPreparationMLImage,
    exploratoryDataAnalysisMLImage,
    implementationMLImage,
    monitoringAndSupportMLImage,
  },

  ARemerging: {
    modeling3dARImage,
    cloudTechnologyARImage,
    computerVisionARImage,
    slamARImage,
    spatialAudioARImage,
  },

  ARprocess: {
    arTechnologyIntegrationARImage,
    deploymentARImage,
    developmentARImage,
    planningARImage,
    testingAndQaARImage,
    uiUxDesignARImage,
  },

  vrProcessImages: {
    definingRequirementsImage,
    deploymentAndMaintenanceImage,
    designingImage,
    developmentImage,
    preDevelopmentPlanningImage,
    testingImage,
  },

  vrEmergingImage: {
    modeling3dImage,
    aiMlImage,
    eyeTrackingImage,
    gestureRecognitionImage,
    hapticFeedbackSystemsImage,
    spatialAudioProcessingImage,
  },

  generativeAIEmerging: {
    codexImage,
    dallE3Image,
    gpt4Image,
    soraImage,
    stableDiffusionImage,
    whisperImage,
  },

  generativeAIprocess: {
    dataCollectionImage,
    deploymentImage,
    designCustomizationImage,
    needsAnalysisImage,
    trainingImage,
    supportAndMaintenanceImage,
  },

  aiConsultingProcess: {
    aiReadinessProcessImage,
    continuousMonitoringProcessImage,
    deploymentProcessImageAIConsulting,
    opportunityMappingProcessImage,
    rapidMvpProcessImage,
    solutionsDesignProcessImage,
  },

  aiConsultingEmerging: {
    agenticAiImageAIConsulting,
    computerVisionImageAIConsulting,
    iotImageAIConsulting,
    largeLanguageModelsImageAIConsulting,
    naturalLanguageProcessingImageAIConsulting,
    predictiveAnalyticsImageAIConsulting,
  },

  aiIntegratedInnovation: {
    agenticAiImage,
    computerVisionImage,
    iotImage,
    largeLanguageModelsImage,
    naturalLanguageProcessingImage,
    predictiveAnalyticsImage,
  },

  aiIntegratedProcess: {
    dataIntegrationProcessImage,
    fineTuningProcessImage,
    modelSelectionProcessImage,
    requirementGatheringProcessImage,
    testingAndEvaluationProcessImage,
    workflowIntegrationProcessImage,
  },

  aiPoweredProcess: {
    businessAssessmentProcessImage,
    changeManagementProcessImage,
    developmentProcessImageAiPowered,
    maintenanceAndSupportProcessImageAiPowered,
    solutionDesignProcessImage,
    strategicRoadmapProcessImage,
  },

  aiPoweredInnovation: {
    aiAgentDevelopmentImage,
    aiChatbotDevelopmentImage,
    aiModelDevelopmentImage,
    aiPocDevelopmentImage,
    aiProductDevelopmentImage,
    imageBasedAiSolutionsImage,
  },

  metaVerseProgress: {
    blockchainIntegrationProcessImageMetaVerse,
    conceptualizationProcessImageMetaVerse,
    deploymentSupportProcessImageMetaVerse,
    developmentProcessImageMetaVerse,
    requirementAnalysisProcessImageMetaVerse,
    testingProcessImageMetaVerse,
  },

  metaverseEmergingTech: {
    reconstruction3dImageMetaVerse,
    artificialIntelligenceImageMetaVerse,
    blockchainImageMetaVerse,
    edgeComputingImageMetaVerse,
    extendedRealityImageMetaVerse,
    internetOfThingsImageMetaVerse,
  },

  fourzerofour: fourzerofour,
  ourClientsBg: ourClientsBg,
  partnerBg: partnerBg,
  becomePartnerBg: becomePartnerBg,
  contactBg: contactBg,
  pressReleaseBg: pressReleaseBg,
  ourTeamBg: ourTeamBg,
  testimonialBg: testimonialBg,
  homeBannerBg: defaultBannerImage,
  mobileBannerImage: mobileBannerImage,
  mobileBannerMobImage: mobileBannerMobImage,
  thankyou: `${ICON_BASE_URL}/assets/images/thankyou.webp`,
  thankyouBackcircle: `${ICON_BASE_URL}/assets/images/Thankyou_backcircle.webp`,
  whitepaper_1: `${ICON_BASE_URL}/assets/images/whitepaper.webp`,
  clutch_survey: `${ICON_BASE_URL}/assets/images/clutch-testimonial.webp`,
  resourcebg: `${ICON_BASE_URL}/assets/images/resources/bg.webp`,
  our_clients_bg: `${ICON_BASE_URL}/assets/images/our-clients-bg.webp`,
  our_team_bg: `${ICON_BASE_URL}/assets/images/our-team/our-team-bg.webp`,
  our_team_about: `${ICON_BASE_URL}/assets/images/our-team/human.webp`,
  team1: `${ICON_BASE_URL}/assets/images/our-team/team1.webp`,
  team2: `${ICON_BASE_URL}/assets/images/our-team/team2.webp`,
  team3: `${ICON_BASE_URL}/assets/images/our-team/team3.webp`,
  team4: `${ICON_BASE_URL}/assets/images/our-team/team4.webp`,

  the_offer: `${ICON_BASE_URL}/assets/images/the_offer.webp`,
  HR_Interview: `${ICON_BASE_URL}/assets/images/HR_Interview.webp`,
  compliance1: `${ICON_BASE_URL}/assets/icons/compliance-1.webp`,
  compliance2: `${ICON_BASE_URL}/assets/icons/compliance-2.webp`,
  compliance3: `${ICON_BASE_URL}/assets/icons/compliance-3.webp`,
  Manager_Interview: `${ICON_BASE_URL}/assets/images/Manager_Interview.webp`,

  saasProcess: {
    process1: planningProcessImageSaas,
    process2: uiUxDesignProcessImageSaas,
    process3: developmentProcessImageSaas,
    process4: testingProcessImageSaas,
    process5: deploymentProcessImageSaas,
    process6: maintenanceProcessImage,
  },

  saasEmergingTech: {
    emerging1: artificialIntelligenceImageSaas,
    emerging2: iotImageSaas,
    emerging3: dataAnalyticsImageSaas,
    emerging4: cloudComputingImageSaas,
    emerging5: arVrImageSaas,
    emerging6: blockchainImageSaas,
  },

  stripProcess: {
    process1: requirementAnalysisProcessImage,
    process2: designingProcessImage,
    process3: integrationProcessImage,
    process4: testingProcessImage,
    process5: deploymentProcessImage,
    process6: supportMaintenanceProcessImage,
  },
  stripEmerging: {
    emerging1: aiMlImageStrip,
    emerging2: internetOfThingsImageStrip,
    emerging3: dataAnalyticsImageStrip,
    emerging4: cloudComputingImageStrip,
    emerging5: arVrImageStrip,
    emerging6: blockchainImageStrip,
  },

  backendService: {
    process1: initialConsultationProcessImage,
    process2: designProcessImage,
    process3: developmentProcessImage,
    process4: qualityAssuranceProcessImage,
    process5: releaseDeploymentProcessImage,
    process6: maintenanceAndSupportProcessImage,
  },

  backendEmerge: {
    emerging1: artificialIntelligenceImage,
    emerging2: arVrImage,
    emerging3: internetOfThingsImage,
    emerging4: cloudComputingImage,
    emerging5: blockchainImage,
    emerging6: dataAnalyticsImage,
  },

  frontendEmerge: {
    emerging1: artificialIntelligenceFrontend,
    emerging2: arVrFrontend,
    emerging3: internetOfThings,
    emerging4: cloudComputingFrontend,
    emerging5: emergeBlockChainFrontend,
    emerging6: dataAnalytics,
  },

  frontendProcess: {
    process1: requirementsGathering,
    process2: wireframing,
    process3: design,
    process4: development,
    process5: testing,
    process6: deploymentAndMaintenance,
  },

  ourPartners: {
    allianceThatCount: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/allience-that-count.png`,
    authorizeNet: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/authorize-net.png`,
    authorizedMegaStorePartners: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/autorized-mega-store-partners.png`,
    drupleAssociateMembers: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/druple-associate-members.png`,
    fistBump: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/fist-bump.gif`,
    makingMostOfAws: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/making-most-of-aws.png`,
    memberOfIosDeveloperProgram: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/member-of-ios-developer-program.png`,
    microsoftPartners: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/microsoft-partners.png`,
    palsWithPaypal: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/pals-with-paypal.png`,
    partOfBand: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/part-of-band.png`,
    paypalPart: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/paypal-part.png`,
    pluggedInPlay: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/plugged-in-play.png`,
    stripePartners: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/striper-partners.png`,
    bluetoothNfc: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/bluetooth-nfc.webp`,
    partner_iot: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/iot.webp`,
    machineLearning: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/machine-learning.webp`,
    naturalLanguageProcessing: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/natural-language-processing.webp`,
    voiceAssistantIntegration: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/voice-assistant-integration.webp`,
    vr: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/emerging/vr.webp`,
    deploymentAndMaintenance: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/deployment-and-maintenance.webp`,
    developmentPhase: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/development-phase.webp`,
    integrations: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/integrations.webp`,
    partner_requirementAnalysis: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/requirement-analysis.webp`,
    testingQa: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/testing-qa.webp`,
    wireframingPrototyping: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/wearable-page/process/wireframing-prototyping.webp`,
    accuia: `${process.env.NEXT_PUBLIC_ASSET_URL}/images/partners/accuia.png`,
  },

  taxiPageImages: {
    taxiAdvancedSafety: `${ICON_BASE_URL}/assets/images/taxi_app/advanced-safety.webp`,
    taxiArtificialIntelligence: `${ICON_BASE_URL}/assets/images/taxi_app/artificial-intelligence.webp`,
    taxiBlockchainSecurePayments: `${ICON_BASE_URL}/assets/images/taxi_app/blockchain-and-secure-payments.webp`,
    taxiElectricVehicleIntegration: `${ICON_BASE_URL}/assets/images/taxi_app/electric-vehicle-integration.webp`,
    taxiTelematics: `${ICON_BASE_URL}/assets/images/taxi_app/telematics.webp`,

    driver: {
      driverAvailabilityToggle: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/availability-toggle.webp`,
      driverEarningsDashboard: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/earnings-dashboard.webp`,
      driverGpsNavigationRouting: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/gps-navigation-and-routing.webp`,
      driverHeatMaps: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/heat-maps.webp`,
      driverInstantRideRequests: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/instant-ride-requests.webp`,
      driverPassengerRatingSystem: `${ICON_BASE_URL}/assets/images/taxi_app/driver_panel/passenger-rating-system.webp`,
    },

    passenger: {
      passengerDigitalPaymentIntegration: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/digital-payment-integration.webp`,
      passengerDriverRatingSystem: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/driver-rating-system.webp`,
      passengerInAppSosButton: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/in-app-sos-button.webp`,
      passengerOneTapBooking: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/one-tap-booking.webp`,
      passengerPreRideFareEstimator: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/pre-ride-fare-estimator.webp`,
      passengerRealTimeLiveTracking: `${ICON_BASE_URL}/assets/images/taxi_app/passenger_panel/real-time-live-tracking.webp`,
    },
  },

  taxiPageBundled: {
    emerging: {
      artificialIntelligence: taxiEmergingArtificialIntelligence,
      blockchain: taxiEmergingBlockchain,
      dataAnalytics: taxiEmergingDataAnalytics,
      iotIntegration: taxiEmergingIotIntegration,
      machineLearning: taxiEmergingMachineLearning,
      virtualAssistants: taxiEmergingVirtualAssistants,
    },
    admin: {
      driverManagement: taxiAdminDriverManagement,
      manageCurrency: taxiAdminManageCurrency,
      owedAmountManagement: taxiAdminOwedAmountManagement,
      ratings: taxiAdminRatings,
      ridersManagement: taxiAdminRidersManagement,
      seamlessMapIntegration: taxiAdminSeamlessUserIntegration,
    },
    driver: {
      cancellingOption: taxiDriverCancellingOption,
      documentManagement: taxiDriverDocumentManagement,
      earningReport: taxiDriverEarningReport,
      onlineOfflineMode: taxiDriverOnlineOfflineMode,
      ratingAndReviews: taxiDriverRatingAndReviews,
      seamlessMapIntegration: taxiDriverSeamlessMapIntegration,
    },
    user: {
      inAppPayments: taxiUserInAppPayments,
      instantNotifications: taxiUserInstantNotifications,
      liveGeoTracking: taxiUserLiveGeoTracking,
      multipleRegistration: taxiUserMultipleRegistration,
      superFastSearch: taxiUserSuperFastSearch,
      verifiedUsers: taxiUserVerifiedUsers,
    },
  },

  datingPageImages: {
    admin: {
      contentModeration: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/content-moderation.webp`,
      customizationHub: `${ICON_BASE_URL}/assets/images/dating_app/admin/customization-hub.webp`,
      geoFencingControl: `${ICON_BASE_URL}/assets/images/dating_app/admin/geo-fencing-control.webp`,
      multiLingualSupportControl: `${ICON_BASE_URL}/assets/images/dating_app/admin/multi-lingual-support-control.webp`,
      revenueTracker: `${ICON_BASE_URL}/assets/images/dating_app/admin/revenue-tracker.webp`,
      terminatorDashboard: `${ICON_BASE_URL}/assets/images/dating_app/admin/the-terminator-dashboard.webp`,
      userBehaviorAnalytics: `${ICON_BASE_URL}/assets/images/dating_app/admin/user-behavior-analytics.webp`,
    },

    customer: {
      behavioralMatchmaking: `${ICON_BASE_URL}/assets/images/dating_app/customer/behavioral-matchmaking.webp`,
      hyperLocalFilteredMatching: `${ICON_BASE_URL}/assets/images/dating_app/customer/hyper-local-filtered-matching.webp`,
      premiumHookupSubscriptions: `${ICON_BASE_URL}/assets/images/dating_app/customer/premium-hookup-subscriptions.webp`,
      profileSetup: `${ICON_BASE_URL}/assets/images/dating_app/customer/profile-setup.webp`,
      pushNotifications: `${ICON_BASE_URL}/assets/images/dating_app/customer/push-notifications.webp`,
      realTimeChatVoiceVideo: `${ICON_BASE_URL}/assets/images/dating_app/customer/real-time-chat-voice-video.webp`,
      securePanicButton: `${ICON_BASE_URL}/assets/images/dating_app/customer/secure-panic-button.webp`,
    },
  },
  telemedicineImage: {
    admin: {
      appointmentConsultationOversight: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/appointment-and-consultation-oversight.webp`,
      appointmentWorkflowQueueManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/appointment-workflow-and-queue-management.webp`,
      auditTrailsComplianceSecurityControls: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/audit-trails-compliance-validation-and-security-controls.webp`,
      billingSupervisionPaymentReconciliation: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/billing-supervision-and-payment-reconciliation.webp`,
      centralizedDashboardOperationalInsights: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/centralized-dashboard-with-operational-insights.webp`,
      centralizedPatientMedicalRecordAccess: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/centralized-patient-medical-record-access.webp`,
      complianceEnforcementDataSecurityGovernance: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/compliance-enforcement-and-data-security-governance.webp`,
      consultationServiceMonitoring: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/consultation-and-service-monitoring.webp`,
      contentPublishingNotificationControl: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/content-publishing-and-notification-control.webp`,
      doctorOnboardingCredentialingRoleAssignment: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/doctor-onboarding-credentialing-and-role-assignment.webp`,
      externalIntegrationsApisPaymentGateways: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/external-integrations-via-apis-and-payment-gateways.webp`,
      facilityProfileDepartmentManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/facility-profile-and-department-management.webp`,
      integrationLaboratoriesPharmaciesDiagnostics: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/integration-with-laboratories-pharmacies-and-diagnostics.webp`,
      issueTrackingResolutionSupportManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/issue-tracking-resolution-and-support-management.webp`,
      operationalRevenueAnalytics: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/operational-and-revenue-analytics.webp`,
      platformConfigurationFeatureManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/platform-configuration-and-feature-management.webp`,
      roleBasedPermissionsAccessControl: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/role-based-permissions-and-access-control.webp`,
      staffResourceScheduling: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/staff-and-resource-scheduling.webp`,
      subscriptionCommissionPaymentManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/subscription-commission-and-payment-management.webp`,
      systemPerformanceUsageMonitoring: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/system-performance-and-usage-monitoring.webp`,
      userManagementPatientsDoctorsFacilities: `${ICON_BASE_URL}/assets/images/telemedicine_app/admin/user-management-across-patients-doctors-and-facilities.webp`,
    },

    doctor: {
      doctorAccessElectronicMedicalRecords: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/access-to-electronic-medical-records.webp`,
      doctorAppointmentAlertsNotifications: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/appointment-alerts-and-notifications.webp`,
      doctorAvailabilityScheduleConfiguration: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/availability-management-and-schedule-configuration.webp`,
      doctorClinicalNotesDocumentationManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/clinical-notes-and-documentation-management.webp`,
      doctorDigitalPrescriptionGeneration: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/digital-prescription-generation.webp`,
      doctorEarningsInvoicesPayoutTracking: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/earnings-invoices-and-payout-tracking.webp`,
      doctorEncryptedPatientCommunication: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/encrypted-patient-communication.webp`,
      doctorIntegratedVideoAudioConsultation: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/integrated-video-and-audio-consultation-tools.webp`,
      doctorLabTestSpecialistReferral: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/lab-test-and-specialist-referral-recommendations.webp`,
      doctorPatientListAppointmentOverview: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/patient-list-and-appointment-overview.webp`,
      doctorPerformanceAnalyticsFeedback: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/performance-analytics-and-patient-feedback-visibility.webp`,
      doctorReviewPatientHistory: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/review-of-patient-history-and-prior-consultations.webp`,
      doctorSecureLogin: `${ICON_BASE_URL}/assets/images/telemedicine_app/doctor_panel/secure-login.webp`,
    },

    patient: {
      patientAppointmentScheduling: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/appointment-scheduling.webp`,
      patientAutomatedAppointmentAlerts: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/automated-appointment-alerts.webp`,
      patientDigitalPrescriptionsReminders: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/digital-prescriptions-and-reminders.webp`,
      patientDoctorDiscoveryFilters: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/doctor-discovery-with-filters.webp`,
      patientDoctorRatingFeedback: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/doctor-rating-and-feedback.webp`,
      patientEncryptedRealTimeChat: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/encrypted-real-time-chat.webp`,
      patientConsultationHistoryAccess: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/full-access-to-consultation-history.webp`,
      patientLiveVideoAudioConsultation: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/live-video-and-audio-consultation.webp`,
      patientMultiLanguageUi: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/multi-language-user-interface.webp`,
      patientOnlinePaymentsBillingHistory: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/online-payments-and-billing-history.webp`,
      patientProfileManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/profile-management.webp`,
      patientRegulatoryCompliantSecurity: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/regulatory-compliant-security.webp`,
      patientReportPrescriptionManagement: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/report-prescription-management.webp`,
      patientSecureAccountRegistration: `${ICON_BASE_URL}/assets/images/telemedicine_app/patient_panel/secure-account-registration.webp`,
    },
  },
  classifiedSolutionImages: {
    admin: {
      adminCategoryManagement: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/category-management.webp`,
      adminDataManagement: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/data-management.webp`,
      adminManageAds: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/manage-ads.webp`,
      adminManageCustomers: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/manage-customers.webp`,
      adminManageDeals: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/manage-deals.webp`,
      adminManageSubscriptions: `${ICON_BASE_URL}/assets/images/classified_soluton/admin/manage-subscriptions.webp`,
    },
    customer: {
      customerEasySignIn: easySignIn,
      customerFavoriteList: favoriteList,
      customerInAppChat: inAppChat,
      customerReviewAndReport: reviewAndReport,
      customerSearchByCategory: searchByCategory,
      customerSearchByLocation: searchByLocation,
    },
    seller: {
      sellerAdManagement: adManagement,
      sellerEasyAdListing: easyAdListing,
      sellerMessagingSystem: messagingSystem,
      sellerPerformanceInsights: performanceInsights,
      sellerProfileCustomization: profileCustomization,
    },
  },
  foodDelivery: {
    tech: {
      ai: `${ICON_BASE_URL}/assets/images/food_delivery/ai.webp`,
      blockchain_food_delivery: `${ICON_BASE_URL}/assets/images/food_delivery/blockchain.webp`,
      businessIntelligence: `${ICON_BASE_URL}/assets/images/food_delivery/business-intelligence.webp`,
      dataScience: `${ICON_BASE_URL}/assets/images/food_delivery/data-science.webp`,
      generativeAi_food_delivery: `${ICON_BASE_URL}/assets/images/food_delivery/generative-ai.webp`,
      internetOfThings_food_delivery: datingIot,
    },
    admin: {
      adminAdvancedAnalytics: `${ICON_BASE_URL}/assets/images/food_delivery/admin/advanced-analytics.webp`,
      adminAgreement: `${ICON_BASE_URL}/assets/images/food_delivery/admin/Agreement.webp`,
      adminCustomerManagement: `${ICON_BASE_URL}/assets/images/food_delivery/admin/customer-management.webp`,
      adminCustomizedDashboards: `${ICON_BASE_URL}/assets/images/food_delivery/admin/customized-dashboards.webp`,
      adminDeliveryAgentManagement: `${ICON_BASE_URL}/assets/images/food_delivery/admin/delivery-agent-management.webp`,
      adminPaymentManagement: `${ICON_BASE_URL}/assets/images/food_delivery/admin/payment-management.webp`,
    },
    customer: {
      customerDiscountCode: `${ICON_BASE_URL}/assets/images/food_delivery/customer/discount-code.webp`,
      customerFeedback: `${ICON_BASE_URL}/assets/images/food_delivery/customer/feedback.webp`,
      customerPaymentGateway: `${ICON_BASE_URL}/assets/images/food_delivery/customer/payment-gateway.webp`,
      customerSearchFiltering: `${ICON_BASE_URL}/assets/images/food_delivery/customer/search-filtering.webp`,
      customerSimpleSignUpLogin: `${ICON_BASE_URL}/assets/images/food_delivery/customer/simple-sign-up-login.webp`,
      customerTrackDelivery: `${ICON_BASE_URL}/assets/images/food_delivery/customer/track-delivery.webp`,
    },
    restaurant: {
      restaurantCustomerReviews: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/customer-reviews.webp`,
      restaurantMenuManagement: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/menu-management.webp`,
      restaurantNotificationsSystem: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/notifications-system.webp`,
      restaurantOrderManagement: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/order-management.webp`,
      restaurantOrderTracking: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/order-tracking.webp`,
      restaurantPromosManagement: `${ICON_BASE_URL}/assets/images/food_delivery/restaurant/promos-management.webp`,
    },
    driver: {
      driverInAppChat: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/in-app-chat.webp`,
      driverInAppMaps: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/in-app-maps.webp`,
      driverOrderManagement: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/order-management.webp`,
      driverPaymentHistory: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/payment-history.webp`,
      driverRealTimeRequest: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/real-time-request.webp`,
      driverRiderProfile: `${ICON_BASE_URL}/assets/images/food_delivery/Driver Panel/rider-profile.webp`,
    },
  },
  ecommerce: {
    aiMl: `${ICON_BASE_URL}/assets/images/ecommerce_images/ai-ml.webp`,
    b2bEcommerceSolutions: `${ICON_BASE_URL}/assets/images/ecommerce_images/b2b-ecommerce-solutions.webp`,
    b2cEcommerceApps: `${ICON_BASE_URL}/assets/images/ecommerce_images/b2c-ecommerce-apps.webp`,
    blockchain: `${ICON_BASE_URL}/assets/images/ecommerce_images/blockchain.webp`,
    c2cMarketplacePlatforms: `${ICON_BASE_URL}/assets/images/ecommerce_images/c2c-marketplace-platforms.webp`,
    cloudComputing: `${ICON_BASE_URL}/assets/images/ecommerce_images/cloud-computing.webp`,
    dataAnalytics_ecommerce: `${ICON_BASE_URL}/assets/images/ecommerce_images/data-analytics.webp`,
    deployment_ecommerce: `${ICON_BASE_URL}/assets/images/ecommerce_images/deployment.webp`,
    development_ecommerce: `${ICON_BASE_URL}/assets/images/ecommerce_images/development.webp`,
    headlessEcommerceSolutions: `${ICON_BASE_URL}/assets/images/ecommerce_images/headless-ecommerce-solutions.webp`,
    iot: `${ICON_BASE_URL}/assets/images/ecommerce_images/iot.webp`,
    metaverse: `${ICON_BASE_URL}/assets/images/ecommerce_images/metaverse.webp`,
    multiVendorEcommerceApps: `${ICON_BASE_URL}/assets/images/ecommerce_images/multi-vendor-ecommerce-apps.webp`,
    requirementAnalysis: `${ICON_BASE_URL}/assets/images/ecommerce_images/requirement-analysis.webp`,
    singleVendorEcommerceSolutions: `${ICON_BASE_URL}/assets/images/ecommerce_images/single-vendor-ecommerce-solutions.webp`,
    supportMaintenance: `${ICON_BASE_URL}/assets/images/ecommerce_images/support-maintenance.webp`,
    testing_ecommerce: `${ICON_BASE_URL}/assets/images/ecommerce_images/testing.webp`,
    uiUxDesign_ecommerce: `${ICON_BASE_URL}/assets/images/ecommerce_images/ui-ux-design.webp`,
    whiteLabelEcommerceSolutions: `${ICON_BASE_URL}/assets/images/ecommerce_images/white-label-ecommerce-solutions.webp`,
  },

  entertainment_media: {
    appPrototype: `${ICON_BASE_URL}/assets/images/media_entertainment/app-prototype.webp`,
    artificialIntelligence_media: `${ICON_BASE_URL}/assets/images/media_entertainment/artificial-intelligence.webp`,
    blockchain_media: `${ICON_BASE_URL}/assets/images/media_entertainment/blockchain.webp`,
    cloud: `${ICON_BASE_URL}/assets/images/media_entertainment/cloud.webp`,
    dataAnalytics: `${ICON_BASE_URL}/assets/images/media_entertainment/data-analytics.webp`,
    deployment_media: `${ICON_BASE_URL}/assets/images/media_entertainment/deployment.webp`,
    development: `${ICON_BASE_URL}/assets/images/media_entertainment/development.webp`,
    discovery: `${ICON_BASE_URL}/assets/images/media_entertainment/discovery.webp`,
    eventMovieTicketBookingApps: `${ICON_BASE_URL}/assets/images/media_entertainment/event-movie-ticket-booking-apps.webp`,
    internetOfThings_media: `${ICON_BASE_URL}/assets/images/media_entertainment/internet-of-things.webp`,
    liveStreamingBroadcastingApps: `${ICON_BASE_URL}/assets/images/media_entertainment/live-streaming-broadcasting-apps.webp`,
    mediaContentManagementApps: `${ICON_BASE_URL}/assets/images/media_entertainment/media-content-management-apps.webp`,
    multimediaEditingSharingApps: `${ICON_BASE_URL}/assets/images/media_entertainment/multimedia-editing-sharing-apps.webp`,
    musicStreamingApps: `${ICON_BASE_URL}/assets/images/media_entertainment/music-streaming-apps.webp`,
    ottApps: `${ICON_BASE_URL}/assets/images/media_entertainment/ott-apps.webp`,
    socialNetworkingAppDevelopment: `${ICON_BASE_URL}/assets/images/media_entertainment/social-networking-app-development.webp`,
    testing_media: `${ICON_BASE_URL}/assets/images/media_entertainment/testing.webp`,
    uiUxDesign: `${ICON_BASE_URL}/assets/images/media_entertainment/ui-ux-design.webp`,
    virtualReality_media: `${ICON_BASE_URL}/assets/images/media_entertainment/virtual-reality.webp`,
  },

  game_development_images: {
    connectivity5G: `${ICON_BASE_URL}/assets/images/game_development_images/5g-connectivity.webp`,
    artificialIntelligence: `${ICON_BASE_URL}/assets/images/game_development_images/artificial-intelligence.webp`,
    augmentedReality: `${ICON_BASE_URL}/assets/images/game_development_images/augmented-reality.webp`,
    backendApiIntegration: `${ICON_BASE_URL}/assets/images/game_development_images/backend-api-integration.webp`,
    cloudGaming: `${ICON_BASE_URL}/assets/images/game_development_images/cloud-gaming.webp`,
    crossPlatformTools: `${ICON_BASE_URL}/assets/images/game_development_images/cross-platform-tools.webp`,
    deepDiveMarketAnalysis: `${ICON_BASE_URL}/assets/images/game_development_images/deep-dive-market-analysis.webp`,
    digitalAssetBugManagementSolutions: `${ICON_BASE_URL}/assets/images/game_development_images/digital-asset-bug-management-solutions.webp`,
    edgeComputing: `${ICON_BASE_URL}/assets/images/game_development_images/edge-computing.webp`,
    findYourNextObsessionApps: `${ICON_BASE_URL}/assets/images/game_development_images/find-your-next-obsession-apps.webp`,
    gameStudioChaosManagementApps: `${ICON_BASE_URL}/assets/images/game_development_images/game-studio-chaos-management-apps.webp`,
    generativeAi: `${ICON_BASE_URL}/assets/images/game_development_images/generative-ai.webp`,
    internetOfThings: `${ICON_BASE_URL}/assets/images/game_development_images/internet-of-things.webp`,
    multiPlatformGameLaunchers: `${ICON_BASE_URL}/assets/images/game_development_images/multi-platform-game-launchers.webp`,
    mvp_feature_prioritization: `${ICON_BASE_URL}/assets/images/game_development_images/mvp-feature-prioritization.webp`,
    rigorousQaSoftLaunch: `${ICON_BASE_URL}/assets/images/game_development_images/rigorous-qa-soft-launch.webp`,
    unrealEngineUnity: `${ICON_BASE_URL}/assets/images/game_development_images/unreal-engine-unity.webp`,
    uxDesign: `${ICON_BASE_URL}/assets/images/game_development_images/ux-design.webp`,
    virtualReality: `${ICON_BASE_URL}/assets/images/game_development_images/virtual-reality.webp`,
    wearableTechIntegration: `${ICON_BASE_URL}/assets/images/game_development_images/wearable-tech-integration.webp`,
  },
  event_images: {
    app_development_solutions: `${ICON_BASE_URL}/assets/images/event_images/app-development-solutions.webp`,
    attendee_management_solutions: `${ICON_BASE_URL}/assets/images/event_images/attendee-management-solutions.webp`,
    corporate_planning: `${ICON_BASE_URL}/assets/images/event_images/corporate-planning.webp`,
    on_site_check_in: `${ICON_BASE_URL}/assets/images/event_images/on-site-check-in.webp`,
    venue_finder: `${ICON_BASE_URL}/assets/images/event_images/venue-finder.webp`,
    AI_and_ML_events: `${ICON_BASE_URL}/assets/images/event_images/AI_ML.webp`,
    Blockchain_events: `${ICON_BASE_URL}/assets/images/event_images/Blockchain.webp`,
    Internet_of_Things: `${ICON_BASE_URL}/assets/images/event_images/Internet_of_Things.webp`,
    contextual_design: `${ICON_BASE_URL}/assets/images/event_images/contextual-design.webp`,
    optimization: `${ICON_BASE_URL}/assets/images/event_images/optimization.webp`,
    scroll_lock: `${ICON_BASE_URL}/assets/images/event_images/scroll-lock.webp`,
    secure_backend: `${ICON_BASE_URL}/assets/images/event_images/secure-backend.webp`,
  },

  transportation: {
    FIVE_connectivity: `${ICON_BASE_URL}/assets/images/transportation/5g-connectivity.webp`,
    blockchain: `${ICON_BASE_URL}/assets/images/transportation/blockchain.webp`,
    computer_vision: `${ICON_BASE_URL}/assets/images/transportation/computer-vision.webp`,
    internet_of_things: `${ICON_BASE_URL}/assets/images/transportation/internet-of-things.webp`,
    predictive_analytic: `${ICON_BASE_URL}/assets/images/transportation/predictive-analytic.webp`,
    deep_dive_market_analysis: `${ICON_BASE_URL}/assets/images/transportation/deep-dive-market-analysis.webp`,
    mvp_feature_prioritization: `${ICON_BASE_URL}/assets/images/transportation/mvp-feature-prioritization.webp`,
    predictive_analytics_transportation: `${ICON_BASE_URL}/assets/images/transportation/predictive-analytic.webp`,
    robust_backend_api_integration: `${ICON_BASE_URL}/assets/images/transportation/robust-backend-api-integration.webp`,
    ux_design: `${ICON_BASE_URL}/assets/images/transportation/ux-design.webp`,
    rigorous_qa_soft_launch: `${ICON_BASE_URL}/assets/images/transportation/rigorous-qa-soft-launch.webp`,
    fleet_management_systems: `${ICON_BASE_URL}/assets/images/transportation/fleet-management-systems.webp`,
    logistics_optimization: `${ICON_BASE_URL}/assets/images/transportation/logistics-optimization.webp`,
    on_demand_transportation_consultation: `${ICON_BASE_URL}/assets/images/transportation/on-demand-transportation-consultation.webp`,
    real_time_tracking: `${ICON_BASE_URL}/assets/images/transportation/real-time-tracking.webp`,
  },

  resturant_images: {
    deployment_and_launch: `${ICON_BASE_URL}/assets/images/resturant_images/deployment_and_launch.webp`,
    ideation_and_consultation: `${ICON_BASE_URL}/assets/images/resturant_images/ideation-and-consultation.webp`,
    maintenance_and_support: `${ICON_BASE_URL}/assets/images/resturant_images/maintenance-and-support.webp`,
    planning_and_assistance: `${ICON_BASE_URL}/assets/images/resturant_images/planning-and-assistance.webp`,
    testing_and_quality_assurance: `${ICON_BASE_URL}/assets/images/resturant_images/testing-and-quality-assurance.webp`,
    ux_design_resturant: `${ICON_BASE_URL}/assets/images/resturant_images/ux-design.webp`,
    app_development: `${ICON_BASE_URL}/assets/images/resturant_images/app-development.webp`,
  },

  ourProcess: {
    Testing_and_Quality_Assurance_process: `${ICON_BASE_URL}/assets/images/our_process/Testing_and_Quality_Assurance.webp`,
    Deployment_and_Support: `${ICON_BASE_URL}/assets/images/our_process/Deployment_and_Support.webp`,
    Final_Development: `${ICON_BASE_URL}/assets/images/our_process/Final_Development.webp`,
    Analysis_and_Planning: `${ICON_BASE_URL}/assets/images/our_process/Market-Analysis_and_Planning.webp`,
    Strategy_Development: `${ICON_BASE_URL}/assets/images/our_process/Strategy_Development.webp`,
    Wireframe_and_UIUX_Design: `${ICON_BASE_URL}/assets/images/our_process/Wireframe_and_UIUX_Design.webp`,
  },

  ourMission1: `${ICON_BASE_URL}/assets/images/Our_Mission_1.png`,
  ourMission2: `${ICON_BASE_URL}/assets/images/Our_Mission_2.png`,
  ourMission3: `${ICON_BASE_URL}/assets/images/Our_Mission_3.png`,

  ourClients: {
    automotive: `${ICON_BASE_URL}/assets/images/our-clients/automotive.webp`,
    bankingFinance: `${ICON_BASE_URL}/assets/images/our-clients/banking-finance.webp`,
    construction: `${ICON_BASE_URL}/assets/images/our-clients/construction.webp`,
    foodBeverages: `${ICON_BASE_URL}/assets/images/our-clients/food-beverages.webp`,
    government: `${ICON_BASE_URL}/assets/images/our-clients/government.webp`,
    hotalRestorant: `${ICON_BASE_URL}/assets/images/our-clients/hotal-and-restorant.webp`,
    informationTechnology: `${ICON_BASE_URL}/assets/images/our-clients/information-technology.png`,
    logisticSupply: `${ICON_BASE_URL}/assets/images/our-clients/logistic-and-supply.webp`,
    printingPublishing: `${ICON_BASE_URL}/assets/images/our-clients/printing-and-publishing.png`,
    printingPublishing2: `${ICON_BASE_URL}/assets/images/our-clients/printing-and-publishing-2.png`,
    securityInvestigation: `${ICON_BASE_URL}/assets/images/our-clients/security-investigation.png`,
    enterpriceAppPop: `${ICON_BASE_URL}/assets/images/our-clients/enterprice-app-pop.webp`,
    enterpriceWebApplication: `${ICON_BASE_URL}/assets/images/our-clients/enterprice-web-application.png`,
    bibbleJone: `${ICON_BASE_URL}/assets/images/our-clients/bibble-jone.webp`,
    sportsSocialCommunity: `${ICON_BASE_URL}/assets/images/our-clients/sports-social-community.png`,
    saasBasedEnterpriceSolution: `${ICON_BASE_URL}/assets/images/our-clients/saas-based-enterprice-solution.png`,
    educationActivitiesForKids: `${ICON_BASE_URL}/assets/images/our-clients/education-activities-for-kids.png`,
    marketingAdvertisment: `${ICON_BASE_URL}/assets/images/our-clients/marketing-advertisment.png`,
    foodAndBeverages: `${ICON_BASE_URL}/assets/images/our-clients/food-and-beverages.webp`,
    platformForProfessionalInterpretater: `${ICON_BASE_URL}/assets/images/our-clients/platform-for-professional-interpretater.png`,
    eventAndTicketing: `${ICON_BASE_URL}/assets/images/our-clients/event-and-ticketing.webp`,
  },

  ourDevelopmentProcess: {
    step1: `${ICON_BASE_URL}/assets/images/our-development-process/step-1.webp`,
    step2: `${ICON_BASE_URL}/assets/images/our-development-process/step-2.webp`,
    step3: `${ICON_BASE_URL}/assets/images/our-development-process/step-3.webp`,
    step4: `${ICON_BASE_URL}/assets/images/our-development-process/step-4.webp`,
    step5: `${ICON_BASE_URL}/assets/images/our-development-process/step-5.webp`,
    step6: `${ICON_BASE_URL}/assets/images/our-development-process/step-6.webp`,
  },

  projectCommunicationStrategy: {
    step1: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step1.webp`,
    step2: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step2.webp`,
    step3: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step3.webp`,
    step4: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step4.webp`,
    step5: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step5.webp`,
    step6: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step6.webp`,
    step7: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step7.webp`,
    step8: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step8.webp`,
    step9: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step9.webp`,
    step10: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step10.webp`,
    step11: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step11.webp`,
    step12: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step12.webp`,
    step13: `${ICON_BASE_URL}/assets/images/project-communication-stretegy/step13.webp`,
  },

  resources: {
    whitelabel1: `${ICON_BASE_URL}/assets/images/resources/whitelabel1.webp`,
    whitelabel2: `${ICON_BASE_URL}/assets/images/resources/whitelabel2.webp`,
    whitelabel3: `${ICON_BASE_URL}/assets/images/resources/whitelabel3.webp`,
    whitelabel4: `${ICON_BASE_URL}/assets/images/resources/whitelabel4.webp`,
    whitelabel5: `${ICON_BASE_URL}/assets/images/resources/whitelabel5.webp`,
    whitelabel6: `${ICON_BASE_URL}/assets/images/resources/whitelabel6.webp`,
    whitelabel7: `${ICON_BASE_URL}/assets/images/resources/whitelabel7.webp`,
    whitelabel8: `${ICON_BASE_URL}/assets/images/resources/whitelabel8.webp`,
    whitelabel9: `${ICON_BASE_URL}/assets/images/resources/whitelabel9.webp`,
  },

  solutionPage: {
    FAD_AI_Image: `${ICON_BASE_URL}/assets/images/food-delivery-solution/ai.webp`,
    FAD_Blockchain_Image: `${ICON_BASE_URL}/assets/images/food-delivery-solution/blockchain.webp`,
    FAD_Business_Intelligence_Imag: `${ICON_BASE_URL}/assets/images/food-delivery-solution/Business_Intelligence .png`,
    FAD_Data_Science_Analytics_Image: `${ICON_BASE_URL}/assets/images/food-delivery-solution/data-science.webp`,
    FAD_Internet_of_Things_Image: `${ICON_BASE_URL}/assets/images/food-delivery-solution/Internet of Things.webp`,
    FAD_Generative_AI: `${ICON_BASE_URL}/assets/images/food-delivery-solution/generative-ai.webp`,
  },

  press_release_bg: `${ICON_BASE_URL}/assets/images/press-release/press-release-bg.webp`,
  Awards_Membership_bg: `${ICON_BASE_URL}/assets/images/awards-members-bg.webp`,
  our_team: `${ICON_BASE_URL}/assets/images/about/team.webp`,
  jurney_arrow: `${ICON_BASE_URL}/assets/images/about/jurney-arrow.svg`,
  date_2003: timeLineImage1,
  date_2008: timeLineImage2,
  date_2013: timeLineImage3,
  date_2018: timeLineImage4,
  date_2023: timeLineImage5,
  date_2026: timeLineImage6,
  about: `${ICON_BASE_URL}/assets/images/about/about.webp`,
  about_3: `${ICON_BASE_URL}/assets/images/about/about-3.webp`,
  what_shape_us: `${ICON_BASE_URL}/assets/images/about/what-shape-konstant.webp`,
  about_us_hero_bg: `${ICON_BASE_URL}/assets/images/about-hero-bg.webp`,
  about_us_hero: `${ICON_BASE_URL}/assets/images/about-hero.webp`,
  tagDividerWhite: `${ICON_BASE_URL}/assets/images/tag-devider-white.webp`,
  whitepaper: `${ICON_BASE_URL}/assets/images/whitepaper.webp`,
  aiCaseStudy: aiCaseStudy,
  statsBg: `${ICON_BASE_URL}/assets/icons/new-stats-bg.webp`,
  cardGlobePattern: `${ICON_BASE_URL}/assets/icons/card-globe.webp`,
  lastCardPattern: `${ICON_BASE_URL}/assets/icons/last-card-pattern.png`,
  bizChatStudy: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-study.svg`,
  fmiStudy: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/fmi-study.svg`,
  peeplVerseStudy: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peeplverse-study.svg`,
  matchMatchStudy: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-study.svg`,
  allProStudy: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-study.svg`,
  taglineBg: `${ICON_BASE_URL}/assets/icons/taglinebg.webp`,
  customerConfusionIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/customer-confusion-icon.svg`,
  poorSeoIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/poor-seo-icon.svg`,
  scalabilityIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/scalability-icon.svg`,
  repetativeAnalysisIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/repetative-analysis-icon.svg`,
  dataInteractivityIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/data-interactivity-icon.svg`,
  slowPublishingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/slow-publishing-icon.svg`,
  highEditorialIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/high-editorial-icon.svg`,
  fragmentedPersonalityIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/fragmented-personality-icon.svg`,
  affiliateDataIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/affiliate-data-icon.svg`,
  inconsistentContentIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/inconsistent-content-icon.svg`,
  manualReportingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/manual-reporting-icon.svg`,
  staticRecruitmentIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/static-recruitment-icon.svg`,
  limitedCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/limited-candidate-icon.svg`,
  difficultShortlistingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/difficult-shortlisting-icon.svg`,
  manualCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/manual-candidate.svg`,
  timeConsumingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/time-consuming-icon.svg`,
  poorSearchIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/poor-search-icon.svg`,
  higherCartIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/higher-cart-icon.svg`,
  increasedSupportIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/increased-support-icon.svg`,
  manualFileIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/manual-file-icon.svg`,
  slowerProductionIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/slower-production-icon.svg`,
  reducedConversionIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/reduced-conversion-icon.svg`,
  delayedResponseIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/delayed-response-icon.svg`,
  customerTrackingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/customer-tracking-icon.svg`,
  uncontrolledAiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/uncontrolled-ai-icon.svg`,
  highStaffingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/high-staffing-icon.svg`,
  manualOrderIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/manual-order-icon.svg`,
  allProSolution: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-solution-1.webp`,
  bizChatSolution: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-solution-1.webp`,
  fmiSolution: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/fmi-solution-1.webp`,
  peeplVerseSolution: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peeplverse-solution-1.webp`,
  matchMindSolution: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-solution-1.webp`,
  allProChoose1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-1.svg`,
  allProChoose2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-2.svg`,
  peepleChoose3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-choose-3.svg`,
  peepleChoose5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-choose-5.svg`,
  peepleChoose6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-choose-6.svg`,
  allProChoose3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-3.svg`,
  allProChoose4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-4.svg`,
  allProChoose5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-5.svg`,
  allProChoose6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-choose-6.svg`,
  allProImpact1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-1.svg`,
  allProImpact2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-2.svg`,
  allProImpact3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-3.svg`,
  allProImpact4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-4.svg`,
  allProImpact5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-5.svg`,
  allProImpact6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-impact-6.svg`,
  matchMindImpact1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-1.svg`,
  matchMindImpact2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-2.svg`,
  matchMindImpact3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-3.svg`,
  matchMindImpact4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-4.svg`,
  matchMindImpact5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-5.svg`,
  matchMindImpact6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-impact-6.svg`,
  peeplImpact1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-1.svg`,
  peeplImpact2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-2.svg`,
  peeplImpact3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-3.svg`,
  peeplImpact4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-4.svg`,
  peeplImpact5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-5.svg`,
  peeplImpact6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-impact-6.svg`,
  bizChatChoose1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-choose-1.svg`,
  bizChatChoose3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-choose-3.svg`,
  matchMindChoose3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-choose-3.svg`,
  matchMindChoose4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-choose-4.svg`,
  matchMindChoose5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-choose-5.svg`,
  matchMindChoose6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-choose-6.svg`,
  bizChatChoose4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-choose-4.svg`,
  bizChatChoose5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-choose-5.svg`,
  bizChatChoose6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-choose-6.svg`,
  allProCtaBg: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-cta-bg.webp`,
  allProCtaMockup: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-cta-mockup.webp`,
  bizChatCtaMockup: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-cta-mockup.webp`,
  fmiCtaMockup: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/fmi-cta-mockup.webp`,
  matchMindPoster: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-poster.webp`,
  peeplVersePoster: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peeplverse-poster.webp`,
  industryNewArrow: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/industry-new-arrow-icon.svg`,
  allProArch1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-1.svg`,
  allProArch2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-2.svg`,
  allProArch3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-3.svg`,
  allProArch4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-4.svg`,
  allProArch5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-5.svg`,
  allProArch6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-arch-6.svg`,
  aiWorkflowIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-workflow-icon.svg`,
  allProEmerging1: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-1.webp`,
  innovationStaticIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/innovation-static-icon.svg`,
  promptEngIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/prompt-eng.svg`,
  bigSemanticIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/big-semantic-vector.svg`,
  aiWorkAutoIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-work-automation.svg`,
  runtimeAffiliateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/runtime-affiliate.svg`,
  humanLoopIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/human-loop.svg`,
  llmPoweredIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/llm-powered.svg`,
  aiAgentOrchesIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-agent-orches.svg`,
  aiRelationMappingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-relation-mapping.svg`,
  aiRecruiterIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-recruiter.svg`,
  aiSearchIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-search.svg`,
  bigContextAwareIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/big-context-aware.svg`,
  intCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/int-candidate.svg`,
  semanticCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/semantic-candidate.svg`,
  aiProcessingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-processing.svg`,
  aiContentIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-content.svg`,
  aiAutomatedIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-automated.svg`,
  aiSeoIntIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-seo-int.svg`,
  aiMarketInsightIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-market-insight.svg`,
  intelligentDatasetIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/intelligent-dataset.svg`,
  realTimeMsgIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/real-time-msg.svg`,
  multiTenantIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/multi-tenant-icon.svg`,
  contextAwareIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/context-aware.svg`,
  aiCostOptmIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-cost-optm.svg`,
  aiRoutingIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-routing.svg`,
  bigConvAiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/big-conv-ai.svg`,
  hybridAiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/hybrid-ai-icon.svg`,
  langChainOrchesIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/langchain-orches.svg`,
  bigRagIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/big-rag-icon.svg`,
  allProEmerging2: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-2.webp`,
  allProEmerging3: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-3.webp`,
  allProEmerging4: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-4.webp`,
  allProEmerging5: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-5.webp`,
  allProEmerging6: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-emerging-6.webp`,
  allProCaseStudyBg: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-case-study-bg.webp`,
  allProCaseStudyMain: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/all-pro-main-case-study.webp`,
  bizChatCaseStudyMain: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/biz-chat-main-case-study.webp`,
  fmiCaseStudyMain: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/fmi-poster.webp`,
  peeplCaseStudyMain: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/peepl-main-case-study.webp`,
  matchMindCaseStudyMain: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/match-mind-main-case-study.webp`,
  noiseTexture: `${ICON_BASE_URL}/assets/images/noise-texture.webp`,
  hireDedicatedDeveloperBannerJpg: `${ICON_BASE_URL}/assets/images/hire-developer-bg.webp`,
  ai_text: `${ICON_BASE_URL}/assets/images/AI_text.webp`,
  industryLandingPageBannerJpg: `${ICON_BASE_URL}/assets/images/industry-landing-bg.webp`,
  realestatebg: `${ICON_BASE_URL}/assets/images/real_estate.webp`,
  laravel_bg: `${ICON_BASE_URL}/assets/images/laravel_bg.svg`,
  ruby_bg: `${ICON_BASE_URL}/assets/images/ruby_bg.svg`,
  html_bg: `${ICON_BASE_URL}/assets/images/html_bg.svg`,
  dotnet_bg: `${ICON_BASE_URL}/assets/images/dotnet_bg.svg`,
  java_bg: `${ICON_BASE_URL}/assets/images/java_bg.svg`,
  joomla_bg: `${ICON_BASE_URL}/assets/images/joomla_bg.svg`,
  kotlin_bg: `${ICON_BASE_URL}/assets/images/kotlin_bg.svg`,
  maui_bg: `${ICON_BASE_URL}/assets/images/maui_bg.svg`,
  mean_bg: stackAssets.mean.bg,
  vue_bg: frameworkAssets.vue.bg,
  wordpress_bg: `${ICON_BASE_URL}/assets/images/wordpress_bg.svg`,

  // AWS_bg: `${ICON_BASE_URL}/assets/images/AWS_bg.svg`,
  // GCP_bg: `${ICON_BASE_URL}/assets/images/GCP_bg.svg`,
  // Odoo_bg: `${ICON_BASE_URL}/assets/images/Odoo_bg.svg`,
  // Stripe_bg: `${ICON_BASE_URL}/assets/images/Stripe_bg.svg`,
  AWS_bg: AWS_bg,
  GCP_bg: GCP_bg,
  Odoo_bg: Odoo_bg,
  Stripe_bg: Stripe_bg,

  three_bg: `${ICON_BASE_URL}/assets/images/three_bg.svg`,
  mern_bg: stackAssets.mern.bg,
  react_bg: `${ICON_BASE_URL}/assets/images/react_bg.svg`,
  magento_bg: ecommerceAssets.magento.bg,
  shopify_bg: ecommerceAssets.shopify.bg,
  woo_bg: `${ICON_BASE_URL}/assets/images/woo_bg.svg`,
  swift_bg: `${ICON_BASE_URL}/assets/images/swift_bg.svg`,
  ionic_bg: `${ICON_BASE_URL}/assets/images/ionic_bg.svg`,
  ios_bg: `${ICON_BASE_URL}/assets/images/ios_bg.svg`,
  nodejs_bg: nodeAssets.node.bg,
  django_bg: djangoAssets.django.bg,

  angular_bg: `${ICON_BASE_URL}/assets/images/angular_bg.svg`,
  android_bg: `${ICON_BASE_URL}/assets/images/android_bg.svg`,
  fullstack_bg: `${ICON_BASE_URL}/assets/images/fullstack_bg.svg`,
  cakephp_bg: cakephpAssets.cakephp.bg,
  codeigniter_bg: codeigniterAssets.codeigniter.bg,
  python_bg: pythonAssets.python.bg,
  phpPng: `${ICON_BASE_URL}/assets/images/php.webp`,
  php_bg: `${ICON_BASE_URL}/assets/images/php_bg.svg`,
  nodejsPng: `${ICON_BASE_URL}/assets/images/nodejs.webp`,
  partner1Png: `${ICON_BASE_URL}/assets/images/partner-1.webp`,
  partner2Png: `${ICON_BASE_URL}/assets/images/partner-2.webp`,
  partner3Png: `${ICON_BASE_URL}/assets/images/partner-3.webp`,
  partner4Png: `${ICON_BASE_URL}/assets/images/partner-4.webp`,
  partner5Png: `${ICON_BASE_URL}/assets/images/partner-5.webp`,
  partner6Png: `${ICON_BASE_URL}/assets/images/partner-6.webp`,
  partner7Png: `${ICON_BASE_URL}/assets/images/partner-7.webp`,
  partner8Png: `${ICON_BASE_URL}/assets/images/partner-8.webp`,
  partner9Png: `${ICON_BASE_URL}/assets/images/partner-9.webp`,
  pythonPng: `${ICON_BASE_URL}/assets/images/python.webp`,
  reactPng: `${ICON_BASE_URL}/assets/images/react.webp`,
  reactNativePng: `${ICON_BASE_URL}/assets/images/react-native.webp`,
  progressiveJpg: `${ICON_BASE_URL}/assets/images/progressive.webp`,
  rubyPng: `${ICON_BASE_URL}/assets/images/ruby.webp`,
  swiftPng: `${ICON_BASE_URL}/assets/images/swift.webp`,
  threePng: `${ICON_BASE_URL}/assets/images/three.webp`,
  typescriptPng: `${ICON_BASE_URL}/assets/images/typescript.webp`,
  starsSvg: `${ICON_BASE_URL}/assets/images/stars.svg`,
  serviceJpg: `${ICON_BASE_URL}/assets/images/service.webp`,
  service1Png: `${ICON_BASE_URL}/assets/images/mobile-app-services.webp`,
  service2Png: `${ICON_BASE_URL}/assets/images/service landing page/ai-ml-development-services.webp`,
  service3Png: `${ICON_BASE_URL}/assets/images/service landing page/web-development-services.webp`,
  service4Png: `${ICON_BASE_URL}/assets/images/service landing page/cloud-services-services.webp`,
  service5Png: `${ICON_BASE_URL}/assets/images/service landing page/hire-dedicated-developes-services.webp`,
  service6Png: `${ICON_BASE_URL}/assets/images/service landing page/it-consulting-services.webp`,
  AI_SVG: `${ICON_BASE_URL}/assets/images/AI_SVG.svg`,
  flutter_bg: `${ICON_BASE_URL}/assets/images/flutterbg.svg`,
  calendartext: `${ICON_BASE_URL}/assets/images/calendartext.png`,
  djangoPng: `${ICON_BASE_URL}/assets/images/django.webp`,
  dotnetPng: `${ICON_BASE_URL}/assets/images/dotnet.webp`,
  drupalPng: `${ICON_BASE_URL}/assets/images/drupal.webp`,
  ionicPng: `${ICON_BASE_URL}/assets/images/ionic.webp`,
  iosPng: `${ICON_BASE_URL}/assets/images/ios.webp`,
  javaPng: `${ICON_BASE_URL}/assets/images/java.webp`,
  kotlinPng: `${ICON_BASE_URL}/assets/images/kotlin.webp`,
  laravelPng: `${ICON_BASE_URL}/assets/images/laravel.webp`,
  magentoPng: `${ICON_BASE_URL}/assets/images/magento.webp`,
  mobilePng: `${ICON_BASE_URL}/assets/images/mobile.webp`,
  mobileDevelopmentJpg: mobileBannerImage,
  mobileDevelopmentPng: `${ICON_BASE_URL}/assets/images/mobile-development.webp`,
  konstantLogoSvg: `${ICON_BASE_URL}/assets/images/konstant-logo.svg`,
  industryDetailsBannerJpg: `${ICON_BASE_URL}/assets/images/industry-details-banner.webp`,
  industryPageBgPng: `${ICON_BASE_URL}/assets/images/industry-page-bg.webp`,

  food_and_resturant_page: {
    Cloud_Kitchen_Management_Solutions: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Cloud_Kitchen_Management_Solutions.webp`,
    Food_Delivery_App_Development: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Food_Delivery_App_Development.webp`,
    Multi_Chain_Restaurant_App_Development: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Multi_Chain_Restaurant_App_Development.webp`,
    Order_Inventory_Management_Solutions: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Order_Inventory_Management_Solutions.webp`,
    Restaurant_Discount_Rewards_App_Development:
      Restaurant_Discount_Rewards_App_Development,
    Restaurant_Finde_Booking_App: Restaurant_Finde_Booking_App,
    Customer_Food_Delivery_App: Customer_Food_Delivery_App,
    Online_Food_Ordering_App: Online_Food_Ordering_App,
    Waiting_Management_App: Waiting_Management_App,
    Table_Reservation_App: Table_Reservation_App,
    Restaurant_PoS_Software_Development: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Restaurant_PoS_Software_Development.webp`,
    Restaurant_Web_Portal_Development: Restaurant_Web_Portal_Development,

    AI_ML: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/AI_ML.webp`,
    Blockchain: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Blockchain.webp`,
    Chatbots: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Chatbots.webp`,
    Facial_Recognition: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Facial_Recognition.webp`,
    AR_and_VR: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/AR_and_VR.webp`,
    Cloud_Technology: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Cloud_Technology.webp`,
    Sentiment_Models_and_NLP: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Sentiment_Models_and_NLP.webp`,
    Voice_powered_Search: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Voice_powered_Search.webp`,
    Geofencing: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Geofencing.webp`,
    Metaverse: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Metaverse.webp`,
    IoT: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/IoT.webp`,

    App_Development: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/App_Development.webp`,
    Deployment_and_Launch: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Deployment_and_Launch.webp`,
    Ideation_and_Consultation: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Ideation_and_Consultation.webp`,
    Planning_and_Assistance: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Planning_and_Assistance.webp`,
    Testing_and_Quality_Assurance: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Testing_and_Quality_Assurance.webp`,
    UX_Design: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/UX_Design.webp`,
    Maintenance_and_Support: `${ICON_BASE_URL}/assets/images/Food_and_restaurant/Maintenance_and_Support.webp`,
  },
  aboutBrand: aboutAssets.aboutBrands,

  crossPlatformEmergingTech: {
    crossPlatformEmerging1: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/ai-and-ml-cross-platform.webp`,
    crossPlatformEmerging2: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-blockchain.webp`,
    crossPlatformEmerging3: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-generative-ai.webp`,
    crossPlatformEmerging4: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-internet-of-things.webp`,
    crossPlatformEmerging5: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-metaverse.webp`,
    crossPlatformEmerging6: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-pwa.webp`,
    crossPlatformEmerging7: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-vr.webp`,
    crossPlatformEmerging8: `${ICON_BASE_URL}/assets/images/Cross-platform/emerging tech/cross-platform-wearable.webp`,
  },

  crossPlatformProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Cross-platform/process/discovery-cross-platform.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Cross-platform/process/project-planning-cross-platform.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Cross-platform/process/cross-platform-design.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Cross-platform/process/project-development-cross-platform.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Cross-platform/process/testing-cross-platform.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Cross-platform/process/deployment-and-launch-cross-platform.webp`,
    process7: `${ICON_BASE_URL}/assets/images/Cross-platform/process/post-launch-support-cross-platform.webp`,
  },

  ecommerceEmergingTech: {
    ecommerceEmerging1: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/emerging-tech/ecommerce-ai.webp`,
    ecommerceEmerging2: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/emerging-tech/ecommerce-vr.webp`,
    ecommerceEmerging3: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/emerging-tech/blockchain-ecommerce.webp`,
    ecommerceEmerging4: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/emerging-tech/ecommerce-iot.webp`,
    ecommerceEmerging5: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/emerging-tech/ecommerce-voice-commerce.webp`,
  },

  ecommerceProcess: {
    process1: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/process/ecommerce-design.webp`,
    process2: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/process/ecommerce-implementation.webp`,
    process3: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/process/ecommerce-post-launch-support.webp`,
    process4: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/process/ecommerce-project-planning.webp`,
    process5: `${ICON_BASE_URL}/assets/images/ecommerce-web-development/process/ecommerce-testing-and-qa.webp`,
  },

  blockchainProcess: {
    process1: `${ICON_BASE_URL}/assets/images/blockchain-development/process/deployment-blockchain.webp`,
    process2: `${ICON_BASE_URL}/assets/images/blockchain-development/process/development-integrationt-blockchain.webp`,
    process3: `${ICON_BASE_URL}/assets/images/blockchain-development/process/initial-understandingt-blockchain.webp`,
    process4: `${ICON_BASE_URL}/assets/images/blockchain-development/process/stakeholder-mappingt-blockchain.webp`,
    process5: `${ICON_BASE_URL}/assets/images/blockchain-development/process/technical-designt-blockchain.webp`,
    process6: `${ICON_BASE_URL}/assets/images/blockchain-development/process/use-case-definitiont-blockchain.webp`,
  },

  blockchainPlatforms: {
    platform1: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/algorand.webp`,
    platform2: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/avalanche.webp`,
    platform3: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/binance-smart-chain.webp`,
    platform4: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/cardano.webp`,
    platform5: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/corda.webp`,
    platform6: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/eos.webp`,
    platform7: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/ethereum.webp`,
    platform8: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/hyperledger-fabric.webp`,
    platform9: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/polkadot.webp`,
    platform10: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/polygon.webp`,
    platform11: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/quorum.webp`,
    platform12: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/solana.webp`,
    platform13: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/stellar.webp`,
    platform14: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/sui.webp`,
    platform15: `${ICON_BASE_URL}/assets/images/blockchain-development/platforms/tron.webp`,
  },

  hireDedicatedProcess: {
    process1: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/dedicated-developers-discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/evaluation-and-interviews.webp`,
    process3: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/ongoing-support-and-monitoring.webp`,
    process4: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/seamless-onboarding.webp`,
    process5: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/tailored-developer-shortlisting.webp`,
    process6: `${ICON_BASE_URL}/assets/images/hire-dedicated-developers/our-hiring-process/technical-roadmap-alignment.webp`,
  },

  iotEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/agriculture-and-farming-solutions.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/artificial-intelligence-of-things.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/connected-vehicle-and-fleet-management.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/healthcare-monitoring-systems.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/industrial-iot-solutions.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/remote-asset-monitoring.webp`,
    emerging7: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/smart-energy-solutions.webp`,
    emerging8: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/smart-home-solutions.webp`,
    emerging9: `${ICON_BASE_URL}/assets/images/Iot-development/emerging/wearable-iot-solutions.webp`,
  },

  iotProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-integration-and-testing.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-post-launch-support.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-project-development.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-project-planning.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Iot-development/process/iot-prototype-design.webp`,
  },

  cloudEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/Cloud-application/emerding/ai-and-machine-learning-cloud.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/Cloud-application/emerding/big-data-cloud.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Cloud-application/emerding/blockchain-cloud.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Cloud-application/emerding/edge-computing-cloud.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Cloud-application/emerding/internet-of-things-cloud.webp`,
  },

  cloudProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Cloud-application/process/cloud-architecture-design.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Cloud-application/process/cloud-deployment.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Cloud-application/process/cloud-maintenance.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Cloud-application/process/cloud-monitoring.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Cloud-application/process/cloud-requirement-analysis.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Cloud-application/process/development-cloud.webp`,
  },

  itConsultingEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/ai-consulting.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/blockchain-consulting.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/cloud-computing-consulting.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/cybersecurity-consulting.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/devops-consulting.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/image-analysis-consulting.webp`,
    emerging7: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/iot-consulting.webp`,
    emerging8: `${ICON_BASE_URL}/assets/images/it-consulting/emerging/vr-consulting.webp`,
  },

  itConsultingProcess: {
    process1: `${ICON_BASE_URL}/assets/images/it-consulting/process/analysis.webp`,
    process2: `${ICON_BASE_URL}/assets/images/it-consulting/process/continuous-enhancement.webp`,
    process3: `${ICON_BASE_URL}/assets/images/it-consulting/process/deployment.webp`,
    process4: `${ICON_BASE_URL}/assets/images/it-consulting/process/optimization.webp`,
    process5: `${ICON_BASE_URL}/assets/images/it-consulting/process/performance.webp`,
    process6: `${ICON_BASE_URL}/assets/images/it-consulting/process/strategy.webp`,
  },

  maintenanceEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/maintance-support/emerging/adaptive-software-maintenance.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/maintance-support/emerging/corrective-software-maintenance.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/maintance-support/emerging/perfective-software-maintenance.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/maintance-support/emerging/preventive-software-maintenance.webp`,
  },

  maintenanceProcess: {
    process1: `${ICON_BASE_URL}/assets/images/maintance-support/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/maintance-support/process/implementation.webp`,
    process3: `${ICON_BASE_URL}/assets/images/maintance-support/process/maintenance-strategy.webp`,
    process4: `${ICON_BASE_URL}/assets/images/maintance-support/process/ongoing-support.webp`,
    process5: `${ICON_BASE_URL}/assets/images/maintance-support/process/roadmap-development.webp`,
    process6: `${ICON_BASE_URL}/assets/images/maintance-support/process/system-audit.webp`,
  },

  enterpriseEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/Metaverse.png`,
    emerging2: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/enterprise-ai-and ml.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/enterprise-blockchain.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/enterprise-cloud-computing-integration.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/enterprise-computer-vision.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/IoT.png`,
    emerging7: `${ICON_BASE_URL}/assets/images/enterprise-page/emerging/enterprise-vr.webp`,
  },

  enterpriseProcess: {
    process1: `${ICON_BASE_URL}/assets/images/enterprise-page/process/discovery-enterprise.webp`,
    process2: `${ICON_BASE_URL}/assets/images/enterprise-page/process/enterprise-app-designing.webp`,
    process3: `${ICON_BASE_URL}/assets/images/enterprise-page/process/UX Design.png`,
    process4: `${ICON_BASE_URL}/assets/images/enterprise-page/process/enterprise-development.webp`,
    process5: `${ICON_BASE_URL}/assets/images/enterprise-page/process/enterprise-deployment-and-launch.webp`,
    process6: `${ICON_BASE_URL}/assets/images/enterprise-page/process/enterprise-qa-and-testing.webp`,
    process7: `${ICON_BASE_URL}/assets/images/enterprise-page/process/Support.png`,
  },

  mobileAppEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/5g-technology.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/ai-and-ml.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/blockchain.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/cloud-computing-integration.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/computer-vision.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/internet-of-things.webp`,
    emerging7: `${ICON_BASE_URL}/assets/images/mobile-page/emerging/mobile-vr.webp`,
  },

  mobileAppProcess: {
    process1: `${ICON_BASE_URL}/assets/images/mobile-page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/mobile-page/process/app-designing.webp`,
    process3: `${ICON_BASE_URL}/assets/images/mobile-page/process/deployment-and-launch.webp`,
    process4: `${ICON_BASE_URL}/assets/images/mobile-page/process/development.webp`,
    process5: `${ICON_BASE_URL}/assets/images/mobile-page/process/product-architecture.webp`,
    process6: `${ICON_BASE_URL}/assets/images/mobile-page/process/qa-and-testing.webp`,
    process7: `${ICON_BASE_URL}/assets/images/mobile-page/process/feedback-and-maintenance.webp`,
  },

  webDevelopmentBlendingInnovation: {
    blend1: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/artificial-intelligence.webp`,
    blend2: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/augmented-reality.webp`,
    blend3: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/blockchain.webp`,
    blend4: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/cloud-computing.webp`,
    blend5: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/internet-of-things.webp`,
    blend6: `${ICON_BASE_URL}/assets/images/web-development-page/blending-innovation/virtual-reality.webp`,
  },

  webDevelopmentProcess: {
    process1: `${ICON_BASE_URL}/assets/images/web-development-page/process/kick-off.webp`,
    process2: `${ICON_BASE_URL}/assets/images/web-development-page/process/set-objectives.webp`,
    process3: `${ICON_BASE_URL}/assets/images/web-development-page/process/tech-stack-selection.webp`,
    process4: `${ICON_BASE_URL}/assets/images/web-development-page/process/design.webp`,
    process5: `${ICON_BASE_URL}/assets/images/web-development-page/process/develop.webp`,
    process6: `${ICON_BASE_URL}/assets/images/web-development-page/process/testing.webp`,
    process7: `${ICON_BASE_URL}/assets/images/web-development-page/process/launch-maintain.webp`,
  },

  webDesignEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/artificial-intelligence.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/machine-learning.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/motion-ui.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/progressive-web-apps.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/virtual-reality.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/web-design-page/emerging/voice-search.webp`,
  },

  webDesignProcess: {
    process1: `${ICON_BASE_URL}/assets/images/web-design-page/process/strategic-planning.webp`,
    process2: `${ICON_BASE_URL}/assets/images/web-design-page/process/strategy-development.webp`,
    process3: `${ICON_BASE_URL}/assets/images/web-design-page/process/launch-and-optimization.webp`,
    process4: `${ICON_BASE_URL}/assets/images/web-design-page/process/responsive-designing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/web-design-page/process/testing.webp`,
    process6: `${ICON_BASE_URL}/assets/images/web-design-page/process/visual-and-ui-design.webp`,
  },

  openSourceEmergingTech: openSourceAssets.openSource.emerging,
  openSourceProcess: openSourceAssets.openSource.process,
  qaTestingEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/agentic-ai.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/ai-ml.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/cloud-based-test-automation.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/codeless-test-automation.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/devops-cicd-integration.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/qa-testing-page/emerging/intelligent-test-orchestration.webp`,
  },

  qaTestingProcess: {
    process1: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/bug-identification-reporting.webp`,
    process2: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/client-needs-assessment.webp`,
    process3: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/continuous-optimization.webp`,
    process4: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/environment-setup.webp`,
    process5: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/planning-and-strategy.webp`,
    process6: `${ICON_BASE_URL}/assets/images/qa-testing-page/process/test-execution.webp`,
  },

  nftPlatforms: {
    platform1: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/arbitrum.webp`,
    platform2: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/avalanche.webp`,
    platform3: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/bnb-chain.webp`,
    platform4: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/ethereum.webp`,
    platform5: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/optimism.webp`,
    platform6: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/polygon.webp`,
    platform7: `${ICON_BASE_URL}/assets/images/NFT-page/platforms/tron.webp`,
  },

  nftProcess: {
    process1: `${ICON_BASE_URL}/assets/images/NFT-page/process/development.webp`,
    process2: `${ICON_BASE_URL}/assets/images/NFT-page/process/discovery.webp`,
    process3: `${ICON_BASE_URL}/assets/images/NFT-page/process/launch-and-maintenance.webp`,
    process4: `${ICON_BASE_URL}/assets/images/NFT-page/process/strategy-and-design.webp`,
    process5: `${ICON_BASE_URL}/assets/images/NFT-page/process/support.webp`,
    process6: `${ICON_BASE_URL}/assets/images/NFT-page/process/testing.webp`,
  },

  wearableEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/bluetooth-nfc.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/natural-language-processing.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/voice-assistant-integration.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/iot.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/machine-learning.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/wearable-page/emerging/vr.webp`,
  },

  wearableProcess: {
    process1: `${ICON_BASE_URL}/assets/images/wearable-page/process/requirement-analysis.webp`,
    process2: `${ICON_BASE_URL}/assets/images/wearable-page/process/wireframing-prototyping.webp`,
    process3: `${ICON_BASE_URL}/assets/images/wearable-page/process/development-phase.webp`,
    process4: `${ICON_BASE_URL}/assets/images/wearable-page/process/integrations.webp`,
    process5: `${ICON_BASE_URL}/assets/images/wearable-page/process/testing-qa.webp`,
    process6: `${ICON_BASE_URL}/assets/images/wearable-page/process/deployment-and-maintenance.webp`,
  },

  pwaEmergingTech: {
    emerging1: `${ICON_BASE_URL}/assets/images/progressive-app-page/emerging/angular-pwa.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/progressive-app-page/emerging/nodejs-pwa.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/progressive-app-page/emerging/react-pwa.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/progressive-app-page/emerging/vuejs-pwa.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/progressive-app-page/emerging/firebase-pwa.webp`,
  },

  pwaProcess: {
    process1: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/planning-and-analysis.webp`,
    process2: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/design-and-architecture.webp`,
    process3: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/core-development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/testing-and-optimization.webp`,
    process5: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/deployment-and-monitoring.webp`,
    process6: `${ICON_BASE_URL}/assets/images/progressive-app-page/process/maintenance-and-updates.webp`,
  },

  startupEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/startup-page/emerging/machine-learning.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/startup-page/emerging/cloud-solutions.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/startup-page/emerging/generative-ai.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/startup-page/emerging/artificial-intelligence.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/startup-page/emerging/internet-of-things.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/startup-page/emerging/vr.webp`,
  },

  startupProcess: {
    process1: `${ICON_BASE_URL}/assets/images/startup-page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/startup-page/process/scoping.webp`,
    process3: `${ICON_BASE_URL}/assets/images/startup-page/process/business-analysis.webp`,
    process4: `${ICON_BASE_URL}/assets/images/startup-page/process/design-sprint.webp`,
    process5: `${ICON_BASE_URL}/assets/images/startup-page/process/development.webp`,
    process6: `${ICON_BASE_URL}/assets/images/startup-page/process/evolve.webp`,
  },

  mvpEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/ai-and-ml.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/iot.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/cloud-computing.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/metaverse.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/big-data-analytics.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/mvp-page/emerging/robotics-process-automation.webp`,
  },

  mvpProcess: {
    process1: `${ICON_BASE_URL}/assets/images/mvp-page/process/research-and-planning.webp`,
    process2: `${ICON_BASE_URL}/assets/images/mvp-page/process/attractive-ui-and-ux.webp`,
    process3: `${ICON_BASE_URL}/assets/images/mvp-page/process/custom-development-process.webp`,
    process4: `${ICON_BASE_URL}/assets/images/mvp-page/process/qa-and-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/mvp-page/process/successful-app-deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/mvp-page/process/post-launch-support.webp`,
  },

  aiProcess: {
    process1: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/readiness-assessment.webp`,
    process2: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/use-case-discovery.webp`,
    process3: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/model-design.webp`,
    process4: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/validation.webp`,
    process5: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/scalable-deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/AI-page/modern-ai-technologies/monitoring.webp`,
  },

  laravelEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/ai-and-ml.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/ai-driven-voice-assistance.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/blockchain-integration.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/progressive-web-apps.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/internet-of-things.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/laravel-page/emerging/cloud-technology.webp`,
  },

  laravelProcess: {
    process1: `${ICON_BASE_URL}/assets/images/laravel-page/process/nda-and-requirement-gathering.webp`,
    process2: `${ICON_BASE_URL}/assets/images/laravel-page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/laravel-page/process/laravel-application-development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/laravel-page/process/qa-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/laravel-page/process/deployment-and-laravel-app-launch.webp`,
    process6: `${ICON_BASE_URL}/assets/images/laravel-page/process/post-launch-upgrades-and-support.webp`,
  },

  dotnetEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/dotnetpage/emerging/iot.webp`,
    emerging2: cmsAiMl,
    emerging3: `${ICON_BASE_URL}/assets/images/dotnetpage/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/dotnetpage/emerging/big-data.webp`,
    emerging5: cmsBlockchain,
    emerging6: cmsCloudComputing,
  },

  dotnetProcess: {
    process1: `${ICON_BASE_URL}/assets/images/dotnetpage/process/research.webp`,
    process2: `${ICON_BASE_URL}/assets/images/dotnetpage/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/dotnetpage/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/dotnetpage/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/dotnetpage/process/launch.webp`,
    process6: `${ICON_BASE_URL}/assets/images/dotnetpage/process/support-and-maintenance.webp`,
  },

  dotnetServices: {
    service1: `${ICON_BASE_URL}/assets/images/dotnetpage/services/custom-net-application-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/dotnetpage/services/enterprise-net-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/dotnetpage/services/net-migration.svg`,
    service4: `${ICON_BASE_URL}/assets/images/dotnetpage/services/asp.net-mvc-development.svg`,
    service5: `${ICON_BASE_URL}/assets/images/dotnetpage/services/api-development-and-integration.svg`,
    service6: `${ICON_BASE_URL}/assets/images/dotnetpage/services/net-cms-application-development.svg`,
    service7: `${ICON_BASE_URL}/assets/images/dotnetpage/services/cloud-application-development.svg`,
  },

  whyNet: {
    benefit1: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/scalability.svg`,
    benefit2: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/cross-platform-compatible.svg`,
    benefit3: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/efficiency.svg`,
    benefit4: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/versatility.svg`,
    benefit5: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/security.svg`,
    benefit6: `${ICON_BASE_URL}/assets/images/dotnetpage/why.net/integration-capabilities.svg`,
  },

  whyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/user-driven-design.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/extensive-net-expertise.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/full-transparency.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/timely-delivery.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/customer-support.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/dotnetpage/whykonstant/cost-effective.svg`,
  },

  phpEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/PHPpage/emerging/iot.webp`,
    emerging2: cmsAiMl,
    emerging3: `${ICON_BASE_URL}/assets/images/PHPpage/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/PHPpage/emerging/big-data.webp`,
    emerging5: cmsBlockchain,
    emerging6: cmsCloudComputing,
  },

  phpProcess: {
    process1: `${ICON_BASE_URL}/assets/images/PHPpage/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/PHPpage/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/PHPpage/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/PHPpage/process/qa-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/PHPpage/process/launch.webp`,
    process6: `${ICON_BASE_URL}/assets/images/PHPpage/process/software-and-maintenance.webp`,
  },

  phpServices: {
    service1: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-consulting.svg`,
    service2: `${ICON_BASE_URL}/assets/images/PHPpage/services/custom-php-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-ecommerce-development.svg`,
    service4: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-modernization-migration.svg`,
    service5: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-plugin-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-web-application-development.svg`,
    service7: `${ICON_BASE_URL}/assets/images/PHPpage/services/php-maintenance-support.svg`,
  },

  whyPHPKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/on-time-delivery.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/transparent-service.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/quality-focused.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/customized-solutions.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/business-focused-strategy.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/PHPpage/whykonstant/skilled-developers.svg`,
  },

  whyPHPProcess: {
    process1: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/accelerated-development.svg`,
    process2: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/robust-security.svg`,
    process3: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/seamless-integration.svg`,
    process4: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/versatile-and-scalable.svg`,
    process5: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/cross-platform-compatible.svg`,
    process6: `${ICON_BASE_URL}/assets/images/PHPpage/whyphp/rich-libraries.svg`,
  },

  iosEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/ios page/emerging/iot.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/ios page/emerging/cloud-computing-integration.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/ios page/emerging/ai-ml.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/ios page/emerging/metaverse.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/ios page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/ios page/emerging/augmented-reality.webp`,
  },

  iosProcess: {
    process1: `${ICON_BASE_URL}/assets/images/ios page/process/project-ideation.webp`,
    process2: `${ICON_BASE_URL}/assets/images/ios page/process/ui-ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/ios page/process/app-development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/ios page/process/quality-assurance.webp`,
    process5: `${ICON_BASE_URL}/assets/images/ios page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/ios page/process/maintenance-and-support.webp`,
  },

  iosServices: {
    service1: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-app-consultation.svg`,
    service2: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-ui-ux-design.svg`,
    service3: `${ICON_BASE_URL}/assets/images/ios page/ios services/custom-ios-app-development.svg`,
    service4: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-software-testing.svg`,
    service5: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-app-support-maintenance.svg`,
    service6: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-game-development.svg`,
    service7: `${ICON_BASE_URL}/assets/images/ios page/ios services/enterprise-ios-apps.svg`,
    service8: `${ICON_BASE_URL}/assets/images/ios page/ios services/ios-app-migration.svg`,
    service9: `${ICON_BASE_URL}/assets/images/ios page/ios services/hire-iphone-app-developers.svg`,
  },

  iosWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/skilled-developers.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/outcome-focused.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/flexible-engagement-models.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/high-end-security.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/app-store-deployment.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/ios page/whychoosekonstant/faster-development.svg`,
  },

  iosWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/high-app-revenue.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/easy-development.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/robust-infrastructure.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/standard-customer-base.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/increase-brand-recognition.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/ios page/whyiosapp/global-market-penetration.svg`,
  },

  androidEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/android page/emerging/big-data-analytics.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/android page/emerging/iot.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/android page/emerging/ai-ml.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/android page/emerging/ar-vr.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/android page/emerging/cloud-technology.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/android page/emerging/natural-language-processing.webp`,
  },

  androidProcess: {
    process1: `${ICON_BASE_URL}/assets/images/android page/process/consultation.webp`,
    process2: `${ICON_BASE_URL}/assets/images/android page/process/ui-ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/android page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/android page/process/app-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/android page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/android page/process/post-launch-support.webp`,
  },

  androidServices: {
    service1: `${ICON_BASE_URL}/assets/images/android page/android services/android-app-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/android page/android services/app-ui-ux-design.svg`,
    service3: `${ICON_BASE_URL}/assets/images/android page/android services/android-app-modernization.svg`,
    service4: `${ICON_BASE_URL}/assets/images/android page/android services/android-app-consultation.svg`,
    service5: `${ICON_BASE_URL}/assets/images/android page/android services/android-api-integration.svg`,
    service6: `${ICON_BASE_URL}/assets/images/android page/android services/android-app-testing.svg`,
    service7: `${ICON_BASE_URL}/assets/images/android page/android services/android-app-support-maintenance.svg`,
  },

  androidWhyChoose: {
    reason1: `${ICON_BASE_URL}/assets/images/android page/why choose android/scalability-flexibility.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/android page/why choose android/monetization-opportunities.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/android page/why choose android/better-communication.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/android page/why choose android/high-scalability.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/android page/why choose android/faster-time-to-market.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/android page/why choose android/vast-community.svg`,
  },

  androidWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/industry-specific-expertise.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/boost-brand-visibility.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/track-record-of-success.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/modern-technical-expertise.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/regular-updates-and-support.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/android page/why choose konstant/user-centric-design.svg`,
  },

  reactNativeEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/React native page/emerging/ar-vr.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/React native page/emerging/cloud-computing.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/React native page/emerging/ai.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/React native page/emerging/ml.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/React native page/emerging/metaverse.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/React native page/emerging/agentic-ai.webp`,
  },

  reactNativeProcess: {
    process1: `${ICON_BASE_URL}/assets/images/React native page/process/strategic-planning.webp`,
    process2: `${ICON_BASE_URL}/assets/images/React native page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/React native page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/React native page/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/React native page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/React native page/process/support.webp`,
  },

  reactNativeServices: {
    service1: `${ICON_BASE_URL}/assets/images/React native page/services/custom-react-native-app-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-app-consultation.svg`,
    service3: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-ui-ux-design.svg`,
    service4: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-code-auditing.svg`,
    service5: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-mvp.svg`,
    service6: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-app-maintenance.svg`,
    service7: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-plugin-development.svg`,
    service8: `${ICON_BASE_URL}/assets/images/React native page/services/react-native-migration.svg`,
  },

  reactNativeWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/on-time-delivery.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/quality-assurance.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/experience.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/robust-security.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/time-zone-aligned.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/React native page/why choose konstant/flexible-models.svg`,
  },

  reactNativeWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/rapid-development.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/cross-platform-support.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/streamlined-maintenance.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/code-reusability.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/fast-performance.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/React native page/Why choose react native/pre-built-components.svg`,
  },

  javaEmerging: javaAssets.java.emerging,
  javaProcess: javaAssets.java.process,
  javaServices: javaAssets.java.services,
  javaWhyJava: javaAssets.java.whyApp,
  javaWhyKonstant: javaAssets.java.whyKonstant,

  flutterEmerging: {
    emerging1: cmsAiMl,
    emerging2: `${ICON_BASE_URL}/assets/images/flutter page/emerging/ar-vr.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/flutter page/emerging/iot.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/flutter page/emerging/blockchain.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/flutter page/emerging/edge-ai.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/flutter page/emerging/cloud-computing.webp`,
  },

  flutterProcess: {
    process1: `${ICON_BASE_URL}/assets/images/flutter page/process/ideation.webp`,
    process2: `${ICON_BASE_URL}/assets/images/flutter page/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/flutter page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/flutter page/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/flutter page/process/launch.webp`,
    process6: `${ICON_BASE_URL}/assets/images/flutter page/process/maintenance.webp`,
  },

  flutterServices: {
    service1: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/custom-flutter-app-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-app-ideation-consultation.svg`,
    service3: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-app-design.svg`,
    service4: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-app-migration.svg`,
    service5: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-web-app-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-widget-customization.svg`,
    service7: `${ICON_BASE_URL}/assets/images/flutter page/flutter services/flutter-app-support-maintenance.svg`,
  },

  flutterWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/hot-reloading.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/widget-library.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/growing-ecosystem.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/multiplatform.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/better-performance.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/flutter page/why choose flutter/flexible-ui.svg`,
  },

  flutterWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/streamlined-project-flow.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/custom-solutions.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/dedicated-project-manager.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/quality-assured-solutions.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/secure-development.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/flutter page/why choose konstant/technical-expertise.svg`,
  },

  ionicEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/ionic page/emerging/ai-ml.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/ionic page/emerging/iot.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/ionic page/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/ionic page/emerging/cloud-computing.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/ionic page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/ionic page/emerging/edge-computing.webp`,
  },

  ionicProcess: {
    process1: `${ICON_BASE_URL}/assets/images/ionic page/process/research.webp`,
    process2: `${ICON_BASE_URL}/assets/images/ionic page/process/architecture.webp`,
    process3: `${ICON_BASE_URL}/assets/images/ionic page/process/design.webp`,
    process4: `${ICON_BASE_URL}/assets/images/ionic page/process/development.webp`,
    process5: `${ICON_BASE_URL}/assets/images/ionic page/process/testing.webp`,
    process6: `${ICON_BASE_URL}/assets/images/ionic page/process/deployment.webp`,
  },

  ionicServices: {
    service1: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/ionic-app-consultation.svg`,
    service2: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/custom-ionic-app-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/ux-design.svg`,
    service4: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/ionic-widget-development.svg`,
    service5: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/ionic-app-migration.svg`,
    service6: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/ionic-qa-and-testing.svg`,
    service7: `${ICON_BASE_URL}/assets/images/ionic page/ionic services/support-maintenance.svg`,
  },

  ionicWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/proven-expertise.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/agile-methodology.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/post-deployment-support.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/security-and-compliance.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/cross-platform-expertise.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/ionic page/why choose konstant/experienced-developers.svg`,
  },

  ionicWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/seamless-integration.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/quick-prototyping.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/robust-ecosystem.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/modern-ui.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/efficient-testing.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/ionic page/why ionic/cost-effective.svg`,
  },

  kotlinEmerging: {
    emerging1: cmsAiMl,
    emerging2: `${ICON_BASE_URL}/assets/images/Kotlin page/emeging/ar-vr.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Kotlin page/emeging/iot.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Kotlin page/emeging/cloud-computing.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Kotlin page/emeging/blockchain-technology.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Kotlin page/emeging/data-analytics.webp`,
  },

  kotlinProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Kotlin page/process/analyze-requirements.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Kotlin page/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Kotlin page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Kotlin page/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Kotlin page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Kotlin page/process/maintenance-support.webp`,
  },

  kotlinServices: {
    service1: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-app-consultation.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-android-app-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-app-migration.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-multiplatform-app-development.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-app-testing.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Kotlin page/kotlin services/kotlin-app-maintenance-and-support.svg`,
  },

  kotlinWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/senior-engineers.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/proficiency-in-kotlin.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/agile-methodology.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/transparency.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/dedicated-team.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Kotlin page/why choose konstant/agile-approach.svg`,
  },

  kotlinWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/concise-coding.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/java-interoperability.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/smart-compiler.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/easy-to-maintain.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/strong-community.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Kotlin page/why kotlin/safe-and-secure.svg`,
  },

  angularEmerging: {
    emerging1: cmsAiMl,
    emerging2: `${ICON_BASE_URL}/assets/images/Angular page/emerging/ar-vr.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Angular page/emerging/iot.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Angular page/emerging/cloud-computing.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Angular page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Angular page/emerging/data-analytics.webp`,
  },

  angularProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Angular page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Angular page/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Angular page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Angular page/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Angular page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Angular page/process/maintenance.webp`,
  },

  angularServices: {
    service1: `${ICON_BASE_URL}/assets/images/Angular page/services/angular-consulting-services.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Angular page/services/angular-web-app-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Angular page/services/single-page-applications.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Angular page/services/angular-migration-services.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Angular page/services/angular-support-maintenance-services.svg`,
  },

  angularWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/enhanced-user-experience.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/community-support.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/offers-responsiveness.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/simplified-development.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/improved-efficiency.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Angular page/Why Angular/seamless-integration.svg`,
  },

  angularWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/tailored-solutions.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/quality-focused.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/agile-development.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/seamless-communication.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/timely-delivery.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Angular page/why konstant/transparent-pricing.svg`,
  },

  whyKonstantImages: {
    onDemandWhyKonstant1: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/niche-focused-solutions.svg`,
    onDemandWhyKonstant2: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/one-stop-solution-provider.svg`,
    onDemandWhyKonstant3: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/transparency-and-integrity.svg`,
    onDemandWhyKonstant4: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/versatile-portfolio.svg`,
    onDemandWhyKonstant5: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/personalized-experience.svg`,
    onDemandWhyKonstant6: `${ICON_BASE_URL}/assets/images/on-demand page/why konstant/own-your-intellectual-property.svg`,
  },

  emergingTechImages: {
    elearningEmergingTech1: `${ICON_BASE_URL}/assets/images/elearning page/emerging/ai-and-ml.webp`,
    elearningEmergingTech2: `${ICON_BASE_URL}/assets/images/elearning page/emerging/ar-and-vr.webp`,
    elearningEmergingTech3: `${ICON_BASE_URL}/assets/images/elearning page/emerging/big-data.webp`,
    elearningEmergingTech4: `${ICON_BASE_URL}/assets/images/elearning page/emerging/blockchain.webp`,
    elearningEmergingTech5: `${ICON_BASE_URL}/assets/images/elearning page/emerging/cloud-computing.webp`,
    elearningEmergingTech6: `${ICON_BASE_URL}/assets/images/elearning page/emerging/gamification.webp`,
    elearningEmergingTech7: `${ICON_BASE_URL}/assets/images/elearning page/emerging/iot.webp`,
    elearningEmergingTech8: `${ICON_BASE_URL}/assets/images/elearning page/emerging/metaverse.webp`,
    elearningEmergingTech9: `${ICON_BASE_URL}/assets/images/elearning page/emerging/microlearning.webp`,
    elearningEmergingTech10: `${ICON_BASE_URL}/assets/images/elearning page/emerging/wearable-technology.webp`,
  },

  processImages: {
    processStep1: `${ICON_BASE_URL}/assets/images/elearning page/process/consultation-and-planning.webp`,
    processStep2: `${ICON_BASE_URL}/assets/images/elearning page/process/market-research.webp`,
    processStep3: `${ICON_BASE_URL}/assets/images/elearning page/process/ux-design.webp`,
    processStep4: `${ICON_BASE_URL}/assets/images/elearning page/process/development.webp`,
    processStep5: `${ICON_BASE_URL}/assets/images/elearning page/process/testing.webp`,
    processStep6: `${ICON_BASE_URL}/assets/images/elearning page/process/deployment-and-launch.webp`,
    processStep7: `${ICON_BASE_URL}/assets/images/elearning page/process/maintenance-and-support.webp`,
  },

  elearningServicesImages: {
    elearningService1: `${ICON_BASE_URL}/assets/images/elearning page/services/education-software-consultation.svg`,
    elearningService2: `${ICON_BASE_URL}/assets/images/elearning page/services/custom-elearning-app-development.svg`,
    elearningService3: `${ICON_BASE_URL}/assets/images/elearning page/services/on-demand-elearning-apps.svg`,
    elearningService4: `${ICON_BASE_URL}/assets/images/elearning page/services/ux-design.svg`,
    elearningService5: `${ICON_BASE_URL}/assets/images/elearning page/services/elearning-app-modernization.svg`,
    elearningService6: `${ICON_BASE_URL}/assets/images/elearning page/services/smart-chatbot-development.svg`,
    elearningService7: `${ICON_BASE_URL}/assets/images/elearning page/services/elearning-api-integration.svg`,
    elearningService8: `${ICON_BASE_URL}/assets/images/elearning page/services/support-and-maintenance.svg`,
  },

  elearningSolutionsImages: {
    elearningSolution1: `${ICON_BASE_URL}/assets/images/elearning page/solutions/custom-elearning-app.webp`,
    elearningSolution2: `${ICON_BASE_URL}/assets/images/elearning page/solutions/virtual-classroom-video-conferencing-apps.webp`,
    elearningSolution3: `${ICON_BASE_URL}/assets/images/elearning page/solutions/corporate-training-apps.webp`,
    elearningSolution4: `${ICON_BASE_URL}/assets/images/elearning page/solutions/e2c-enterprise-solutions.webp`,
    elearningSolution5: `${ICON_BASE_URL}/assets/images/elearning page/solutions/skill-enhancement-apps.webp`,
    elearningSolution6: `${ICON_BASE_URL}/assets/images/elearning page/solutions/tuition-apps.webp`,
    elearningSolution7: `${ICON_BASE_URL}/assets/images/elearning page/solutions/elearning-apps-for-disabled.webp`,
    elearningSolution8: `${ICON_BASE_URL}/assets/images/elearning page/solutions/online-induction-software.webp`,
    elearningSolution9: `${ICON_BASE_URL}/assets/images/elearning page/solutions/employee-engagement-apps.webp`,
    elearningSolution10: `${ICON_BASE_URL}/assets/images/elearning page/solutions/lms-development.webp`,
    elearningSolution11: `${ICON_BASE_URL}/assets/images/elearning page/solutions/exam-and-assessment-apps.webp`,
    elearningSolution12: `${ICON_BASE_URL}/assets/images/elearning page/solutions/classroom-management-apps.webp`,
    elearningSolution13: `${ICON_BASE_URL}/assets/images/elearning page/solutions/library-management-software.webp`,
  },

  elearningWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/expertise-in-edtech-development.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/new-tech-implementation.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/seamless-third-party-integration.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/talented-team-of-it-professionals.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/improved-brand-identity.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/data-security-and-compliance.svg`,
    reason7: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/on-time-project-delivery.svg`,
    reason8: `${ICON_BASE_URL}/assets/images/elearning page/why konstant/transparent-and-confidential.svg`,
  },

  healthcareSolutions: {
    solution1: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/clinic-management-solution.webp`,
    solution2: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/doctor-appointment-mobile-app.webp`,
    solution3: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/education-healthcare-app.webp`,
    solution4: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/ehr-solution.webp`,
    solution5: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/fitness-and-wellness-app.webp`,
    solution6: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/healthcare-crm-solution.webp`,
    solution7: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/hospital-management-solution.webp`,
    solution8: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/laboratory-information-management-app.webp`,
    solution9: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/online-pharmacy-app.webp`,
    solution10: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/patient-data-management-app.webp`,
    solution11: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/remote-patient-monitoring-app.webp`,
    unitedStatesCompliance: `${ICON_BASE_URL}/assets/icons/usa-compliance.webp`,
    europeStatesCompliance: `${ICON_BASE_URL}/assets/icons/europe-uk-compliance.webp`,
    middleEastCompliance: `${ICON_BASE_URL}/assets/icons/middle-east-compliance.webp`,
    canadaCompliance: `${ICON_BASE_URL}/assets/icons/canada-compliance.webp`,
    asiaPacificCompliance: `${ICON_BASE_URL}/assets/icons/asia-pacific-compliance.webp`,
    solution12: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/smart-software-for-medical-devices.webp`,
    solution13: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/telemedicine-app-solution.webp`,
    solution14: `${ICON_BASE_URL}/assets/images/healthcare page/solutions/wearable-healthcare-app.webp`,
  },

  healthcareServices: {
    service1: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-software-consultation.svg`,
    service2: `${ICON_BASE_URL}/assets/images/healthcare page/services/custom-healthcare-app-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-ecommerce-software.svg`,
    service4: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-mobile-application.svg`,
    service5: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-web-design-and-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-app-support-and-evolution.svg`,
    service7: `${ICON_BASE_URL}/assets/images/healthcare page/services/healthcare-app-modernization.svg`,
  },

  healthcareEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/ml-integration.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/blockchain.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/iot-connected-apps.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/cloud-technology.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/ar-and-vr.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/big-data.webp`,
    emerging7: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/computer-vision.webp`,
    emerging8: `${ICON_BASE_URL}/assets/images/healthcare page/emerging/business-intelligence.webp`,
  },

  healthcareProcess: {
    process1: `${ICON_BASE_URL}/assets/images/healthcare page/process/requirement-gathering.webp`,
    process2: `${ICON_BASE_URL}/assets/images/healthcare page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/healthcare page/process/app-prototype.webp`,
    process4: `${ICON_BASE_URL}/assets/images/healthcare page/process/software-development.webp`,
    process5: `${ICON_BASE_URL}/assets/images/healthcare page/process/testing.webp`,
    process6: `${ICON_BASE_URL}/assets/images/healthcare page/process/deployment.webp`,
    process7: `${ICON_BASE_URL}/assets/images/healthcare page/process/launch.webp`,
    process8: `${ICON_BASE_URL}/assets/images/healthcare page/process/support-and-maintenance.webp`,
  },

  healthcareWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/hipaa-compliant-app.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/constructive-architecture.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/transparent-communication.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/high-quality-code-generation.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/progressive-solutions.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/healthcare page/why konstant/robust-management.svg`,
  },

  netMauiEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/Net MAUI page/emerging/internet-of-things.webp`,
    emerging2: cmsAiMl,
    emerging3: `${ICON_BASE_URL}/assets/images/Net MAUI page/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Net MAUI page/emerging/big-data.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Net MAUI page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Net MAUI page/emerging/cloud-computing.webp`,
  },

  netMauiProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/requirement-gathering.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/qa-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Net MAUI page/process/maintenance.webp`,
  },

  netMauiServices: {
    service1: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-consulting.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-ui-ux-design.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-cross-platform-app.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-android-app.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-ios-app.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/net-maui-support-and-maintenance.svg`,
    service7: `${ICON_BASE_URL}/assets/images/Net MAUI page/services/xamarin.forms-migration.svg`,
  },

  netMauiWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/one-codebase.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/incredible-ui-ux.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/native-performance.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/instant-modifications.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/azure-integration.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Net MAUI page/why .net maui/open-source.svg`,
  },

  netMauiWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/tailored-solutions.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/technical-expertise.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/rapid-prototyping.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/cross-platform-excellence.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/agile-development.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Net MAUI page/why konstant/client-centric-approach.svg`,
  },

  html5Emerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/internet-of-things.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/ai-ml.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/big-data.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/HTML5 page/emerging/cloud-computing.webp`,
  },

  html5Process: {
    process1: `${ICON_BASE_URL}/assets/images/HTML5 page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/HTML5 page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/HTML5 page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/HTML5 page/process/qa-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/HTML5 page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/HTML5 page/process/support-and-maintenance.webp`,
  },

  html5Services: {
    service1: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-app-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-game-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-web-design.svg`,
    service4: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-website-integrations.svg`,
    service5: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-website-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/HTML5 page/services/html5-migration-services.svg`,
  },

  html5WhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/seo-friendly.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/user-experience.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/offline-browsing.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/improved-accessibility.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/consistent-development.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/HTML5 page/why html5/high-performance.svg`,
  },

  html5WhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/customization.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/timely-delivery.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/collaborative-approach.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/expert-developers.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/outcome-focused.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/HTML5 page/why konstant/strong-online-presence.svg`,
  },

  fullstackEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/Full Stack page/emerging/iot.webp`,
    emerging2: cmsAiMl,
    emerging3: `${ICON_BASE_URL}/assets/images/Full Stack page/emerging/ar-vr.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Full Stack page/emerging/big-data.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Full Stack page/emerging/blockchain.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Full Stack page/emerging/cloud-computing.webp`,
  },

  fullstackProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Full Stack page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Full Stack page/process/ux-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Full Stack page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Full Stack page/process/testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Full Stack page/process/deployment.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Full Stack page/process/monitoring-and-support.webp`,
  },

  fullstackServices: {
    service1: `${ICON_BASE_URL}/assets/images/Full Stack page/services/mean-stack-consulting.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Full Stack page/services/full-stack-web-hosting.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Full Stack page/services/mean-stack-development.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Full Stack page/services/mern-stack-development.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Full Stack page/services/lamp-stack-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Full Stack page/services/mevn-stack-development.svg`,
  },

  fullstackWhyApp: {
    reason1: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/faster-development.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/cost-effective.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/seamless-user-experience.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/scalability.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/simplified-maintenance.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Full Stack page/why full-stack/greater-flexibility.svg`,
  },

  fullstackWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/post-launch-support.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/agile-approach.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/long-term-relationships.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/timely-project-delivery.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/versatility.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Full Stack page/why konstant/transparent-billing.svg`,
  },

  appPrototypeEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/5g-ready-features.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/iot.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/edge-computing.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/Blockchain.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/ai-ml.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/App prototype page/emerging/ar-vr.webp`,
  },

  appPrototypeProcess: {
    process1: `${ICON_BASE_URL}/assets/images/App prototype page/process/discovery.webp`,
    process2: `${ICON_BASE_URL}/assets/images/App prototype page/process/visual-design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/App prototype page/process/clickable-prototype.webp`,
    process4: `${ICON_BASE_URL}/assets/images/App prototype page/process/usability-testing.webp`,
    process5: `${ICON_BASE_URL}/assets/images/App prototype page/process/iterate-polish.webp`,
    process6: `${ICON_BASE_URL}/assets/images/App prototype page/process/developer-handover.webp`,
  },

  appPrototypeIndustries: {
    industry1: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/real-estate.svg`,
    industry2: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/on-demand-services.svg`,
    industry3: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/social-networking.svg`,
    industry4: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/food-and-restaurant.svg`,
    industry5: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/banking-and-finance.svg`,
    industry6: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/education.svg`,
    industry7: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/hospitality-and-travel.svg`,
    industry8: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/media-and-entertainment.svg`,
    industry9: `${ICON_BASE_URL}/assets/images/App prototype page/industries we serve/fitness-and-healthcare.svg`,
  },

  appPrototypeServices: {
    service1: `${ICON_BASE_URL}/assets/images/App prototype page/services/ios-app-prototype.svg`,
    service2: `${ICON_BASE_URL}/assets/images/App prototype page/services/web-app-prototyping.svg`,
    service3: `${ICON_BASE_URL}/assets/images/App prototype page/services/mockup-design-services.svg`,
    service4: `${ICON_BASE_URL}/assets/images/App prototype page/services/android-app-prototype.svg`,
    service5: `${ICON_BASE_URL}/assets/images/App prototype page/services/ecommerce-app-prototype.svg`,
  },

  appPrototypeWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/custom-solutions.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/cost-effective-development.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/end-to-end-service.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/expert-designers.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/efficient-process.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/App prototype page/why konstant/seamless-collaboration.svg`,
  },

  appPrototypeBenefits: {
    benefit1: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/improved-user-experience.svg`,
    benefit2: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/better-communication.svg`,
    benefit3: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/accurate-requirements.svg`,
    benefit4: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/early-validation.svg`,
    benefit5: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/faster-iterations.svg`,
    benefit6: `${ICON_BASE_URL}/assets/images/App prototype page/benefits/cost-effective.svg`,
  },

  realEstateEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/ar-in-real-estate.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/blockchain-in-real-estate.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/data-analytics-in-real-estate.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/iot-in-real-estate.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/metaverse-in-real-estate.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Real estate page/emerging/ml-and-ai-in-real-estate.webp`,
  },

  realEstateProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Real estate page/process/deployment.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Real estate page/process/development.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Real estate page/process/maintenance-support.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Real estate page/process/requirement-gathering.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Real estate page/process/testing.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Real estate page/process/ui-ux-design.webp`,
  },

  realEstateServices: {
    service1: `${ICON_BASE_URL}/assets/images/Real estate page/services/consulting-services.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Real estate page/services/enterprise-software-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Real estate page/services/quality-assurance-and-engineering.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Real estate page/services/real-estate-mobile-app-development.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Real estate page/services/real-estate-website-development.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Real estate page/services/ui-ux-design.svg`,
  },

  realEstateSolutions: {
    solution1: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/home-auction-app.webp`,
    solution2: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/lead-management-app.webp`,
    solution3: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/online-booking-app.webp`,
    solution4: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/property-management-app.webp`,
    solution5: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/real-estate-investment-app.webp`,
    solution6: `${ICON_BASE_URL}/assets/images/Real estate page/solutions/rental-property-management-app.webp`,
  },

  realEstateWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/app-compliance-and-security.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/budget-friendly-services.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/dedicated-experts.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/extended-portfolio.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/on-time-delivery.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Real estate page/why konstant/personalized-solutions.svg`,
  },

  fintechEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/ai-ml.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/ar-vr.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/blockchain.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/cloud-computing.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/data-analytics.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Fintech page/emerging/iot.webp`,
  },

  fintechProcess: {
    process1: `${ICON_BASE_URL}/assets/images/Fintech page/process/deployment.webp`,
    process2: `${ICON_BASE_URL}/assets/images/Fintech page/process/design.webp`,
    process3: `${ICON_BASE_URL}/assets/images/Fintech page/process/development.webp`,
    process4: `${ICON_BASE_URL}/assets/images/Fintech page/process/discovery.webp`,
    process5: `${ICON_BASE_URL}/assets/images/Fintech page/process/qa-and-testing.webp`,
    process6: `${ICON_BASE_URL}/assets/images/Fintech page/process/support-maintenance.webp`,
  },

  fintechServices: {
    service1: `${ICON_BASE_URL}/assets/images/Fintech page/services/android-fintech-app-development.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Fintech page/services/custom-fintech-app-development.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Fintech page/services/fintech-app-maintenance.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Fintech page/services/fintech-app-testing.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Fintech page/services/fintech-consulting.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Fintech page/services/ios-fintech-app-development.svg`,
  },

  fintechSolutions: {
    solution1: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/buy-now-pay-later-solutions.webp`,
    solution2: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/credit-scoring-solutions.webp`,
    solution3: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/crowdfunding-platform-development.webp`,
    solution4: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/defi-app-development.webp`,
    solution5: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/insurance-tech-applications.webp`,
    solution6: `${ICON_BASE_URL}/assets/images/Fintech page/solutions/loan-against-asset-platform.webp`,
  },

  fintechWhyKonstant: {
    reason1: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/decentralized-solutions.svg`,
    reason2: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/maximum-scalability.svg`,
    reason3: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/optimum-accuracy.svg`,
    reason4: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/regulatory-compliance.svg`,
    reason5: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/robust-security.svg`,
    reason6: `${ICON_BASE_URL}/assets/images/Fintech page/why konstant/user-focused-design.svg`,
  },

  classifiedEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/Classified page/emerging/ai-and-ml.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/Classified page/emerging/ar-vr.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/Classified page/emerging/blockchain.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/Classified page/emerging/cloud-computing.webp`,
    emerging5: `${ICON_BASE_URL}/assets/images/Classified page/emerging/iot.webp`,
    emerging6: `${ICON_BASE_URL}/assets/images/Classified page/emerging/nlp.webp`,
  },

  classifiedBenefits: {
    noTimeConstraints: `${ICON_BASE_URL}/assets/images/Classified page/benefits/no-time-constraints.svg`,
    enhancedMobility: `${ICON_BASE_URL}/assets/images/Classified page/benefits/enhanced-mobility.svg`,
    reducedCosts: `${ICON_BASE_URL}/assets/images/Classified page/benefits/reduced-costs.svg`,
    easyAdPosting: `${ICON_BASE_URL}/assets/images/Classified page/benefits/easy-ad-posting.svg`,
    communityBuilding: `${ICON_BASE_URL}/assets/images/Classified page/benefits/community-building.svg`,
    revenueGeneration: `${ICON_BASE_URL}/assets/images/Classified page/benefits/revenue-generation.svg`,
  },

  classifiedSolutions: {
    service1: `${ICON_BASE_URL}/assets/images/Classified page/solutions/gig-based-classified-app.svg`,
    service2: `${ICON_BASE_URL}/assets/images/Classified page/solutions/global-classifieds-apps.svg`,
    service3: `${ICON_BASE_URL}/assets/images/Classified page/solutions/local-classified-apps.svg`,
    service4: `${ICON_BASE_URL}/assets/images/Classified page/solutions/marketplace-apps.svg`,
    service5: `${ICON_BASE_URL}/assets/images/Classified page/solutions/on-demand-classified-apps.svg`,
    service6: `${ICON_BASE_URL}/assets/images/Classified page/solutions/service-based-classified-app.svg`,
  },

  classifiedWhyKonstant: {
    resultsDrivenDelivery: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/results-driven-approach.svg`,
    latestTechIntegration: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/latest-tech-integration.svg`,
    userCentricDesign: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/user-centric-design.svg`,
    timelyDelivery: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/timely-delivery.svg`,
    transparentCommunication: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/transparent-communication.svg`,
    customizedSolutions: `${ICON_BASE_URL}/assets/images/Classified page/why konstant/customized-solutions.svg`,
  },

  chatEmerging: {
    emerging1: `${ICON_BASE_URL}/assets/images/chat_app/emerging/generative-ai-nlp.webp`,
    emerging2: `${ICON_BASE_URL}/assets/images/chat_app/emerging/headless-cms.webp`,
    emerging3: `${ICON_BASE_URL}/assets/images/chat_app/emerging/progressive-web-apps.webp`,
    emerging4: `${ICON_BASE_URL}/assets/images/chat_app/emerging/websockets.webp`,
  },

  chatBenefits: {
    broaderClientele: `${ICON_BASE_URL}/assets/images/chat_app/benefit/broader-clientele.svg`,
    improvedUserExperience: `${ICON_BASE_URL}/assets/images/chat_app/benefit/improved-user-experience.svg`,
    optimumResourceUtilization: `${ICON_BASE_URL}/assets/images/chat_app/benefit/spam-but-make-it-chic.svg`,
    spamButMakeItChic: `${ICON_BASE_URL}/assets/images/chat_app/benefit/optimum-resource-utilization.svg`,
  },

  chatSolutions: {
    service1: `${ICON_BASE_URL}/assets/images/chat_app/solutions/chat-management-apps.svg`,
    service2: `${ICON_BASE_URL}/assets/images/chat_app/solutions/custom-user-search-apps.svg`,
    service3: `${ICON_BASE_URL}/assets/images/chat_app/solutions/digital-wellbeing-solutions.svg`,
    service4: `${ICON_BASE_URL}/assets/images/chat_app/solutions/multi-user-chat-apps.svg`,
  },

  chatWhyKonstant: {
    encryptionYouBet: `${ICON_BASE_URL}/assets/images/chat_app/why konstant/encryption-you-bet.svg`,
    noTrespassing: `${ICON_BASE_URL}/assets/images/chat_app/why konstant/no-trespassing.svg`,
    safeguardingYourBusiness: `${ICON_BASE_URL}/assets/images/chat_app/why konstant/safeguarding-your-business.svg`,
  },

  chatMessagingSolutionImages: {
    customer: {
      customerRealTimeMessaging: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/real-time-messaging.webp`,
      customerMultimediaSharing: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/multimedia-sharing.webp`,
      customerUserProfileManagement: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/user-profile-management.webp`,
      customerSearchFunctionality: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/search-functionality.webp`,
      customerAuthentication: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/authentication.webp`,
      customerPushNotification: `${ICON_BASE_URL}/assets/images/chat_app/feature/customer/push-notification.webp`,
    },
    admin: {
      dashboardAndAnalytics: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/dashboard-analytics.webp`,
      userManagement: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/user-management.webp`,
      contentModeration: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/content-moderation.webp`,
      conversationMonitoring: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/conversation-monitoring.webp`,
      systemConfiguration: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/system-configuration.webp`,
      dataExportBackup: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/data-export-backup.webp`,
      roleBasedAccessControl: `${ICON_BASE_URL}/assets/images/chat_app/feature/admin/role-based-access-control.webp`,
    },
  },

  directoryEmerging: directoryAssets.directory.emerging,
  directoryBenefits: directoryAssets.directory.benefits,
  directorySolutions: directoryAssets.directory.solutions,
  directoryWhyKonstant: directoryAssets.directory.whyKonstant,

  telemedicineBenefits: telemedicineAssets.telemedicine.benefits,
  telemedicineEmerging: telemedicineAssets.telemedicine.emerging,
  telemedicineSolutions: telemedicineAssets.telemedicine.solutions,
  telemedicineWhyKonstant: telemedicineAssets.telemedicine.whyKonstant,

  datingEmerging: datingAssets.dating.emerging,
  datingBenefits: datingAssets.dating.benefits,
  datingSolutions: datingAssets.dating.solutions,
  datingWhyKonstant: datingAssets.dating.whyKonstant,

  blog: marketingAssets.blog,
  wordpress1: `${ICON_BASE_URL}/assets/images/wordpress-1.webp`,
  wordpress: `${ICON_BASE_URL}/assets/images/wordpress.webp`,
  php: `${ICON_BASE_URL}/assets/images/php.webp`,
  node: `${ICON_BASE_URL}/assets/images/node.webp`,
  androidAlt: `${ICON_BASE_URL}/assets/images/andriod.webp`,
  androidAlt1: `${ICON_BASE_URL}/assets/images/andriod-1.webp`,
  laravel: `${ICON_BASE_URL}/assets/images/laravel.webp`,
  ios: `${ICON_BASE_URL}/assets/images/ios.webp`,
  react: `${ICON_BASE_URL}/assets/images/react.webp`,
  reactNative: `${ICON_BASE_URL}/assets/images/react-native.webp`,
  vue: `${ICON_BASE_URL}/assets/images/vue.webp`,
  angular: `${ICON_BASE_URL}/assets/images/angular.webp`,
  python: `${ICON_BASE_URL}/assets/images/python.webp`,
  django: `${ICON_BASE_URL}/assets/images/django.webp`,
  drupal: `${ICON_BASE_URL}/assets/images/drupal.webp`,
  magento: `${ICON_BASE_URL}/assets/images/magento.webp`,
  cakephp: `${ICON_BASE_URL}/assets/images/cakephp.webp`,
  codelgniter: `${ICON_BASE_URL}/assets/images/Codelgniter.webp`,
  ionic: `${ICON_BASE_URL}/assets/images/ionic.webp`,
  hybrid: `${ICON_BASE_URL}/assets/images/Hybrid.webp`,
  progressive: `${ICON_BASE_URL}/assets/images/progressive.webp`,
  three: `${ICON_BASE_URL}/assets/images/three.webp`,
  flutter: `${ICON_BASE_URL}/assets/images/Flutter.webp`,
  hero: `${ICON_BASE_URL}/assets/images/Hero.webp`,
  aboutCompany: `${ICON_BASE_URL}/assets/images/aboutcompany.webp`,
  blobPlaceholder: `${ICON_BASE_URL}/assets/images/blob-placeholder.webp`,
  industryPageBg: `${ICON_BASE_URL}/assets/images/industry-page-bg.webp`,
  service: `${ICON_BASE_URL}/assets/images/service.webp`,
  service1: `${ICON_BASE_URL}/assets/images/service-1.webp`,
  service2: `${ICON_BASE_URL}/assets/images/service landing page/ai-ml-development-services.webp`,
  service3: `${ICON_BASE_URL}/assets/images/service landing page/web-development-services.webp`,
  service4: `${ICON_BASE_URL}/assets/images/service landing page/cloud-services-services.webp`,
  service5: `${ICON_BASE_URL}/assets/images/service landing page/hire-dedicated-developes-services.webp`,
  service6: `${ICON_BASE_URL}/assets/images/service landing page/it-consulting-services.webp`,
  foodBanner: `${ICON_BASE_URL}/assets/images/food-banner.webp`,
  indusrySolution: `${ICON_BASE_URL}/assets/images/indusry-solution.webp`,
  industryDetailsBanner: `${ICON_BASE_URL}/assets/images/industry-details-banner.webp`,
  partner1: `${ICON_BASE_URL}/assets/images/partner-1.webp`,
  partner2: `${ICON_BASE_URL}/assets/images/partner-2.webp`,
  partner3: `${ICON_BASE_URL}/assets/images/partner-3.webp`,
  partner4: `${ICON_BASE_URL}/assets/images/partner-4.webp`,
  partner5: `${ICON_BASE_URL}/assets/images/partner-5.webp`,
  partner6: `${ICON_BASE_URL}/assets/images/partner-6.webp`,
  partner7: `${ICON_BASE_URL}/assets/images/partner-7.webp`,
  partner8: `${ICON_BASE_URL}/assets/images/partner-8.webp`,
  partner9: `${ICON_BASE_URL}/assets/images/partner-9.webp`,
  fistBump: `${ICON_BASE_URL}/assets/images/partners/fist-bump.gif`,

  award1: `${ICON_BASE_URL}/assets/images/award1.webp`,
  award2: `${ICON_BASE_URL}/assets/images/award2.webp`,
  award3: `${ICON_BASE_URL}/assets/images/award3.webp`,
  award4: `${ICON_BASE_URL}/assets/images/award4.webp`,
  award5: `${ICON_BASE_URL}/assets/images/award5.webp`,
  award6: `${ICON_BASE_URL}/assets/images/award6.webp`,

  awardImage1: `${ICON_BASE_URL}/assets/images/awards/clutch-winner-fall-2025.webp`,
  awardImageNew1: `${ICON_BASE_URL}/assets/icons/clutch-global-winner-2026.svg`,
  awardImageNew4: `${ICON_BASE_URL}/assets/icons/software-world-2026.webp`,
  awardImage2: `${ICON_BASE_URL}/assets/images/awards/clutch-champion-fall-2025.webp`,
  awardImage3: `${ICON_BASE_URL}/assets/images/awards/clutch-winner-spring-2025.webp`,
  awardImage4: `${ICON_BASE_URL}/assets/images/awards/softwareworldai.webp`,
  awardImage5: `${ICON_BASE_URL}/assets/images/awards/top-app-developers-itfirms-badge-2025.webp`,
  awardImage6: `${ICON_BASE_URL}/assets/images/awards/techbehemoths-award.webp`,
  awardImage7: `${ICON_BASE_URL}/assets/images/awards/businessofapps.webp`,
  awardImage8: `${ICON_BASE_URL}/assets/images/awards/upfirms.webp`,
  awardImage9: `${ICON_BASE_URL}/assets/images/awards/themanifest.webp`,
  awardImage10: `${ICON_BASE_URL}/assets/images/awards/goodfirms.webp`,
  awardImage11: `${ICON_BASE_URL}/assets/images/awards/extract.webp`,
  awardImage12: `${ICON_BASE_URL}/assets/images/awards/topdevelopers.webp`,
  awardImageNew12: `${ICON_BASE_URL}/assets/icons/top-developers-2026.webp`,
  awardImageNew15: `${ICON_BASE_URL}/assets/icons/mobile-apps-daily-2026.avif`,
  awardImageNew7: `${ICON_BASE_URL}/assets/icons/business-of-apps-2026.svg`,
  awardImageNew10: `${ICON_BASE_URL}/assets/icons/good-firms-2026.svg`,
  awardImageNew23: `${ICON_BASE_URL}/assets/icons/crowd-reviews.webp`,
  awardImageNew17: `${ICON_BASE_URL}/assets/icons/tech-reviewer-2026.webp`,
  awardImageNew21: `${ICON_BASE_URL}/assets/icons/up-votes-2026.webp`,
  awardImage13: `${ICON_BASE_URL}/assets/images/awards/tabbyawards-2018.webp`,
  awardImage14: `${ICON_BASE_URL}/assets/images/awards/softwareworldapp.webp`,
  awardImage15: `${ICON_BASE_URL}/assets/images/awards/mobileappdaily.webp`,
  awardImage16: `${ICON_BASE_URL}/assets/images/awards/g2.webp`,
  awardImage17: `${ICON_BASE_URL}/assets/images/awards/techreviewer.webp`,
  awardImage18: `${ICON_BASE_URL}/assets/images/awards/siliconindia.webp`,
  awardImage19: `${ICON_BASE_URL}/assets/images/awards/designrush-web.webp`,
  awardImage20: `${ICON_BASE_URL}/assets/images/awards/selectedfirms-web.webp`,
  awardImage21: `${ICON_BASE_URL}/assets/images/awards/upvoted-app.webp`,
  awardImage22: `${ICON_BASE_URL}/assets/images/awards/serchen.webp`,
  awardImage23: `${ICON_BASE_URL}/assets/images/awards/top-mobile-app-development-company.webp`,
  awardImage24: award24,
  threejsEmerging: threejsAssets.threejs.emerging,
  threejsProcess: threejsAssets.threejs.process,
  threejsServices: threejsAssets.threejs.services,
  threejsWhatMakes: threejsAssets.threejs.whatMakes,
  threejsWhyUse: threejsAssets.threejs.whyUse,

  nodeEmerging: nodeAssets.node.emerging,
  nodeProcess: nodeAssets.node.process,
  nodeServices: nodeAssets.node.services,

  whyChooseKonstant: nodeAssets.node.whyChooseKonstant,
  whyNodejs: nodeAssets.node.whyNodejs,
  emergingTechnologies: pythonAssets.python.emerging,

  pythonProcess: pythonAssets.python.process,
  pythonServices: pythonAssets.python.services,
  pythonWhyKonstant: pythonAssets.python.whyKonstant,
  pythonWhy: pythonAssets.python.whyPython,
  codigniterEmerging: codeigniterAssets.codeigniter.emerging,
  codigniterProcess: codeigniterAssets.codeigniter.process,
  codigniterServices: codeigniterAssets.codeigniter.services,
  codigniterWhyKonstantProcess: codeigniterAssets.codeigniter.whyProcess,
  codigniterWhyKonstant: codeigniterAssets.codeigniter.whyKonstant,
  cakephpEmerging: cakephpAssets.cakephp.emerging,
  cakephpProcess: cakephpAssets.cakephp.process,
  cakephpServices: cakephpAssets.cakephp.services,
  cakephpWhyBenefits: cakephpAssets.cakephp.whyBenefits,
  cakephpWhyKonstant: cakephpAssets.cakephp.whyKonstant,
  swiftEmerging: swiftAssets.swift.emerging,
  swiftProcess: swiftAssets.swift.process,
  swiftServices: swiftAssets.swift.services,
  swiftWhySwift: swiftAssets.swift.whyApp,
  swiftWhyKonstant: swiftAssets.swift.whyKonstant,
  djangoEmerging: djangoAssets.django.emerging,
  djangoProcess: djangoAssets.django.process,
  djangoServices: djangoAssets.django.services,
  djangoWhyBenefits: djangoAssets.django.whyBenefits,
  djangoWhyKonstant: djangoAssets.django.whyKonstant,

  onDemandEmerging: onDemandAssets.onDemand.emerging,
  onDemandProcess: onDemandAssets.onDemand.process,
  onDemandServices: onDemandAssets.onDemand.services,
  onDemandSolution: onDemandAssets.onDemand.solution,
  onDemandWhyKonstant: onDemandAssets.onDemand.whyKonstant,
  travelEmerging: industryAssets.travel.emerging,
  travelProcess: industryAssets.travel.process,
  travelServices: industryAssets.travel.services,
  travelSolutions: industryAssets.travel.solutions,
  travelWhyKonstant: industryAssets.travel.whyKonstant,
  meanEmerging: stackAssets.mean.emerging,
  meanProcess: stackAssets.mean.process,
  meanServices: stackAssets.mean.services,
  meanWhyMean: stackAssets.mean.whyApp,
  meanWhyKonstant: stackAssets.mean.whyKonstant,
  mernEmerging: stackAssets.mern.emerging || {},
  mernProcess: stackAssets.mern.process,
  mernServices: stackAssets.mern.services,
  mernWhatMakes: stackAssets.mern.whatMakes,
  mernWhyUse: stackAssets.mern.whyUse,

  reactjsEmerging: frameworkAssets.react.emerging,
  reactjsProcess: frameworkAssets.react.process,
  reactjsServices: frameworkAssets.react.services,
  reactjsWhyApp: frameworkAssets.react.whyApp,
  reactjsWhyKonstant: frameworkAssets.react.whyKonstant,

  vuePng: frameworkAssets.vue.bg,
  vueEmerging: frameworkAssets.vue.emerging,
  vueProcess: frameworkAssets.vue.process,
  vueServices: frameworkAssets.vue.services,
  vueWhyVue: frameworkAssets.vue.whyApp,
  vueWhyKonstant: frameworkAssets.vue.whyKonstant,
  magentoEmerging: ecommerceAssets.magento.emerging,
  magentoProcess: ecommerceAssets.magento.process,
  magentoServices: ecommerceAssets.magento.services,
  magentoWhyMagento: ecommerceAssets.magento.whyApp,
  magentoWhyKonstant: ecommerceAssets.magento.whyKonstant,

  shopifyEmerging: ecommerceAssets.shopify.emerging,
  shopifyProcess: ecommerceAssets.shopify.process,
  shopifyServices: ecommerceAssets.shopify.services,
  shopifyWhyShopify: ecommerceAssets.shopify.whyApp,
  shopifyWhyKonstant: ecommerceAssets.shopify.whyKonstant,
  woocommerceEmerging: cmsAssets.woocommerce.emerging,
  woocommerceProcess: cmsAssets.woocommerce.process,
  woocommerceServices: cmsAssets.woocommerce.services,
  woocommerceWhyKonstant: cmsAssets.woocommerce.whyKonstant,
  woocommerceWhyWoo: cmsAssets.woocommerce.whyWoo,

  wordpressEmerging: cmsAssets.wordpress.emerging,
  wordpressProcess: cmsAssets.wordpress.process,
  wordpressServices: cmsAssets.wordpress.services,
  wordpressWhyKonstant: cmsAssets.wordpress.whyKonstant,
  wordpressWhyWordpress: cmsAssets.wordpress.whyWordpress,

  joomlaEmerging: cmsAssets.joomla.emerging,
  joomlaProcess: cmsAssets.joomla.process,
  joomlaServices: cmsAssets.joomla.services,
  joomlaWhyJoomla: cmsAssets.joomla.whyJoomla,
  joomlaWhyKonstant: cmsAssets.joomla.whyKonstant,

  transportationEmerging: industryAssets.transportation.emerging,
  transportationProcess: industryAssets.transportation.process,
  transportationServices: industryAssets.transportation.services,
  transportationSolutions: industryAssets.transportation.solutions,
  transportationWhyKonstant: industryAssets.transportation.whyKonstant,

  partners: contactPartnersAssets.partners,
  blogDetails: marketingAssets.blogDetails,

  awards: marketingAssets.awards,

  jobDetails: careerAssets.jobDetails,

  approachSteps: partnershipAssets.approachSteps,

  becomePartner: partnershipAssets.becomePartner,
};
